// ═══════════════════════════════════════════════════════════════════════
//  FinancialMind.ai — i18n Module (Internationalization)
//  Idiomas: pt-BR, en-US, es-MX, zh-CN
//  Uso: import { t, setLocale, getLocale } from './i18n/i18n.js'
// ═══════════════════════════════════════════════════════════════════════

const SUPPORTED_LOCALES = ["pt-BR", "en-US", "es-MX", "zh-CN"];
const DEFAULT_LOCALE = "en-US";

let currentLocale = DEFAULT_LOCALE;

// ─── Dicionários de tradução ─────────────────────────────────────────
const dictionaries = {

  // ════════════════════════════════════════════════════════════════════
  //  PORTUGUÊS (BRASIL)
  // ════════════════════════════════════════════════════════════════════
  "pt-BR": {
    // ── Navegação & Layout ──
    "nav.home": "Início",
    "nav.products": "Produtos",
    "nav.pricing": "Preços",
    "nav.about": "Sobre",
    "nav.contact": "Contato",
    "nav.login": "Entrar",
    "nav.signup": "Cadastre-se",
    "nav.start_free": "Começar Grátis",
    "nav.logout": "Sair",
    "nav.dashboard": "Painel",
    "nav.settings": "Configurações",
    "nav.language": "Idioma",

    // ── Autenticação ──
    "auth.login": "Entrar",
    "auth.register": "Criar Conta",
    "auth.email": "E-mail",
    "auth.password": "Senha",
    "auth.confirm_password": "Confirmar Senha",
    "auth.forgot_password": "Esqueceu a senha?",
    "auth.name": "Nome Completo",
    "auth.company": "Empresa",
    "auth.title": "Cargo",
    "auth.company_id": "CNPJ",
    "auth.personal_id": "CPF",
    "auth.legal_name": "Razão Social",
    "auth.trade_name": "Nome Fantasia",
    "auth.fill_all_fields": "Preencha todos os campos.",
    "auth.invalid_company_id": "CNPJ inválido.",
    "auth.invalid_personal_id": "CPF inválido.",
    "auth.registration_success": "Conta criada com sucesso! Verifique seu e-mail.",
    "auth.login_error": "E-mail ou senha incorretos.",
    "auth.access_portal": "Portal de Acesso",
    "auth.identify": "Identifique-se",
    "auth.select_profile": "Selecione seu perfil para acessar a plataforma",
    "auth.left_tag": "Plataforma B2B de Crédito",
    "auth.left_h1": "Análise de crédito",
    "auth.left_h2": "estruturada e auditável",
    "auth.left_h3": "para o seu negócio.",
    "auth.left_desc": "Motor quantitativo próprio, IA generativa Anthropic Claude e conformidade LGPD em uma plataforma unificada.",
    "auth.feat1_title": "Algoritmo Proprietário",
    "auth.feat1_desc": "Motor de scoring desenvolvido internamente — metodologia exclusiva, não replicável por concorrentes.",
    "auth.feat2_title": "IA Generativa Anthropic",
    "auth.feat2_desc": "Claude analisa narrativas, relatórios de auditores e fatores qualitativos com raciocínio financeiro.",
    "auth.feat3_title": "Rigor Quantitativo",
    "auth.feat3_desc": "Fundamentado em Altman, Merton-KMV, Basel II/III e calibração ao mercado brasileiro.",
    "auth.card_analyst_title": "Analista / Equipe Interna",
    "auth.card_analyst_desc": "Tesouraria, CFO, Diretoria, Comercial e Aprovadores. Acesso ao painel completo de análise de crédito.",
    "auth.tag_new_analysis": "Nova Análise",
    "auth.tag_portfolio": "Portfólio",
    "auth.tag_reports": "Relatórios",
    "auth.card_client_title": "Empresa Solicitante de Crédito",
    "auth.card_client_desc": "Acesso via convite da empresa parceira. Submeta seus dados e documentos para análise de crédito comercial.",
    "auth.invite_only": "Acesso exclusivo por convite",

    // ── RiskMind ──
    "risk.title": "RiskMind — Análise de Risco de Crédito",
    "risk.subtitle": "Plataforma de risco de crédito B2B com IA",
    "risk.new_application": "Nova Solicitação",
    "risk.applications": "Solicitações",
    "risk.credit_analysis": "Análise de Crédito",
    "risk.risk_score": "Score de Risco",
    "risk.credit_limit": "Limite de Crédito",
    "risk.approval_status": "Status de Aprovação",
    "risk.approved": "Aprovado",
    "risk.denied": "Negado",
    "risk.pending": "Pendente",
    "risk.in_review": "Em Análise",
    "risk.financial_docs": "Documentos Financeiros",
    "risk.upload_docs": "Enviar Documentos",
    "risk.balance_sheet": "Balanço Patrimonial",
    "risk.income_statement": "DRE (Demonstração do Resultado)",
    "risk.cash_flow": "Fluxo de Caixa",
    "risk.equity_statement": "DMPL",

    // ── MIA (IA Assistente) ──
    "mia.title": "MIA — Assistente de Inteligência Financeira",
    "mia.greeting": "Olá! Sou a MIA, sua assistente de análise financeira.",
    "mia.placeholder": "Pergunte sobre análise de crédito, risco, mercado...",
    "mia.analyzing": "Analisando...",

    // ── Planos & Preços ──
    "plan.free": "Gratuito",
    "plan.essential": "Essencial",
    "plan.professional": "Profissional",
    "plan.enterprise": "Enterprise",
    "plan.companies": "empresas",
    "plan.users": "usuários",
    "plan.per_month": "/mês",
    "plan.start_free": "Começar Grátis",
    "plan.subscribe": "Assinar",
    "plan.contact_sales": "Falar com Vendas",

    // ── Compliance & Legal ──
    "legal.terms": "Termos de Uso",
    "legal.privacy": "Política de Privacidade",
    "legal.data_protection": "LGPD",
    "legal.contract": "Contrato",
    "legal.accept_terms": "Li e aceito o Contrato + LGPD",
    "legal.cookie_consent": "Este site utiliza cookies para melhorar sua experiência.",

    // ── Dashboard ──
    "dash.overview": "Visão Geral",
    "dash.total_applications": "Total de Solicitações",
    "dash.approved_volume": "Volume Aprovado",
    "dash.avg_score": "Score Médio",
    "dash.pending_review": "Aguardando Análise",
    "dash.recent_activity": "Atividade Recente",

    // ── Roles ──
    "role.client": "Cliente",
    "role.analyst": "Analista de Crédito",
    "role.approver": "Aprovador de Crédito",
    "role.commercial": "Comercial (CS)",
    "role.treasury": "Tesouraria",
    "role.manager": "Gerente Comercial",
    "role.director": "Diretor de Negócios",
    "role.cfo": "CFO",
    "role.admin": "Admin Sistema",

    // ── Genérico ──
    "common.save": "Salvar",
    "common.cancel": "Cancelar",
    "common.edit": "Editar",
    "common.delete": "Excluir",
    "common.search": "Buscar",
    "common.filter": "Filtrar",
    "common.export": "Exportar",
    "common.loading": "Carregando...",
    "common.error": "Erro",
    "common.success": "Sucesso",
    "common.confirm": "Confirmar",
    "common.back": "Voltar",
    "common.next": "Próximo",
    "common.yes": "Sim",
    "common.no": "Não",
    "common.or": "ou",
    "common.required": "Obrigatório",
    "common.optional": "Opcional",

    // ── Footer ──
    "footer.powered_by": "Powered by Anthropic Claude · AWS",
    "footer.compliance": "LGPD Compliant",
    "footer.copyright": "© {year} Keymind Tecnologia em Gestão Ltda",

    // ── Landing Page ──
    "land.tag": "Plataforma de Risco de Crédito B2B",
    "land.headline1": "Análise de crédito",
    "land.headline_gold": "tão precisa",
    "land.headline2": "quanto os seus",
    "land.headline3": "melhores analistas.",
    "land.description": "Motor quantitativo com Basel II, Z-Score de Altman, KMV-Merton e Kanitz — com algoritmo proprietário RiskMind e modelos exclusivos, interpretados pela IA Generativa Claude. Modelo de aprendizado contínuo com a inteligência Mia.",
    "land.cta_free": "Começar grátis — sem cartão",
    "land.cta_login": "Já tenho conta →",
    "land.trial_info": "Teste gratuito · 15 dias · 2 CNPJs · sem cartão",
    "land.pill_basel": "Motor Basel II ativo",
    "land.pill_ifrs": "IFRS 16 · KMV-Merton",
    "land.pill_zscore": "Z-Score · Kanitz · Altman",
    "land.how_title": "Como Funciona",
    "land.how_subtitle": "Da entrada de dados ao relatório em 4 etapas.",
    "land.pricing_title": "Planos",
    "land.pricing_subtitle": "Escolha o plano ideal para sua operação.",
    "land.faq_title": "Perguntas Frequentes",
    "land.footer_cta": "Comece agora a análise de crédito mais inteligente do Brasil.",
    "land.nav_how": "Como funciona",
    "land.nav_plans": "Planos",

    // ── How It Works (steps) ──
    "land.how_tag": "Como Funciona",
    "land.how_head1": "Do CNPJ ao parecer em ",
    "land.how_head_gold": "3 passos",
    "land.how_sub2": "Sem planilhas. Sem cálculos manuais. Sem horas de trabalho.",
    "land.how_s1_title": "Cadastre a empresa",
    "land.how_s1_desc": "Informe o CNPJ e os dados financeiros da contraparte. Você pode importar DREs e Balanços em PDF — a IA extrai os campos automaticamente.",
    "land.how_s2_title": "Motor quantitativo roda",
    "land.how_s2_desc": "Basel II, Z-Score de Altman, KMV-Merton, Kanitz e análise de Damodaran são executados simultaneamente. PD, LGD, rating e limite de crédito calculados em segundos.",
    "land.how_s3_title": "Parecer inteligente pronto",
    "land.how_s3_desc": "A MIA (nossa analista de IA) interpreta os resultados, aponta riscos, explica os modelos e sugere limite de crédito com fundamentação técnica completa.",

    // ── Pricing Section ──
    "land.price_tag": "Planos & Preços",
    "land.price_head1": "Escolha o plano certo para ",
    "land.price_head_gold": "sua operação",
    "land.price_sub": "Comece grátis. Upgrade quando precisar. Cancele quando quiser.",
    "land.price_monthly": "Mensal",
    "land.price_annual": "Anual",
    "land.price_per_month": "/mês",
    "land.price_billed_annual": "Cobrado anualmente",
    "land.price_free_period": "por 15 dias · sem cartão",
    "land.price_custom": "Sob consulta",
    "land.price_note": "Todos os preços em BRL · CNPJ obrigatório para emissão de NF-e · Sujeito a reajuste anual pelo IPCA",
    "land.price_currency": "R$",

    // Plan names/desc/CTA
    "land.plan_free_name": "Teste Gratuito",
    "land.plan_free_tag": "15 dias",
    "land.plan_free_desc": "Teste gratuito por 15 dias. Motor completo sem cartão de crédito.",
    "land.plan_free_cta": "Começar Teste Gratuito",
    "land.plan_ess_name": "Essencial",
    "land.plan_ess_desc": "Para toda empresa, análise de crédito avançada",
    "land.plan_ess_cta": "Assinar Plano",
    "land.plan_pro_name": "Profissional",
    "land.plan_pro_tag": "Mais popular",
    "land.plan_pro_desc": "Para análises que exijam interpretação avançada",
    "land.plan_pro_cta": "Assinar Plano",
    "land.plan_ent_name": "Enterprise",
    "land.plan_ent_desc": "Para bancos, fundos e plataformas de crédito.",
    "land.plan_ent_cta": "Falar com Especialista",

    // Plan features
    "land.feat_cnpj_2": "2 CNPJs para análise",
    "land.feat_user_1": "1 usuário",
    "land.feat_engine": "Motor de risco completo",
    "land.feat_score": "Score + Rating automatizado",
    "land.feat_mia_10": "MIA — 10 perguntas/mês",
    "land.feat_no_history": "Somente última análise (sem histórico)",
    "land.feat_no_pdf": "Sem exportação PDF",
    "land.feat_corp_email": "E-mail corporativo obrigatório",
    "land.feat_cnpj_15": "15 CNPJs monitorados",
    "land.feat_user_3": "3 usuários",
    "land.feat_history": "Histórico completo de análises",
    "land.feat_pdf_unlim": "Exportação PDF ilimitada",
    "land.feat_mia_limited": "MIA nossa IA limitado",
    "land.feat_ticket": "Suporte por Ticket na Plataforma",
    "land.feat_sod": "SOD — segregação de funções",
    "land.feat_cnpj_75": "75 CNPJs monitorados",
    "land.feat_user_10": "10 usuários",
    "land.feat_tenant": "Tenant para sua Empresa",
    "land.feat_models": "Basel II · KMV-Merton · Z-Score · Kanitz",
    "land.feat_algo": "Algoritmo proprietário RiskMind",
    "land.feat_prs": "PRS — Passive Risk Score (tempo real, diário)",
    "land.feat_mia_adv": "MIA com contexto de carteira e análise avançada",
    "land.feat_ticket2": "Suporte por Ticket na plataforma",
    "land.feat_reports": "Relatórios personalizados",
    "land.feat_sod2": "SOD - segregação de funções",
    "land.feat_cnpj_unlim": "CNPJs ilimitados",
    "land.feat_user_unlim": "Usuários ilimitados",
    "land.feat_sla": "SLA contratual",
    "land.feat_api": "Integração via API",
    "land.feat_vpc": "Ambiente dedicado (VPC)",
    "land.feat_onboard": "Onboarding e treinamento",
    "land.feat_custom_models": "Personalização de modelos",
    "land.feat_support_247": "Suporte 24/7",

    // ── FAQ ──
    "land.faq_tag": "Dúvidas Frequentes",
    "land.faq_head": "Perguntas frequentes",
    "land.faq_q1": "O plano gratuito exige cartão de crédito?",
    "land.faq_a1": "Não. Você cria sua conta com e-mail corporativo e começa a usar imediatamente. Sem cartão, sem compromisso.",
    "land.faq_q2": "O que é um 'CNPJ monitorado'?",
    "land.faq_a2": "É cada empresa (contraparte) que você cadastra e analisa na plataforma. Cada análise de crédito consome um slot de CNPJ ativo no mês.",
    "land.faq_q3": "Posso cancelar a qualquer momento?",
    "land.faq_a3": "Sim. Planos mensais podem ser cancelados a qualquer momento sem multa. Planos anuais oferecem desconto de 2 meses e são cancelados ao término do período.",
    "land.faq_q4": "O RiskMind usa inteligência artificial real?",
    "land.faq_a4": "Sim. O motor analítico é alimentado pelo Claude da Anthropic — o mesmo modelo de IA generativa adotado por instituições financeiras líderes globais. Toda análise combina modelos quantitativos (Basel II, Z-Score, KMV-Merton) com interpretação generativa.",
    "land.faq_q5": "Meus dados financeiros são seguros?",
    "land.faq_a5": "Sua infraestrutura roda 100% na AWS (São Paulo). Dados em repouso são criptografados (AES-256) e em trânsito (TLS 1.3). Nunca vendemos ou compartilhamos dados de clientes.",
    "land.faq_q6": "O plano Enterprise inclui integração com sistemas internos?",
    "land.faq_a6": "Sim. Oferecemos API REST documentada e suporte para integração com ERPs, sistemas de originação e CRMs. Entre em contato para discutir sua arquitetura.",

    // ── Backtest Section ──
    "land.bt_tag": "Validação Científica",
    "land.bt_head1": "Backtest com ",
    "land.bt_head_gold": "192 empresas da B3",
    "land.bt_desc": "Análise bilateral com dados públicos de 2015 a 2024. O algoritmo RiskMind™ demonstrou capacidade superior de discriminação e antecipação de eventos de crédito.",
    "land.bt_m1_desc": "Capacidade de distinguir empresas saudáveis de distressed",
    "land.bt_m2_desc": "Poder de ordenação do modelo proprietário",
    "land.bt_m3_desc": "Separação máxima entre distribuições de risco",
    "land.bt_m4_label": "Razão PD",
    "land.bt_m4_desc": "Risco relativo entre empresas distressed e saudáveis",
    "land.bt_m5_value": "3 anos",
    "land.bt_m5_label": "Antecipação",
    "land.bt_m5_desc": "Sinalização antecipada de eventos de crédito",
    "land.bt_m6_value": "8 de 8",
    "land.bt_m6_label": "Acerto",
    "land.bt_m6_desc": "Classificação correta em todas as empresas testadas",
    "land.bt_check1": "100% dados públicos",
    "land.bt_check2": "Metodologia replicável",
    "land.bt_check3": "+19pp vs. baseline logístico",
    "land.bt_check4": "Período 2015–2024",
    "land.bt_cta": "Ver estudo completo →",
    "land.bt_cta_sub": "Case study detalhado com curvas ROC, distribuições e metodologia",

    // ── Footer CTA ──
    "land.fcta_head1": "Pronto para tomar decisões ",
    "land.fcta_head_gold": "mais seguras",
    "land.fcta_desc": "Junte-se às equipes de crédito que já usam o RiskMind.\nComece grátis em menos de 2 minutos.",
    "land.fcta_btn": "Criar conta gratuita →",
    "land.fcta_badge1": "Sem cartão de crédito",
    "land.fcta_badge2": "Teste grátis 15 dias",
    "land.fcta_badge3": "Motor completo disponível",

    // ── Landing Footer Badges ──
    "land.foot_b1": "Powered by Anthropic Claude",
    "land.foot_b2": "AWS São Paulo",
    "land.foot_b3": "Conformidade LGPD",

    // ── Trust Badges / Destaques ──
    "land.trust_tag": "Infraestrutura & Parceiros",
    "land.trust_h2": "Confiança de nível institucional",
    "land.trust_more": "ler mais",
    "land.trust1_title": "Powered by Anthropic Claude",
    "land.trust1_sub": "IA generativa com segurança enterprise",
    "land.trust1_detail": "O RiskMind é alimentado pelo Claude da Anthropic — o mesmo modelo de IA generativa adotado por instituições financeiras líderes globais, reconhecido por rastreabilidade, conformidade regulatória e alinhamento ético.",
    "land.trust2_title": "AWS Infrastructure",
    "land.trust2_sub": "São Paulo · 99.9% uptime SLA",
    "land.trust2_detail": "Infraestrutura 100% AWS na região sa-east-1 (São Paulo). Dados em repouso com AES-256, trânsito TLS 1.3. Elastic Beanstalk + RDS PostgreSQL com backups automáticos diários.",
    "land.trust3_title": "Segurança Financeira",
    "land.trust3_sub": "LGPD · Criptografia AES-256",
    "land.trust3_detail": "Conformidade com LGPD e melhores práticas de segurança do setor financeiro. Autenticação JWT, rate limiting, auditoria completa de acessos e logs imutáveis de todas as operações.",

    // ── Configurações (Settings) ──
    "cfg.title": "Configurações",
    "cfg.users": "Usuários",
    "cfg.users_desc": "Gerencie os membros e seus perfis de acesso.",
    "cfg.invites": "Convites",
    "cfg.invites_desc": "Envie convites para novos usuários.",
    "cfg.policy": "Política de Crédito",
    "cfg.policy_desc": "Regras, limites e alçadas de aprovação.",
    "cfg.fiscal": "Dados Fiscais",
    "cfg.fiscal_desc": "CNPJ, razão social e regime tributário.",
    "cfg.billing": "Cobrança",
    "cfg.billing_desc": "Plano, faturas e forma de pagamento.",

    // ── Dashboard Executivo ──
    "dash.exec_panel": "Painel Executivo de Crédito",
    "dash.portfolio": "Portfólio",
    "dash.tickets": "Tickets",
    "dash.units": "Unidades",
    "dash.settings": "Configurações",
    "dash.logout": "Sair",
    "dash.total_portfolio": "Portfólio Total",
    "dash.analyses": "análises",
    "dash.approved": "Aprovados",
    "dash.active_credits": "créditos ativos",
    "dash.conditional": "Condicionados",
    "dash.with_caveats": "com ressalvas",
    "dash.pend_board": "Pend. Comitê",
    "dash.awaiting_decision": "aguardando decisão",
    "dash.total_exposure": "Exposição Total",
    "dash.approved_limits": "limites aprovados",
    "dash.avg_pd": "PD Médio",
    "dash.avg_risk": "risco médio da carteira",

    // ── SOD Controls ──
    "dash.sod_title": "Controles SOD",
    "dash.sod_sub": "Segregação de funções ativa em tempo real",
    "dash.sod_analyst": "Analista ≠ Aprovador",
    "dash.sod_analyst_d": "Quem analisa não pode aprovar a mesma operação",
    "dash.sod_audit": "Trilha de Auditoria",
    "dash.sod_audit_d": "Log imutável de todas as ações e decisões",
    "dash.sod_review": "Revisão por Pares",
    "dash.sod_review_d": "Análises acima do limite exigem dupla conferência",
    "dash.sod_models": "Modelos Independentes",
    "dash.sod_models_d": "Calibração separada da operação de crédito",
    "dash.sod_limit": "Alçadas Definidas",
    "dash.sod_limit_d": "Limites de aprovação por nível hierárquico",
    "dash.sod_compliance": "Compliance Contínuo",
    "dash.sod_compliance_d": "Monitoramento 24/7 com alertas automáticos",

    // Portfolio/Dashboard
    "port.back": "← Voltar",
    "port.title": "Portfólio de Crédito",
    "port.consolidated": "Consolidado",
    "port.analyses": "análises",
    "port.unique_clients": "clientes únicos",
    "port.updated": "Atualizado",
    "port.loading": "Carregando dados detalhados das análises...",
    "port.total_analyses": "Total Análises",
    "port.approved": "Aprovadas",
    "port.full": "integral",
    "port.conditional": "condicional",
    "port.rejected": "Reprovadas",
    "port.avg_pd": "PD Média Portfólio",
    "port.total_exposure": "Exposição Total",
    "port.approval_rate": "Taxa de Aprovação",
    "port.distribution": "Distribuição do Portfólio",
    "port.by_status": "Por status de análise",
    "port.status_approved": "Aprovado",
    "port.status_conditional": "Condicional",
    "port.status_rejected": "Reprovado",
    "port.status_analyzing": "Em Análise",
    "port.status_pending": "Aguardando",
    "port.approval_rate_label": "Taxa aprovação",
    "port.risk_radar": "Radar de Risco do Portfólio",
    "port.based_on": "Baseado em",
    "port.analyses_with_complete_data": "análise(s) com dados completos",
    "port.perform_credit_analyses_to_populate_radar": "Realize análises de crédito para popular o radar",
    "port.radar_solvency": "Solvência",
    "port.radar_liquidity": "Liquidez",
    "port.radar_approval": "Aprovação",
    "port.radar_score": "Score",
    "port.radar_renewal": "Renovação",
    "port.radar_capital": "Capital",
    "port.no_data": "Sem dados",
    "port.ratings_dist": "Distribuição de Ratings",
    "port.ratings_sub": "Baseado no modelo interno PD → Rating",
    "port.avg_pd_label": "PD Média",
    "port.avg_limit": "Limite médio",
    "port.max_limit": "Maior limite",
    "port.clients_with_renewal": "Clientes com renovação",
    "port.pd_dist": "Distribuição PD",
    "port.pd_by_range": "Probabilidade de default por faixa",
    "port.avg_score_by_status": "Score Médio por Status",
    "port.behavioral_financial_scorecard": "Scorecard comportamental + financeiro",
    "port.monthly_evolution": "Evolução Mensal — Volume Aprovado",
    "port.trend_last_6_months": "Tendência dos últimos 6 meses",
    "port.pd_trend": "Evolução da PD Média — Tendência de Risco",
    "port.pd_trend_sub": "Quanto menor, melhor qualidade do portfólio",
    "port.concentration": "Concentração por Subsidiária",
    "port.concentration_sub": "Exposição por unidade de negócio do grupo (baseado na alocação comercial)",
    "port.unit_dash": "Dashboard por Unidade de Negócio",
    "port.units": "unidades",
    "port.unit": "unidade",
    "port.with_recorded_analyses": "com análises registradas",
    "port.table_unit": "Unidade",
    "port.table_analyses": "Análises",
    "port.table_approved": "Aprovadas",
    "port.table_rejected": "Reprovadas",
    "port.table_exposure": "Exposição",
    "port.table_avg_pd": "PD Média",
    "port.table_avg_score": "Score Médio",
    "port.table_approval_rate": "Taxa Aprov.",
    "port.top_clients": "Top Clientes por Limite",
    "port.top_clients_sub": "clientes únicos aprovados · ordenados por limite",
    "port.table_company": "Empresa",
    "port.table_cnpj": "CNPJ",
    "port.table_limit": "Limite",
    "port.table_pd": "PD",
    "port.table_rating": "Rating",
    "port.table_status": "Status",
    "port.table_date": "Data",
    "port.no_approval_data": "Sem dados de aprovação",
    "port.consolidation_info": "Visão consolidada inclui todas as análises. Filtre por unidade acima para análise detalhada.",

    // ── Formulário de Cadastro de Cliente (ClientForm) ──
    "form.step_company": "Empresa",
    "form.step_documents": "Documentos",
    "form.step_financial": "Financeiro",
    "form.step_confirmation": "Confirmar",
    "form.checking_registration": "Verificando cadastro...",
    "form.registration_found": "Cadastro Encontrado",
    "form.your_data_registered": "Seus dados já estão registrados no sistema",
    "form.new_request_reuse_data": "Para nova solicitação, seus dados e documentos válidos serão aproveitados. Apenas confirme se houve alterações.",
    "form.previous_docs_changes": "Documentos do cadastro anterior — houve alguma alteração?",
    "form.no_changes": "Sem mudança ✓",
    "form.update": "Atualizar",
    "form.responsibility_statement": "Declaração de responsabilidade",
    "form.responsibility_text": "Ao manter documentos anteriores sem atualização, declaro que as informações e documentos estão vigentes, completos e sem alterações relevantes. Estou ciente de que a prestação de informações inverídicas constitui crime previsto em lei.",
    "form.confirm_and_continue": "Confirmar e Continuar",
    "form.new_registration": "Novo Cadastro",
    "form.no_previous_registration": "Nenhum cadastro anterior encontrado. Vamos criar seu perfil completo.",
    "form.get_started": "Começar",
    "form.company_data": "Dados da Empresa",
    "form.cnpj_matrix": "CNPJ Matriz",
    "form.cnpj_linked_to_invite": "CNPJ vinculado ao seu convite — não pode ser alterado",
    "form.lookup": "Consultar",
    "form.federal_revenue_data": "Dados Receita Federal",
    "form.legal_name": "Razão Social",
    "form.legal_entity_type": "Tipo Societário",
    "form.type_ltda": "Ltda / Eireli / ME",
    "form.type_sa": "S/A",
    "form.type_mei": "MEI",
    "form.industry_sector": "Setor de Atuação",
    "form.sector_logistics": "Logística",
    "form.sector_transport": "Transporte",
    "form.sector_industry": "Indústria",
    "form.sector_commerce": "Comércio",
    "form.sector_services": "Serviços",
    "form.sector_agribusiness": "Agronegócio",
    "form.sector_technology": "Tecnologia",
    "form.sector_others": "Outros",
    "form.documents": "Documentos - {type}",
    "form.docs_validated_automatically": "Documentos são validados automaticamente pela IA antes de prosseguir. Itens marcados com * são obrigatórios.",
    "form.after_upload_validate_docs": "Após enviar todos os documentos, clique em Validar Documentos para que a IA confirme se estão corretos e referentes à sua empresa.",
    "form.multiple_files_accepted": "Múltiplos arquivos aceitos",
    "form.analyzing": "Analisando...",
    "form.add_file": "+Arquivo",
    "form.upload": "Enviar",
    "form.reused": "REAPROVEITADO",
    "form.optional_comment_analysis": "Comentário opcional para a análise...",
    "form.required_docs_manual_validation": "* Obrigatórios. Documentos não legíveis serão validados manualmente pela Tesouraria.",
    "form.financial_data": "Dados Financeiros - 3 Exercícios",
    "form.years": "Anos",
    "form.fill_financial_data": "Preencha com os valores do Balanço Patrimonial e DRE. Se os documentos financeiros foram enviados na etapa anterior (PDF), use o botão abaixo para tentar extração automática.",
    "form.first_time_financial_notice": "Primeiro cadastro? É obrigatório preencher os dados financeiros dos 3 últimos exercícios encerrados ({years}). Balanço Patrimonial, DRE e demais demonstrações devem ser informados para cada ano. Dados incompletos podem atrasar a análise de crédito.",
    "form.first_time_docs_notice": "Para o primeiro cadastro, envie os documentos financeiros (Balanço, DRE, balancete, SPED) referentes aos 3 últimos exercícios encerrados ({years}). Isso é essencial para a análise de crédito.",
    "form.quarter_req_notice": "Além dos 3 exercícios anteriores, é necessário enviar também os dados parciais de {year} ({quarters}). Balancete e demonstrações do período já encerrado são obrigatórios.",
    "form.quarter_req_docs_notice": "Inclua também os documentos parciais de {year} ({quarters}) — balancete de verificação e demonstrações intermediárias do exercício em curso.",
    "form.pdf_extraction": "Extração de PDF",
    "form.pdf_extraction_desc": "Lê o texto nativo do PDF (Balanço + DRE). Confira e corrija os valores extraídos.",
    "form.extracting": "Extraindo...",
    "form.extract_from_pdf": "Extrair do PDF",
    "form.extract_all_years": "Extrair Todos os Anos do PDF",
    "form.upload_financial_first": "Suba os documentos financeiros primeiro (Balanço + DRE) na etapa de documentos, depois volte aqui.",
    "form.ai_partial_years": "Dados extraídos para: {found}.\n\nNão encontrado nos documentos: {missing}.\nPreencha esses anos manualmente ou suba os documentos correspondentes.",
    "form.ai_no_data_found": "Não foi possível extrair dados financeiros dos documentos. Verifique se os PDFs contêm Balanço Patrimonial ou DRE legíveis e tente novamente.",
    "form.extracted_fields": "Extraídos {count} campo(s) do PDF.",
    "form.verify_and_correct": "Confira e corrija se necessário.",
    "form.confirm_and_send": "Confirmar e Enviar",
    "form.request_sent_to_treasury": "Sua solicitação entrará na fila do time de Tesouraria. A equipe comercial (CS) complementará os dados de relacionamento e volumes antes da análise de crédito.",
    "form.company": "Empresa",
    "form.type": "Tipo",
    "form.files_uploaded": "Arquivos enviados",
    "form.sending": "Enviando...",
    "form.send_request": "Enviar Solicitação",

    // ── Formulário Financeiro (FinancialFormPeriod) ──
    "form.fin_field": "Campo",
    "form.fin_previous": "Anterior",
    "form.fin_new": "Novo ({period})",
    "form.fin_group_income_statement": "Demonstração de Resultado",
    "form.fin_group_balance_sheet": "Balanço Patrimonial",
    "form.fin_required_legend": "* Obrigatórios · Valores em R$ (reais inteiros) · Campos de fluxo = valor do período | Estoque = saldo final",
    "form.fin_flow_vs_stock_warning": "📊 Campos de <strong>fluxo</strong> (receita, custos, resultado): valores do período. Campos de <strong>estoque</strong> (ativos, passivos, PL): saldo no final do período.",

    // ── Campos Financeiros (FINS_FIELDS) ──
    "form.fin_rev": "Receita Líquida (após deduções)",
    "form.fin_cpv": "Custo dos Produtos / Serviços (CPV/CSP)",
    "form.fin_desp_op": "Despesas Operacionais",
    "form.fin_desp_fin": "Despesas Financeiras (Juros pagos)",
    "form.fin_lucro": "Resultado Líquido (Lucro ou Prejuízo)",
    "form.fin_da": "Depreciação e Amortização (D&A)",
    "form.fin_ebitda_real": "EBITDA (se informado no DRE)",
    "form.fin_caixa": "Caixa e Equivalentes",
    "form.fin_ac": "Total do Ativo Circulante",
    "form.fin_pc": "Total do Passivo Circulante",
    "form.fin_at": "Total de Ativos",
    "form.fin_pt": "Total de Passivos",
    "form.fin_pl": "Patrimônio Líquido",
    "form.fin_lucro_acum": "Lucros/Prejuízos Acumulados (Reservas)",
    "form.fin_div_cp": "Empréstimos e Financiamentos - Curto Prazo (até 12 meses)",
    "form.fin_div_lp": "Empréstimos e Financiamentos - Longo Prazo (acima de 12 meses)",
    "form.fin_arrend_cp": "Arrendamentos IFRS16 - Curto Prazo (passivo)",
    "form.fin_arrend_lp": "Arrendamentos IFRS16 - Longo Prazo (passivo)",
    "form.fin_dou_uso": "Direito de Uso (ativo IFRS16)",
    "form.fin_pgto_lease": "Pagamento de Leasing no Período (opcional)",

    // ── Tickets & Support ──
    "tkt.report_error": "Reportar Erro",
    "tkt.suggest_improvement": "Sugerir Melhoria",
    "tkt.technical_support": "SUPORTE TÉCNICO",
    "tkt.credit_tickets": "TICKETS DE CRÉDITO",
    "tkt.support_technical": "Suporte Técnico",
    "tkt.tickets_credit": "Tickets de Crédito",
    "tkt.new_ticket": "+ Novo Ticket",
    "tkt.credit_label": "🎫 Crédito",
    "tkt.credit_desc": "Pendências e documentos",
    "tkt.support_label": "🐛 Suporte",
    "tkt.support_desc": "Erros e melhorias",
    "tkt.status_all": "Todos",
    "tkt.status_open": "Abertos",
    "tkt.status_waiting": "Aguardando",
    "tkt.status_replied": "Respondidos",
    "tkt.status_closed": "Fechados",
    "tkt.loading": "Carregando...",
    "tkt.no_error_reported": "Você não reportou nenhum erro ou melhoria ainda",
    "tkt.no_ticket_found": "Nenhum ticket encontrado",
    "tkt.new_reply": "● Nova resposta",
    "tkt.awaiting_you": "⏳ Aguardando você",
    "tkt.pending_badge": "🎫 Ticket Pendente",
    "tkt.avg_closure_time": "Tempo médio de fechamento:",
    "tkt.total_tickets": "tickets no total",
    "tkt.days": "dias",
    "tkt.send_error_report": "🐛 Enviar Relatório",
    "tkt.send_suggestion": "💡 Enviar Sugestão",
    "tkt.create_ticket": "🎫 Criar Ticket",
    "tkt.sending": "Enviando...",
    "tkt.sent_success": "✅ Enviado! O Founder será notificado.",
    "tkt.ticket_created": "✅ Ticket criado e cliente notificado!",
    "tkt.back": "← Voltar",
    "tkt.requests": "Solicitações",

    // ── Ticket Detail ──
    "tkt.detail_header": "Solicitações",
    "tkt.open_tickets": "Abertos",
    "tkt.waiting_debtor": "Aguardando",
    "tkt.replied_tickets": "Respondidos",
    "tkt.closed_tickets": "Fechados",

    // ── Modal: Ticket Creation ──
    "modal.ticket_error_title": "Reportar Erro",
    "modal.ticket_improvement_title": "Sugerir Melhoria",
    "modal.ticket_credit_title": "Novo Ticket de Crédito",
    "modal.sent_to_founder": "Enviado ao Founder · Código FNM-Tech gerado automaticamente",
    "modal.auto_code_generated": "Código FNM gerado automaticamente",
    "modal.type_label": "TIPO",
    "modal.priority_label": "PRIORIDADE",
    "modal.priority_low": "Baixa",
    "modal.priority_normal": "Normal",
    "modal.priority_high": "Alta",
    "modal.priority_urgent": "🔴 Urgente",
    "modal.company_label": "EMPRESA / DEVEDOR",
    "modal.company_placeholder": "Digite o nome ou CNPJ da empresa...",
    "modal.company_registered": "✓",
    "modal.title_label": "TÍTULO *",
    "modal.description_label": "DESCRIÇÃO",
    "modal.deadline_label": "PRAZO",
    "modal.screenshot_label": "SCREENSHOT DO ERRO (opcional)",
    "modal.click_to_attach": "📎 Clique para anexar imagem (máx 5MB, apenas imagens)",
    "modal.attached": "📎",
    "modal.where_error_occurred": "ONDE OCORREU / TÍTULO *",
    "modal.example_error": "Ex: Botão 'Aprovar' não salva",
    "modal.describe_problem": "DESCREVA O PROBLEMA",
    "modal.steps_to_reproduce": "Passo a passo para reproduzir...",
    "modal.how_improvement": "COMO VOCÊ IMAGINA ESTA MELHORIA?",
    "modal.improvement_details": "Detalhes da funcionalidade...",
    "modal.what_needed": "DESCRIÇÃO",
    "modal.detail_what": "Detalhe o que precisa ser enviado...",
    "modal.cancel_button": "Cancelar",

    // ── Modal: Request Update ──
    "modal.request_update_title": "Solicitar atualização",
    "modal.request_recipients": "Destinatários",
    "modal.request_loading_contacts": "Buscando contatos registrados…",
    "modal.request_no_contacts": "Nenhum contato cadastrado para este CNPJ. Insira o e-mail abaixo.",
    "modal.request_additional_email": "Adicionar outro e-mail (opcional)",
    "modal.request_error_invalid": "E-mail adicional inválido.",
    "modal.request_error_none_selected": "Selecione ao menos um destinatário.",
    "modal.request_info_text": "Cada destinatário receberá um link único e seguro (válido 24h) para preencher os dados de",
    "modal.request_sending": "Enviando…",
    "modal.request_send": "Enviar solicitação →",
    "modal.request_success_title": "Solicitação enviada!",
    "modal.request_success_text": "Link seguro enviado para:",
    "modal.request_success_for": "para preenchimento de",
    "modal.request_registered": "cadastrado",

    // ── File Upload ──
    "upload.only_images": "❌ Apenas imagens são aceitas",
    "upload.file_too_large": "❌ Arquivo muito grande (máx 5MB)",
    "upload.drag_drop": "Arraste e solte",
    "upload.select_file": "Selecionar arquivo",
    "upload.attach": "Anexar",
    "upload.attached_file": "Arquivo anexado",
    "upload.max_size": "máx 5MB",
    "upload.image_only": "apenas imagens",

    // ── Checkout Modal ──
    "modal.checkout_title": "Assinar plano",
    "modal.checkout_redirect": "Você será redirecionado ao Stripe para pagamento seguro.",
    "modal.full_name": "Nome completo *",
    "modal.full_name_placeholder": "João Silva",
    "modal.company_cnpj": "CNPJ da Empresa *",
    "modal.company_cnpj_placeholder": "00.000.000/0001-00",
    "modal.cnpj_checking": "Consultando Receita Federal...",
    "modal.company_legal_name": "Nome / Razão Social *",
    "modal.company_legal_placeholder": "Preenchido ao informar o CNPJ",
    "modal.cpf_label": "CPF do responsável",
    "modal.cpf_placeholder": "000.000.000-00",
    "modal.job_title": "Cargo / Função",
    "modal.job_title_placeholder": "Ex: Diretor Financeiro",
    "modal.corporate_email": "E-mail corporativo *",
    "modal.corporate_email_placeholder": "joao@empresa.com.br",
    "modal.checkout_error": "⚠️ Erro",
    "modal.already_exists_pending": "📧 Link de ativação reenviado",
    "modal.already_exists_active": "✅ Conta já existe",
    "modal.domain_already_registered": "🏢 Empresa já cadastrada",
    "modal.check_spam": "Verifique também a pasta de spam.",
    "modal.ask_admin": "Para acessar o RiskMind, peça ao administrador da sua empresa que acesse Configurações → Usuários e te envie um convite.",
    "modal.contract_accepted": "Contrato SaaS + LGPD aceitos eletronicamente",
    "modal.undo_accept": "desfazer",
    "modal.read_sign_contract": "📄 Ler e assinar Contrato + LGPD",
    "modal.required": "(obrigatório)",
    "modal.sending_text": "Enviando…",
    "modal.close_login": "Fechar e fazer login →",
    "unit.group": "Grupo",
    "unit.title": "Unidades de Negócio",
    "unit.back": "← Voltar",
    "unit.view_portfolio": "📊 Ver no Portfólio",
    "unit.new": "+ Nova Unidade",
    "unit.edit_title": "Editar Unidade",
    "unit.new_title": "Nova Unidade",
    "unit.name_label": "Nome *",
    "unit.name_ph": "Ex: nome da empresa ou CNPJ...",
    "unit.cnpj_label": "CNPJ (opcional)",
    "unit.desc_label": "Descrição (opcional)",
    "unit.desc_ph": "Ex: Divisão Logística, Unidade Norte...",
    "unit.credit_policy": "Política de Crédito desta Unidade",
    "unit.update_freq": "Frequência de Atualização",
    "unit.quarterly": "Trimestral (3 meses)",
    "unit.semiannual": "Semestral (6 meses)",
    "unit.annual": "Anual (12 meses)",
    "unit.min_interval": "Intervalo Mínimo (meses)",
    "unit.inherits_policy": "Se não definida, herda a política padrão do grupo (Configurações → Política de Crédito).",
    "unit.name_required": "Nome é obrigatório.",
    "unit.saving": "Salvando...",
    "unit.save_changes": "Salvar Alterações",
    "unit.register": "Cadastrar Unidade",
    "unit.cancel": "Cancelar",
    "unit.loading": "Carregando unidades...",
    "unit.none": "Nenhuma unidade cadastrada",
    "unit.none_desc": "Configure as subsidiárias e divisões do grupo para visualizar o portfólio de crédito por unidade.",
    "unit.register_first": "+ Cadastrar Primeira Unidade",
    "unit.th_unit": "Unidade",
    "unit.th_cnpj": "CNPJ",
    "unit.th_desc": "Descrição",
    "unit.th_policy": "Política de Crédito",
    "unit.edit": "Editar",
    "unit.remove": "Remover",
    "unit.confirm_remove": "Remover \"{name}\"? Esta ação não pode ser desfeita.",
    "unit.inherits_default": "Herda padrão",
    "unit.count": "{n} unidade(s) cadastrada(s)",
    "unit.view_consolidated": "Ver portfólio consolidado",
    "unit.policy_info": "A Política de Atualização de Crédito é definida em Configurações → Política de Crédito.",
    "usr.back": "Voltar",
    "usr.title": "Gestão de Usuários",
    "usr.invite": "+ Convidar Usuário",
    "usr.invite_title": "Convidar Novo Usuário",
    "usr.invite_sub": "O usuário receberá um e-mail com link para criar sua própria senha (válido por 72h)",
    "usr.name": "Nome Completo *",
    "usr.email": "E-mail Corporativo *",
    "usr.position": "Cargo *",
    "usr.position_ph": "Ex: Analista de Crédito",
    "usr.access_profile": "Perfil de Acesso *",
    "usr.security_title": "🔒 Segurança — Criação de Senha pelo Próprio Usuário",
    "usr.security_desc": "O convite é enviado por e-mail com um link seguro de uso único.",
    "usr.security_pass": "O usuário criará sua própria senha com no mínimo 12 caracteres.",
    "usr.security_expire": "O link expira em 72 horas. Caso expire, você pode reenviar o convite.",
    "usr.sod_title": "⚠ PRINCÍPIO SOD — Segregação de Funções",
    "usr.role_analista": "Analista: preenche dados, roda engine, gera parecer — NÃO pode aprovar.",
    "usr.role_aprovador": "Aprovador: visualiza resultado e decide — NÃO pode alterar análise.",
    "usr.role_tesouraria": "Tesouraria: realiza análise completa e aprova — para equipes enxutas.",
    "usr.role_cs": "CS + Tesouraria: comercial + análise + aprovação — para empresas sem estrutura segregada.",
    "usr.role_cfo": "CFO/Diretor: somente leitura + solicitação de revisão — NÃO interferem na análise.",
    "usr.cancel": "Cancelar",
    "usr.sending": "Enviando convite...",
    "usr.send_invite": "Enviar Convite por E-mail",
    "usr.fill_required": "Preencha nome, e-mail e cargo.",
    "usr.none": "Nenhum usuário encontrado.",
    "usr.awaiting_setup": "Aguardando Setup",
    "usr.verified": "Verificado",
    "usr.awaiting_password": "📧 Aguardando criação de senha via e-mail",
    "usr.edit": "Editar",
    "usr.resend": "Reenviar Convite",
    "usr.reactivate": "Reativar",
    "usr.deactivate": "Desativar",
    "usr.delete": "Excluir",
    "usr.delete_title": "Excluir Usuário",
    "usr.delete_confirm": "Tem certeza que deseja excluir",
    "usr.delete_irreversible": "Esta ação é irreversível.",
    "usr.confirm_delete": "Confirmar Exclusão",
    "usr.edit_title": "Editar Usuário",
    "usr.name_label": "NOME",
    "usr.position_label": "CARGO",
    "usr.access_label": "PERFIL DE ACESSO",
    "usr.admin_warning": "⚠ Acesso total — use apenas para testes e validações.",
    "usr.save": "Salvar alterações",
    "usr.loading": "Carregando...",
    "port2.risk_by_borrower": "Análise de Risco por Tomadora",
    "port2.risk_by_borrower_sub": "Indicadores de risco por empresa que recebe crédito",
    "port2.risk_by_assignor": "Análise de Risco por Cedente",
    "port2.risk_by_assignor_sub": "Indicadores de risco agrupados por unidade de negócio do grupo",
    "port2.no_unit_analysis": "Sem análise por unidade de negócio",
    "port2.no_unit_desc": "Os clientes aprovados não têm unidades/subsidiárias definidas.",
    "port2.no_unit_desc2": "O risco de crédito está consolidado por empresa no portfólio acima.",
    "port2.risk_ranges": "Faixas de risco: Verde < 3% | Âmbar 3-12% | Vermelho > 12%",
    "port2.score_avg": "Score 0–100 · Média geral:",
    "port2.pd_warning": "⚠️ PD crescente indica piora da qualidade do portfólio — monitore novos clientes com PD > 6%",
    "port2.exposure_concentration": "Concentração de Exposição por Unidade",
    "port2.exposure": "Exposição:",
    "port2.clients": "Clientes:",
    "port2.avg_pd": "PD média:",
    "port2.dominant_rating": "Rating predominante:",
    "port2.client": "Cliente",
    "port2.validity": "Vigência: Limite anual com revisão trimestral automática.",
    "port2.immediate_review": "Revisão imediata:",
    "port2.review_text": "reserva-se o direito de rever, suspender ou cancelar limites de crédito a qualquer momento, sem prévio aviso, a seu exclusivo critério.",
    "port2.generated_at": "Análise gerada em",
    "port2.confidential": "Confidencial",
    "port2.th_empresa": "Empresa",
    "port2.th_cnpj": "CNPJ",
    "port2.th_rating": "Rating",
    "port2.th_pd": "PD",
    "port2.th_score": "Score",
    "port2.th_limite": "Limite",
    "port2.th_unidade": "Unidade",
    "port2.th_status": "Status",
    "port2.approved": "Aprovado",
    "port2.conditional": "Cond.",
    "port2.rejected": "Reprov.",
    "common.all_rights": "Todos os direitos reservados",
    "common.confidential": "CONFIDENCIAL — USO INTERNO",
    "common.ticket_pending": "🎫 Ticket Pendente",
    "stat.approved": "Aprovado",
    "stat.conditional": "Condicional",
    "stat.rejected": "Reprovado",
    "stat.pending": "Pendente",
    "stat.awaiting": "Aguardando",
    "stat.in_analysis": "Em Análise",
    "bill.active_users": "Usuários ativos",
    "bill.back_panel": "← Voltar ao painel",
    "bill.billing_q": "Dúvidas sobre o faturamento?",
    "bill.cnpjs_analyzed": "CNPJs analisados",
    "bill.cnpjs_available": "CNPJs disponível no período de teste.",
    "bill.contact": "Entre em contato:",
    "bill.current_plan": "PLANO ATUAL",
    "bill.free_trial": "🎉 Teste gratuito em andamento",
    "bill.mia_queries": "Consultas MIA",
    "bill.no_subscription": "Sem assinatura",
    "bill.portal_info": "O portal de assinatura permite trocar cartão, baixar faturas e cancelar ou fazer upgrade do plano.",
    "bill.title": "Assinatura & Billing",
    "bill.unlimited": "(ilimitado)",
    "bill.usage_title": "USO DO PLANO — CICLO ATUAL",
    "fiscal.address": "ENDEREÇO FISCAL",
    "fiscal.address_desc": "Preenchido automaticamente ao consultar o CNPJ",
    "fiscal.city": "Município",
    "fiscal.city_reg": "Inscrição Municipal",
    "fiscal.cnpj": "CNPJ *",
    "fiscal.company_desc": "Dados obrigatórios para emissão de NF-e nos planos pagos",
    "fiscal.company_id": "IDENTIFICAÇÃO DA EMPRESA",
    "fiscal.complement": "Complemento",
    "fiscal.district": "Bairro",
    "fiscal.legal_name": "Razão Social *",
    "fiscal.nfe_info": "Estes dados são usados como tomador na emissão automática de NF-e para suas mensalidades. Mantenha-os atualizados para garantir validade fiscal das notas.",
    "fiscal.number": "Número",
    "fiscal.save": "Salvar Dados Fiscais",
    "fiscal.state": "UF",
    "fiscal.state_reg": "Inscrição Estadual",
    "fiscal.street": "Logradouro",
    "fiscal.title": "Dados Fiscais",
    "fiscal.trade_name": "Nome Fantasia",
    "fiscal.zip": "CEP",
    "inv.new": "+ Novo Convite",
    "inv.none": "Nenhum convite enviado",
    "inv.none_desc": "Clique em \"+ Novo Convite\" para convidar uma empresa a se cadastrar.",
    "inv.title": "Convites de Cadastro",
    "pol.alert_info": "Clientes receberão alertas automáticos quando a atualização estiver próxima do vencimento.",
    "pol.annual_option": "Anual (a cada 12 meses — mínimo obrigatório)",
    "pol.min_interval": "Intervalo Mínimo (meses)",
    "pol.min_max": "Mínimo: 3 meses · Máximo: 12 meses (obrigatório por ano)",
    "pol.rule_desc": "Define com que frequência os devedores devem atualizar os dados financeiros para renovação de crédito",
    "pol.rule_title": "REGRA DE ATUALIZAÇÃO DE DADOS FINANCEIROS",
    "pol.save": "Salvar Política",
    "pol.title": "Política de Crédito",
    "pol.unit_edit_info": "Para definir prazos específicos por unidade, acesse 🏢 Unidades no menu principal e edite cada unidade individualmente.",
    "pol.unit_inherit": "As unidades de negócio herdam esta política padrão.",
    "pol.unit_policy": "POLÍTICA POR UNIDADE DE NEGÓCIO",
    "pol.unit_policy_sub": "Para definir políticas individuais por subsidiária",
    "pol.update_freq": "Frequência de Atualização",
    "port2.customers": "Clientes:",
    "port2.footer": "RiskMind v2.0 · Análise gerada em",
    "port2.footer_confidential": "· Confidencial",
    "port2.no_unit_desc1": "Os clientes aprovados não têm unidades/subsidiárias definidas.",
    "port2.predominant_rating": "Rating predominante:",
    "port2.th_company": "Empresa",
    "port2.th_customer": "Cliente",
    "port2.th_limit": "Limite",
    "port2.th_unit": "Unidade",
    "port2.validity_annual": "Limite anual com revisão trimestral automática.",
    "port2.validity_header": "Vigência:",
    "port2.validity_rights": "reserva-se o direito de rever, suspender ou cancelar limites de crédito a qualquer momento, sem prévio aviso, a seu exclusivo critério.",
    "usr.invite_access_profile": "Perfil de Acesso *",
    "usr.invite_email": "E-mail Corporativo *",
    "usr.invite_name": "Nome Completo *",
    "usr.invite_role": "Cargo *",
    "usr.label_access_profile": "PERFIL DE ACESSO",
    "usr.label_name": "NOME",
    "usr.label_role": "CARGO",
    "usr.resend_invite": "Reenviar Convite",
    "usr.security_header": "Segurança — Criação de Senha pelo Próprio Usuário",
    "usr.sending_invite": "Enviando convite...",
    "usr.sod_desc": "Analista: preenche dados, roda engine, gera parecer — NÃO pode aprovar. Aprovador: visualiza resultado e decide — NÃO pode alterar análise. Tesouraria: realiza análise completa e aprova — para equipes enxutas. CS + Tesouraria: comercial + análise + aprovação — para empresas sem estrutura segregada. CFO/Diretor: somente leitura + solicitação de revisão — NÃO interferem na análise.",
    "usr.sod_header": "PRINCÍPIO SOD — Segregação de Funções",
    "bill.cnpjs": "CNPJs analisados",
    "bill.mia": "Consultas MIA",
    "bill.users": "Usuários ativos",
    "bill.usage_label": "USO DO PLANO — CICLO ATUAL",
    "bill.support_question": "Dúvidas sobre o faturamento?",
    "fiscal.address_sub": "Preenchido automaticamente ao consultar o CNPJ",
    "fiscal.id_company": "IDENTIFICAÇÃO DA EMPRESA",
    "fiscal.id_sub": "Dados obrigatórios para emissão de NF-e nos planos pagos",
    "fiscal.tax_usage": "Estes dados são usados como tomador na emissão automática de NF-e para suas mensalidades. Mantenha-os atualizados para garantir validade fiscal das notas.",
    "fiscal.neighborhood": "Bairro",
    "inv.header": "Convites de Cadastro",
    "inv.new_invite": "+ Novo Convite",
    "inv.no_invites": "Nenhum convite enviado",
    "pol.annual": "Anual (a cada 12 meses — mínimo obrigatório)",
    "pol.auto_alerts": "Clientes receberão alertas automáticos quando a atualização estiver próxima do vencimento.",
    "pol.inheritance_note": "As unidades de negócio herdam esta política padrão. Para definir prazos específicos por unidade, acesse Unidades no menu principal e edite cada unidade individualmente.",
    "pol.interval_info": "Mínimo: 3 meses · Máximo: 12 meses (obrigatório por ano)",
    "pol.per_unit": "POLÍTICA POR UNIDADE DE NEGÓCIO",
    "usr.two_factor": "Autenticação de dois fatores",
    "cfg.settings_label": "Configurações",
    "inv.empty_hint": "Clique em \"+ Novo Convite\" para convidar uma empresa a se cadastrar.",
    "inv.form_title": "Convidar Empresa Devedora",
    "inv.lbl_cnpj": "CNPJ *",
    "inv.lbl_company": "Razão Social *",
    "inv.lbl_contact_cpf": "CPF do Responsável",
    "inv.lbl_contact_name": "Nome do Responsável",
    "inv.lbl_email": "Email Corporativo *",
    "inv.lbl_role": "Cargo / Função",
    "inv.ph_company": "Nome da empresa",
    "inv.ph_email": "responsavel@empresa.com.br",
    "inv.ph_name": "Nome completo",
    "inv.ph_role": "Ex: Diretor Financeiro",
    "inv.resend": "Reenviar",
    "inv.searching": "Buscando dados...",
    "inv.submit_btn": "📨 Enviar Convite",
    "inv.submitting": "Enviando...",
    "inv.th_actions": "Ações",
    "inv.th_cnpj": "CNPJ",
    "inv.th_company": "Empresa",
    "inv.th_contact": "Responsável",
    "inv.th_email": "Email",
    "inv.th_expires": "Expira",
    "inv.th_status": "Status",
    "pol.per_unit_sub": "Para definir políticas individuais por subsidiária",
    "pol.quarterly": "Trimestral (a cada 3 meses)",
    "pol.rule_sub": "Define com que frequência os devedores devem atualizar os dados financeiros para renovação de crédito",
    "pol.semiannual": "Semestral (a cada 6 meses)",
    "pol.saving": "Salvando...",

    // ── Portal do Cliente (cp.*) ──
    "cp.portal_title": "PORTAL DO CLIENTE",
    "cp.credit_history": "Meu Histórico de Crédito",
    "cp.logout": "Sair",
    "cp.new_application": "+ Nova Solicitação",
    "cp.portfolio_stats": "Estatísticas do Portfólio",
    "cp.credit_requests": "Solicitações de Crédito",
    "cp.support": "Suporte",
    "cp.loading": "Carregando...",
    "cp.no_applications": "Nenhuma solicitação ainda",
    "cp.no_applications_hint": "Clique em \"+ Nova Solicitação\" para começar",
    "cp.applications_count": "solicitação(ões)",
    "cp.limit_evolution": "EVOLUÇÃO DO LIMITE",
    "cp.most_recent": "Mais recente",
    "cp.waiting_cs": "Aguardando preenchimento comercial (CS)",
    "cp.in_analysis_treasury": "Em análise pela Tesouraria",
    "cp.credit_letter": "Carta de Crédito",
    "cp.current_limit": "Limite atual",
    "cp.limit_label": "Limite",
    "cp.status_approved": "Aprovado",
    "cp.status_conditional": "Condicional",
    "cp.status_rejected": "Reprovado",
    "cp.status_in_analysis": "Em Análise",
    "cp.status_waiting": "Aguardando",
    "cp.status_pending_board": "Pend. Diretoria",
    "cp.status_pending_docs": "Pend. Docs",

    // ── Documentos (doc.*) ──
    "doc.section_title": "DOCUMENTOS",
    "doc.validation_intro": "Documentos são validados automaticamente por IA antes de prosseguir. Itens marcados com * são obrigatórios.",
    "doc.validation_hint": "Após enviar todos os documentos, clique em Validar Documentos para que a IA confirme que estão corretos e relacionados à sua empresa.",
    "doc.required_note": "* Obrigatório. Documentos ilegíveis serão validados manualmente pela Tesouraria.",
    "doc.upload": "Upload",
    "doc.multiple_files": "Múltiplos arquivos aceitos",
    "doc.validate_ai": "Validar Documentos com IA",
    "doc.back": "Voltar",
    "doc.contract_amendments": "Contrato Social + Alterações",
    "doc.contract_amendments_desc": "Suba o contrato original + todas as alterações. Aceita múltiplos arquivos.",
    "doc.meeting_minutes": "Ata de Reunião / RCA",
    "doc.meeting_minutes_desc": "Atas de reunião de sócios ou RCA com deliberações relevantes.",
    "doc.balance_sheet_dre": "Balanço Patrimonial + DRE",
    "doc.balance_sheet_dre_desc": "Um arquivo por ano ou todos juntos. Aceito PDF e imagem.",
    "doc.trial_balance": "Balancete Analítico (complementar)",
    "doc.trial_balance_desc": "Útil para períodos sem balanço fechado ou renovações semestrais.",
    "doc.sped_accounting": "SPED Contábil / ECD / ECF",
    "doc.sped_accounting_desc": "Arquivo SPED gerado pelo sistema contábil.",
    "doc.cnd_federal": "CND Receita Federal (SRFB/PGFN)",
    "doc.cnd_federal_desc": "Certidão com validade de 30 dias. A vencida penaliza o score.",
    "doc.cnd_inss": "CND Previdenciária / INSS",
    "doc.cnd_inss_desc": "Certidão de Regularidade Previdenciária.",
    "doc.crf_fgts": "CRF FGTS",
    "doc.crf_fgts_desc": "Certificado de Regularidade do FGTS.",
    "doc.cndt_labor": "CNDT — Certidão Trabalhista",
    "doc.cndt_labor_desc": "Certidão Negativa de Débitos Trabalhistas (TST).",
    "doc.audit_report": "Relatório de Auditoria Independente",
    "doc.audit_report_desc": "Relatório assinado por auditor registrado CVM/CFC.",
    "doc.esg_report": "Relatório de Sustentabilidade / ESG",
    "doc.esg_report_desc": "GRI, SASB, Integrated Report ou similar.",
    "doc.id_owners": "RG ou CNH dos Sócios Adm.",
    "doc.id_owners_desc": "Documento de identidade de cada sócio administrador.",
    "doc.bylaws": "Estatuto Social",
    "doc.bylaws_desc": "Estatuto social consolidado da companhia.",
    "doc.board_election": "Ata de Eleição da Diretoria / AGO",
    "doc.board_election_desc": "Ata de assembleia geral que elegeu a diretoria atual.",
    "doc.balance_audited": "Balanço + DRE Auditado",
    "doc.balance_audited_desc": "Demonstrações financeiras auditadas por auditoria independente.",
    "doc.trial_balance_sa": "Balancetes (complementar)",
    "doc.trial_balance_sa_desc": "Balancetes intermediários para análise complementar.",
    "doc.sped_sa": "SPED Contábil / ECD",
    "doc.sped_sa_desc": "Arquivo SPED gerado pelo sistema contábil.",
    "doc.id_directors": "RG ou CNH dos Diretores",
    "doc.id_directors_desc": "Documento de identidade de cada diretor.",
    "doc.mei_certificate": "Certificado MEI",
    "doc.mei_certificate_desc": "Certificado de Condição de Microempreendedor Individual.",
    "doc.dasn_simei": "DASN-SIMEI",
    "doc.dasn_simei_desc": "Declaração Anual do Simples Nacional.",
    "doc.id_holder": "RG ou CNH do Titular",
    "doc.id_holder_desc": "Documento de identidade do titular do MEI.",

    // ── Validação IA de Documentos ──
    "doc.ai_analyzing": "Analisando documentos com Mia...",
    "doc.ai_checking": "Verificando autenticidade e correspondência com a empresa",
    "doc.ai_all_valid": "Todos os documentos validados com sucesso",
    "doc.ai_next_financial": "Próximo: Dados Financeiros →",
    "doc.ai_warnings": "Documentos aceitos com ressalvas",
    "doc.ai_replace": "Substituir Documentos",
    "doc.ai_proceed": "Prosseguir mesmo assim →",
    "doc.ai_problems": "Problemas encontrados nos documentos",
    "doc.ai_company_mismatch": "Empresa não confere",
    "doc.ai_ignore_proceed": "Ignorar e prosseguir →",
    "doc.no_previous": "sem registro anterior, será solicitado",
    "doc.ai_timeout": "Timeout — validação manual pela Tesouraria.",
    "doc.ai_fallback": "Não foi possível validar — prosseguindo.",
    "doc.ai_manual_required": "Validação manual necessária",
    "doc.ai_manual_required_desc": "A IA não conseguiu validar nenhum documento. Os documentos serão encaminhados para validação manual pela Tesouraria.",
    "doc.ai_proceed_manual": "Prosseguir — validação manual pela Tesouraria →",
    "doc.ai_manual_partial": "Validação parcial — alguns documentos requerem revisão manual",
    "doc.ai_manual_partial_desc": "Alguns documentos foram validados pela IA, mas outros não puderam ser analisados e serão encaminhados para validação manual.",
    "doc.ai_proceed_partial": "Prosseguir — pendentes serão validados manualmente →",
    "form.quarter_partial_data": "Ano {year}: preencha apenas os dados referentes ao(s) {quarters} já encerrado(s).",
    "doc.upload_first": "Suba ao menos um documento antes de validar."
  },

  // ════════════════════════════════════════════════════════════════════
  //  ENGLISH (US)
  // ════════════════════════════════════════════════════════════════════
  "en-US": {
    "nav.home": "Home",
    "nav.products": "Products",
    "nav.pricing": "Pricing",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.login": "Sign In",
    "nav.signup": "Sign Up",
    "nav.start_free": "Start Free",
    "nav.logout": "Sign Out",
    "nav.dashboard": "Dashboard",
    "nav.settings": "Settings",
    "nav.language": "Language",

    "auth.login": "Sign In",
    "auth.register": "Create Account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.confirm_password": "Confirm Password",
    "auth.forgot_password": "Forgot password?",
    "auth.name": "Full Name",
    "auth.company": "Company",
    "auth.title": "Job Title",
    "auth.company_id": "EIN",
    "auth.personal_id": "SSN",
    "auth.legal_name": "Legal Name",
    "auth.trade_name": "DBA (Doing Business As)",
    "auth.fill_all_fields": "Please fill in all fields.",
    "auth.invalid_company_id": "Invalid EIN.",
    "auth.invalid_personal_id": "Invalid SSN.",
    "auth.registration_success": "Account created! Check your email to verify.",
    "auth.login_error": "Invalid email or password.",
    "auth.access_portal": "Access Portal",
    "auth.identify": "Sign In",
    "auth.select_profile": "Select your profile to access the platform",
    "auth.left_tag": "B2B Credit Platform",
    "auth.left_h1": "Credit analysis",
    "auth.left_h2": "structured and auditable",
    "auth.left_h3": "for your business.",
    "auth.left_desc": "Proprietary quantitative engine, Anthropic Claude generative AI and data privacy compliance in a unified platform.",
    "auth.feat1_title": "Proprietary Algorithm",
    "auth.feat1_desc": "Scoring engine developed in-house — exclusive methodology, not replicable by competitors.",
    "auth.feat2_title": "Anthropic Generative AI",
    "auth.feat2_desc": "Claude analyzes narratives, auditor reports and qualitative factors with financial reasoning.",
    "auth.feat3_title": "Quantitative Rigor",
    "auth.feat3_desc": "Based on Altman, Merton-KMV, Basel II/III and market calibration.",
    "auth.card_analyst_title": "Analyst / Internal Team",
    "auth.card_analyst_desc": "Treasury, CFO, Board, Commercial and Approvers. Full access to credit analysis dashboard.",
    "auth.tag_new_analysis": "New Analysis",
    "auth.tag_portfolio": "Portfolio",
    "auth.tag_reports": "Reports",
    "auth.card_client_title": "Credit Applicant Company",
    "auth.card_client_desc": "Access via partner company invitation. Submit your data and documents for commercial credit analysis.",
    "auth.invite_only": "Invitation only access",

    "risk.title": "RiskMind — Credit Risk Analysis",
    "risk.subtitle": "B2B Credit Risk Platform powered by AI",
    "risk.new_application": "New Application",
    "risk.applications": "Applications",
    "risk.credit_analysis": "Credit Analysis",
    "risk.risk_score": "Risk Score",
    "risk.credit_limit": "Credit Limit",
    "risk.approval_status": "Approval Status",
    "risk.approved": "Approved",
    "risk.denied": "Denied",
    "risk.pending": "Pending",
    "risk.in_review": "Under Review",
    "risk.financial_docs": "Financial Documents",
    "risk.upload_docs": "Upload Documents",
    "risk.balance_sheet": "Balance Sheet",
    "risk.income_statement": "Income Statement",
    "risk.cash_flow": "Cash Flow Statement",
    "risk.equity_statement": "Stockholders' Equity Statement",

    "mia.title": "MIA — Financial Intelligence Assistant",
    "mia.greeting": "Hi! I'm MIA, your financial analysis assistant.",
    "mia.placeholder": "Ask about credit analysis, risk, markets...",
    "mia.analyzing": "Analyzing...",

    "plan.free": "Free",
    "plan.essential": "Essential",
    "plan.professional": "Professional",
    "plan.enterprise": "Enterprise",
    "plan.companies": "companies",
    "plan.users": "users",
    "plan.per_month": "/mo",
    "plan.start_free": "Start Free",
    "plan.subscribe": "Subscribe",
    "plan.contact_sales": "Contact Sales",

    "legal.terms": "Terms of Service",
    "legal.privacy": "Privacy Policy",
    "legal.data_protection": "CCPA/CPRA",
    "legal.contract": "Service Agreement",
    "legal.accept_terms": "I have read and accept the Terms + Privacy Policy",
    "legal.cookie_consent": "This site uses cookies to improve your experience.",

    "dash.overview": "Overview",
    "dash.total_applications": "Total Applications",
    "dash.approved_volume": "Approved Volume",
    "dash.avg_score": "Average Score",
    "dash.pending_review": "Pending Review",
    "dash.recent_activity": "Recent Activity",

    "role.client": "Client",
    "role.analyst": "Credit Analyst",
    "role.approver": "Credit Approver",
    "role.commercial": "Sales (CS)",
    "role.treasury": "Treasury",
    "role.manager": "Sales Manager",
    "role.director": "Business Director",
    "role.cfo": "CFO",
    "role.admin": "System Admin",

    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.edit": "Edit",
    "common.delete": "Delete",
    "common.search": "Search",
    "common.filter": "Filter",
    "common.export": "Export",
    "common.loading": "Loading...",
    "common.error": "Error",
    "common.success": "Success",
    "common.confirm": "Confirm",
    "common.back": "Back",
    "common.next": "Next",
    "common.yes": "Yes",
    "common.no": "No",
    "common.or": "or",
    "common.required": "Required",
    "common.optional": "Optional",

    "footer.powered_by": "Powered by Anthropic Claude · AWS",
    "footer.compliance": "CCPA Compliant",
    "footer.copyright": "© {year} Keymind Technology Inc.",

    // ── Landing Page ──
    "land.tag": "B2B Credit Risk Platform",
    "land.headline1": "Credit analysis",
    "land.headline_gold": "as precise",
    "land.headline2": "as your best",
    "land.headline3": "analysts.",
    "land.description": "Quantitative engine with Basel II, Altman Z-Score, KMV-Merton and Kanitz — powered by the proprietary RiskMind algorithm and exclusive models, interpreted by Claude Generative AI. Continuous learning with Mia intelligence.",
    "land.cta_free": "Start free — no credit card",
    "land.cta_login": "I already have an account →",
    "land.trial_info": "Free trial · 15 days · 2 companies · no credit card",
    "land.pill_basel": "Basel II Engine active",
    "land.pill_ifrs": "IFRS 16 · KMV-Merton",
    "land.pill_zscore": "Z-Score · Kanitz · Altman",
    "land.how_title": "How It Works",
    "land.how_subtitle": "From data input to report in 4 steps.",
    "land.pricing_title": "Plans",
    "land.pricing_subtitle": "Choose the ideal plan for your operation.",
    "land.faq_title": "Frequently Asked Questions",
    "land.footer_cta": "Start the most intelligent credit analysis today.",
    "land.nav_how": "How it works",
    "land.nav_plans": "Plans",

    // ── How It Works (steps) ──
    "land.how_tag": "How It Works",
    "land.how_head1": "From company ID to report in ",
    "land.how_head_gold": "3 steps",
    "land.how_sub2": "No spreadsheets. No manual calculations. No hours of work.",
    "land.how_s1_title": "Register the company",
    "land.how_s1_desc": "Enter the company ID and financial data. You can import income statements and balance sheets in PDF — our AI extracts the fields automatically.",
    "land.how_s2_title": "Quantitative engine runs",
    "land.how_s2_desc": "Basel II, Altman Z-Score, KMV-Merton, Kanitz and Damodaran analysis run simultaneously. PD, LGD, rating and credit limit calculated in seconds.",
    "land.how_s3_title": "Smart report ready",
    "land.how_s3_desc": "MIA (our AI analyst) interprets the results, identifies risks, explains the models and suggests credit limits with complete technical rationale.",

    // ── Pricing Section ──
    "land.price_tag": "Plans & Pricing",
    "land.price_head1": "Choose the right plan for ",
    "land.price_head_gold": "your operation",
    "land.price_sub": "Start free. Upgrade when needed. Cancel anytime.",
    "land.price_monthly": "Monthly",
    "land.price_annual": "Annual",
    "land.price_per_month": "/month",
    "land.price_billed_annual": "Billed annually",
    "land.price_free_period": "for 15 days · no credit card",
    "land.price_custom": "Custom pricing",
    "land.price_note": "All prices in USD · Company ID required for invoicing · Subject to annual adjustment",
    "land.price_currency": "$",

    // Plan names/desc/CTA
    "land.plan_free_name": "Free Trial",
    "land.plan_free_tag": "15 days",
    "land.plan_free_desc": "Free trial for 15 days. Full engine, no credit card required.",
    "land.plan_free_cta": "Start Free Trial",
    "land.plan_ess_name": "Essential",
    "land.plan_ess_desc": "For every company, advanced credit analysis",
    "land.plan_ess_cta": "Subscribe",
    "land.plan_pro_name": "Professional",
    "land.plan_pro_tag": "Most popular",
    "land.plan_pro_desc": "For analyses requiring advanced interpretation",
    "land.plan_pro_cta": "Subscribe",
    "land.plan_ent_name": "Enterprise",
    "land.plan_ent_desc": "For banks, funds, and credit platforms.",
    "land.plan_ent_cta": "Contact Sales",

    // Plan features
    "land.feat_cnpj_2": "2 companies for analysis",
    "land.feat_user_1": "1 user",
    "land.feat_engine": "Full risk engine",
    "land.feat_score": "Automated Score + Rating",
    "land.feat_mia_10": "MIA — 10 questions/month",
    "land.feat_no_history": "Latest analysis only (no history)",
    "land.feat_no_pdf": "No PDF export",
    "land.feat_corp_email": "Corporate email required",
    "land.feat_cnpj_15": "15 monitored companies",
    "land.feat_user_3": "3 users",
    "land.feat_history": "Full analysis history",
    "land.feat_pdf_unlim": "Unlimited PDF export",
    "land.feat_mia_limited": "MIA AI assistant (limited)",
    "land.feat_ticket": "Platform ticket support",
    "land.feat_sod": "SOD — segregation of duties",
    "land.feat_cnpj_75": "75 monitored companies",
    "land.feat_user_10": "10 users",
    "land.feat_tenant": "Dedicated tenant for your company",
    "land.feat_models": "Basel II · KMV-Merton · Z-Score · Kanitz",
    "land.feat_algo": "Proprietary RiskMind algorithm",
    "land.feat_prs": "PRS — Passive Risk Score (real-time, daily)",
    "land.feat_mia_adv": "MIA with portfolio context and advanced analysis",
    "land.feat_ticket2": "Platform ticket support",
    "land.feat_reports": "Custom reports",
    "land.feat_sod2": "SOD — segregation of duties",
    "land.feat_cnpj_unlim": "Unlimited companies",
    "land.feat_user_unlim": "Unlimited users",
    "land.feat_sla": "Contractual SLA",
    "land.feat_api": "API integration",
    "land.feat_vpc": "Dedicated environment (VPC)",
    "land.feat_onboard": "Onboarding and training",
    "land.feat_custom_models": "Custom model development",
    "land.feat_support_247": "24/7 support",

    // ── FAQ ──
    "land.faq_tag": "Frequently Asked Questions",
    "land.faq_head": "Frequently asked questions",
    "land.faq_q1": "Does the free plan require a credit card?",
    "land.faq_a1": "No. Create your account with a corporate email and start using it immediately. No credit card, no commitment.",
    "land.faq_q2": "What is a 'monitored company'?",
    "land.faq_a2": "Each company (counterparty) that you register and analyze on the platform. Each credit analysis uses one active company slot per month.",
    "land.faq_q3": "Can I cancel anytime?",
    "land.faq_a3": "Yes. Monthly plans can be canceled at any time without penalty. Annual plans offer a 2-month discount and are canceled at the end of the period.",
    "land.faq_q4": "Does RiskMind use real artificial intelligence?",
    "land.faq_a4": "Yes. The analytical engine is powered by Anthropic's Claude — the same generative AI model adopted by leading global financial institutions. Every analysis combines quantitative models (Basel II, Z-Score, KMV-Merton) with generative interpretation.",
    "land.faq_q5": "Is my financial data secure?",
    "land.faq_a5": "Your infrastructure runs 100% on AWS. Data at rest is encrypted (AES-256) and in transit (TLS 1.3). We never sell or share customer data.",
    "land.faq_q6": "Does the Enterprise plan include integration with internal systems?",
    "land.faq_a6": "Yes. We offer a documented REST API and support for integration with ERPs, origination systems and CRMs. Contact us to discuss your architecture.",

    // ── Backtest Section ──
    "land.bt_tag": "Scientific Validation",
    "land.bt_head1": "Backtest with ",
    "land.bt_head_gold": "192 companies from B3",
    "land.bt_desc": "Bilateral analysis with public data from 2015 to 2024. The RiskMind™ algorithm demonstrated superior discrimination and early warning of credit events.",
    "land.bt_m1_desc": "Ability to distinguish healthy from distressed companies",
    "land.bt_m2_desc": "Ranking power of the proprietary model",
    "land.bt_m3_desc": "Maximum separation between risk distributions",
    "land.bt_m4_label": "PD Ratio",
    "land.bt_m4_desc": "Relative risk between distressed and healthy companies",
    "land.bt_m5_value": "3 years",
    "land.bt_m5_label": "Early warning",
    "land.bt_m5_desc": "Early signaling of credit events",
    "land.bt_m6_value": "8 of 8",
    "land.bt_m6_label": "Accuracy",
    "land.bt_m6_desc": "Correct classification in all tested companies",
    "land.bt_check1": "100% public data",
    "land.bt_check2": "Replicable methodology",
    "land.bt_check3": "+19pp vs. logistic baseline",
    "land.bt_check4": "Period 2015–2024",
    "land.bt_cta": "View full study →",
    "land.bt_cta_sub": "Detailed case study with ROC curves, distributions and methodology",

    // ── Footer CTA ──
    "land.fcta_head1": "Ready to make ",
    "land.fcta_head_gold": "safer decisions",
    "land.fcta_desc": "Join the credit teams already using RiskMind.\nStart free in less than 2 minutes.",
    "land.fcta_btn": "Create free account →",
    "land.fcta_badge1": "No credit card",
    "land.fcta_badge2": "Free trial 15 days",
    "land.fcta_badge3": "Full engine available",

    // ── Landing Footer Badges ──
    "land.foot_b1": "Powered by Anthropic Claude",
    "land.foot_b2": "AWS São Paulo",
    "land.foot_b3": "LGPD Compliance",

    // ── Trust Badges / Highlights ──
    "land.trust_tag": "Infrastructure & Partners",
    "land.trust_h2": "Institutional-grade trust",
    "land.trust_more": "read more",
    "land.trust1_title": "Powered by Anthropic Claude",
    "land.trust1_sub": "Enterprise-grade generative AI",
    "land.trust1_detail": "RiskMind is powered by Anthropic's Claude — the same generative AI model adopted by leading global financial institutions, recognized for traceability, regulatory compliance, and ethical alignment.",
    "land.trust2_title": "AWS Infrastructure",
    "land.trust2_sub": "São Paulo · 99.9% uptime SLA",
    "land.trust2_detail": "100% AWS infrastructure in the sa-east-1 region (São Paulo). Data at rest with AES-256, transit TLS 1.3. Elastic Beanstalk + RDS PostgreSQL with automatic daily backups.",
    "land.trust3_title": "Financial Security",
    "land.trust3_sub": "LGPD · AES-256 Encryption",
    "land.trust3_detail": "LGPD compliance and financial-sector security best practices. JWT authentication, rate limiting, full access auditing, and immutable logs of all operations.",

    // ── Settings ──
    "cfg.title": "Settings",
    "cfg.users": "Users",
    "cfg.users_desc": "Manage team members and their access profiles.",
    "cfg.invites": "Invitations",
    "cfg.invites_desc": "Send invitations to new users.",
    "cfg.policy": "Credit Policy",
    "cfg.policy_desc": "Rules, limits, and approval thresholds.",
    "cfg.fiscal": "Fiscal Data",
    "cfg.fiscal_desc": "Tax ID, legal name, and tax regime.",
    "cfg.billing": "Billing",
    "cfg.billing_desc": "Plan, invoices, and payment method.",

    // ── Executive Dashboard ──
    "dash.exec_panel": "Credit Executive Dashboard",
    "dash.portfolio": "Portfolio",
    "dash.tickets": "Tickets",
    "dash.units": "Units",
    "dash.settings": "Settings",
    "dash.logout": "Logout",
    "dash.total_portfolio": "Total Portfolio",
    "dash.analyses": "analyses",
    "dash.approved": "Approved",
    "dash.active_credits": "active credits",
    "dash.conditional": "Conditional",
    "dash.with_caveats": "with caveats",
    "dash.pend_board": "Pend. Board",
    "dash.awaiting_decision": "awaiting decision",
    "dash.total_exposure": "Total Exposure",
    "dash.approved_limits": "approved limits",
    "dash.avg_pd": "Avg PD",
    "dash.avg_risk": "average portfolio risk",

    // ── SOD Controls ──
    "dash.sod_title": "SOD Controls",
    "dash.sod_sub": "Segregation of duties active in real time",
    "dash.sod_analyst": "Analyst ≠ Approver",
    "dash.sod_analyst_d": "Whoever analyzes cannot approve the same operation",
    "dash.sod_audit": "Audit Trail",
    "dash.sod_audit_d": "Immutable log of all actions and decisions",
    "dash.sod_review": "Peer Review",
    "dash.sod_review_d": "Analyses above threshold require dual verification",
    "dash.sod_models": "Independent Models",
    "dash.sod_models_d": "Calibration separate from credit operations",
    "dash.sod_limit": "Defined Thresholds",
    "dash.sod_limit_d": "Approval limits by hierarchical level",
    "dash.sod_compliance": "Continuous Compliance",
    "dash.sod_compliance_d": "24/7 monitoring with automatic alerts",

    // Portfolio/Dashboard
    "port.back": "← Back",
    "port.title": "Credit Portfolio",
    "port.consolidated": "Consolidated",
    "port.analyses": "analyses",
    "port.unique_clients": "unique clients",
    "port.updated": "Updated",
    "port.loading": "Loading detailed analysis data...",
    "port.total_analyses": "Total Analyses",
    "port.approved": "Approved",
    "port.full": "full",
    "port.conditional": "conditional",
    "port.rejected": "Rejected",
    "port.avg_pd": "Average PD Portfolio",
    "port.total_exposure": "Total Exposure",
    "port.approval_rate": "Approval Rate",
    "port.distribution": "Portfolio Distribution",
    "port.by_status": "By analysis status",
    "port.status_approved": "Approved",
    "port.status_conditional": "Conditional",
    "port.status_rejected": "Rejected",
    "port.status_analyzing": "Under Analysis",
    "port.status_pending": "Pending",
    "port.approval_rate_label": "Approval rate",
    "port.risk_radar": "Portfolio Risk Radar",
    "port.based_on": "Based on",
    "port.analyses_with_complete_data": "analysis(es) with complete data",
    "port.perform_credit_analyses_to_populate_radar": "Perform credit analyses to populate the radar",
    "port.radar_solvency": "Solvency",
    "port.radar_liquidity": "Liquidity",
    "port.radar_approval": "Approval",
    "port.radar_score": "Score",
    "port.radar_renewal": "Renewal",
    "port.radar_capital": "Capital",
    "port.no_data": "No data",
    "port.ratings_dist": "Ratings Distribution",
    "port.ratings_sub": "Based on internal PD → Rating model",
    "port.avg_pd_label": "Average PD",
    "port.avg_limit": "Average limit",
    "port.max_limit": "Maximum limit",
    "port.clients_with_renewal": "Clients with renewal",
    "port.pd_dist": "PD Distribution",
    "port.pd_by_range": "Probability of default by range",
    "port.avg_score_by_status": "Average Score by Status",
    "port.behavioral_financial_scorecard": "Behavioral + financial scorecard",
    "port.monthly_evolution": "Monthly Evolution — Approved Volume",
    "port.trend_last_6_months": "Trend of last 6 months",
    "port.pd_trend": "Average PD Evolution — Risk Trend",
    "port.pd_trend_sub": "Lower is better portfolio quality",
    "port.concentration": "Concentration by Subsidiary",
    "port.concentration_sub": "Exposure by business unit of the group (based on commercial allocation)",
    "port.unit_dash": "Dashboard by Business Unit",
    "port.units": "units",
    "port.unit": "unit",
    "port.with_recorded_analyses": "with recorded analyses",
    "port.table_unit": "Unit",
    "port.table_analyses": "Analyses",
    "port.table_approved": "Approved",
    "port.table_rejected": "Rejected",
    "port.table_exposure": "Exposure",
    "port.table_avg_pd": "Average PD",
    "port.table_avg_score": "Average Score",
    "port.table_approval_rate": "Approval Rate",
    "port.top_clients": "Top Clients by Limit",
    "port.top_clients_sub": "unique approved clients · sorted by limit",
    "port.table_company": "Company",
    "port.table_cnpj": "CNPJ",
    "port.table_limit": "Limit",
    "port.table_pd": "PD",
    "port.table_rating": "Rating",
    "port.table_status": "Status",
    "port.table_date": "Date",
    "port.no_approval_data": "No approval data",
    "port.consolidation_info": "Consolidated view includes all analyses. Filter by unit above for detailed analysis.",

    // ── Client Registration Form (ClientForm) ──
    "form.step_company": "Company",
    "form.step_documents": "Documents",
    "form.step_financial": "Financial",
    "form.step_confirmation": "Confirmation",
    "form.checking_registration": "Checking registration...",
    "form.registration_found": "Registration Found",
    "form.your_data_registered": "Your data is already registered in the system",
    "form.new_request_reuse_data": "For a new request, your data and valid documents will be reused. Just confirm if there are any changes.",
    "form.previous_docs_changes": "Documents from previous registration — any changes?",
    "form.no_changes": "No changes ✓",
    "form.update": "Update",
    "form.responsibility_statement": "Statement of Responsibility",
    "form.responsibility_text": "By keeping previous documents without updates, I declare that the information and documents are current, complete and without relevant changes. I am aware that providing false information constitutes a crime under law.",
    "form.confirm_and_continue": "Confirm and Continue",
    "form.new_registration": "New Registration",
    "form.no_previous_registration": "No previous registration found. Let's create your complete profile.",
    "form.get_started": "Get Started",
    "form.company_data": "Company Data",
    "form.cnpj_matrix": "Company CNPJ",
    "form.cnpj_linked_to_invite": "CNPJ linked to your invite — cannot be changed",
    "form.lookup": "Lookup",
    "form.federal_revenue_data": "Federal Revenue Data",
    "form.legal_name": "Legal Name",
    "form.legal_entity_type": "Legal Entity Type",
    "form.type_ltda": "Ltda / Eireli / ME",
    "form.type_sa": "S/A",
    "form.type_mei": "MEI",
    "form.industry_sector": "Industry Sector",
    "form.sector_logistics": "Logistics",
    "form.sector_transport": "Transport",
    "form.sector_industry": "Industry",
    "form.sector_commerce": "Commerce",
    "form.sector_services": "Services",
    "form.sector_agribusiness": "Agribusiness",
    "form.sector_technology": "Technology",
    "form.sector_others": "Others",
    "form.documents": "Documents - {type}",
    "form.docs_validated_automatically": "Documents are validated automatically by AI before proceeding. Items marked with * are required.",
    "form.after_upload_validate_docs": "After uploading all documents, click Validate Documents so AI can confirm they are correct and related to your company.",
    "form.multiple_files_accepted": "Multiple files accepted",
    "form.analyzing": "Analyzing...",
    "form.add_file": "+File",
    "form.upload": "Upload",
    "form.reused": "REUSED",
    "form.optional_comment_analysis": "Optional comment for analysis...",
    "form.required_docs_manual_validation": "* Required. Illegible documents will be validated manually by Treasury.",
    "form.financial_data": "Financial Data - 3 Years",
    "form.years": "Years",
    "form.fill_financial_data": "Fill in the values from the Balance Sheet and Income Statement. If financial documents were uploaded in the previous step (PDF), use the button below to attempt automatic extraction.",
    "form.first_time_financial_notice": "First-time registration? You must provide financial data for the last 3 completed fiscal years ({years}). Balance Sheet, Income Statement, and other financial statements are required for each year. Incomplete data may delay credit analysis.",
    "form.first_time_docs_notice": "For first-time registration, please upload financial documents (Balance Sheet, Income Statement, Trial Balance, SPED) for the last 3 completed fiscal years ({years}). This is essential for credit analysis.",
    "form.quarter_req_notice": "In addition to the 3 prior fiscal years, you must also provide partial data for {year} ({quarters}). Trial balance and interim statements for the closed period are required.",
    "form.quarter_req_docs_notice": "Also include partial documents for {year} ({quarters}) — trial balance and interim financial statements for the current fiscal year.",
    "form.pdf_extraction": "PDF Extraction",
    "form.pdf_extraction_desc": "Reads the native PDF text (Balance Sheet + Income Statement). Check and correct the extracted values.",
    "form.extracting": "Extracting...",
    "form.extract_from_pdf": "Extract from PDF",
    "form.extract_all_years": "Extract All Years from PDF",
    "form.upload_financial_first": "Upload financial documents first (Balance Sheet + Income Statement) in the documents step, then come back here.",
    "form.ai_partial_years": "Data extracted for: {found}.\n\nNot found in documents: {missing}.\nFill these years manually or upload the corresponding documents.",
    "form.ai_no_data_found": "Could not extract financial data from the documents. Verify that PDFs contain readable Balance Sheets or Income Statements and try again.",
    "form.extracted_fields": "Extracted {count} field(s) from PDF.",
    "form.verify_and_correct": "Verify and correct if necessary.",
    "form.confirm_and_send": "Confirm and Send",
    "form.request_sent_to_treasury": "Your request will enter the Treasury team queue. The commercial team (CS) will complete relationship data and volumes before credit analysis.",
    "form.company": "Company",
    "form.type": "Type",
    "form.files_uploaded": "Files uploaded",
    "form.sending": "Sending...",
    "form.send_request": "Send Request",

    // ── Financial Form (FinancialFormPeriod) ──
    "form.fin_field": "Field",
    "form.fin_previous": "Previous",
    "form.fin_new": "New ({period})",
    "form.fin_group_income_statement": "Income Statement",
    "form.fin_group_balance_sheet": "Balance Sheet",
    "form.fin_required_legend": "* Required · Values in R$ (whole reals) · Flow fields = period value | Stock = period-end balance",
    "form.fin_flow_vs_stock_warning": "📊 <strong>Flow</strong> fields (revenue, costs, result): period values. <strong>Stock</strong> fields (assets, liabilities, equity): period-end balance.",

    // ── Financial Fields (FINS_FIELDS) ──
    "form.fin_rev": "Net Revenue (after deductions)",
    "form.fin_cpv": "Cost of Products / Services (CPV/CSP)",
    "form.fin_desp_op": "Operating Expenses",
    "form.fin_desp_fin": "Financial Expenses (Interest paid)",
    "form.fin_lucro": "Net Result (Profit or Loss)",
    "form.fin_da": "Depreciation and Amortization (D&A)",
    "form.fin_ebitda_real": "EBITDA (if disclosed in Income Statement)",
    "form.fin_caixa": "Cash and Equivalents",
    "form.fin_ac": "Total Current Assets",
    "form.fin_pc": "Total Current Liabilities",
    "form.fin_at": "Total Assets",
    "form.fin_pt": "Total Liabilities",
    "form.fin_pl": "Total Equity",
    "form.fin_lucro_acum": "Accumulated Profits/Losses (Reserves)",
    "form.fin_div_cp": "Loans and Financing - Short Term (up to 12 months)",
    "form.fin_div_lp": "Loans and Financing - Long Term (over 12 months)",
    "form.fin_arrend_cp": "IFRS16 Leases - Short Term (liability)",
    "form.fin_arrend_lp": "IFRS16 Leases - Long Term (liability)",
    "form.fin_dou_uso": "Right of Use (IFRS16 asset)",
    "form.fin_pgto_lease": "Lease Payment in Period (optional)",

    // ── Tickets & Support ──
    "tkt.report_error": "Report Error",
    "tkt.suggest_improvement": "Suggest Improvement",
    "tkt.technical_support": "TECHNICAL SUPPORT",
    "tkt.credit_tickets": "CREDIT TICKETS",
    "tkt.support_technical": "Technical Support",
    "tkt.tickets_credit": "Credit Tickets",
    "tkt.new_ticket": "+ New Ticket",
    "tkt.credit_label": "🎫 Credit",
    "tkt.credit_desc": "Pending and documents",
    "tkt.support_label": "🐛 Support",
    "tkt.support_desc": "Errors and improvements",
    "tkt.status_all": "All",
    "tkt.status_open": "Open",
    "tkt.status_waiting": "Waiting",
    "tkt.status_replied": "Replied",
    "tkt.status_closed": "Closed",
    "tkt.loading": "Loading...",
    "tkt.no_error_reported": "You have not reported any errors or improvements yet",
    "tkt.no_ticket_found": "No ticket found",
    "tkt.new_reply": "● New reply",
    "tkt.awaiting_you": "⏳ Awaiting you",
    "tkt.pending_badge": "🎫 Pending Ticket",
    "tkt.avg_closure_time": "Average closure time:",
    "tkt.total_tickets": "total tickets",
    "tkt.days": "days",
    "tkt.send_error_report": "🐛 Send Report",
    "tkt.send_suggestion": "💡 Send Suggestion",
    "tkt.create_ticket": "🎫 Create Ticket",
    "tkt.sending": "Sending...",
    "tkt.sent_success": "✅ Sent! The Founder will be notified.",
    "tkt.ticket_created": "✅ Ticket created and client notified!",
    "tkt.back": "← Back",
    "tkt.requests": "Requests",

    // ── Ticket Detail ──
    "tkt.detail_header": "Requests",
    "tkt.open_tickets": "Open",
    "tkt.waiting_debtor": "Waiting",
    "tkt.replied_tickets": "Replied",
    "tkt.closed_tickets": "Closed",

    // ── Modal: Ticket Creation ──
    "modal.ticket_error_title": "Report Error",
    "modal.ticket_improvement_title": "Suggest Improvement",
    "modal.ticket_credit_title": "New Credit Ticket",
    "modal.sent_to_founder": "Sent to Founder · FNM-Tech code automatically generated",
    "modal.auto_code_generated": "FNM code automatically generated",
    "modal.type_label": "TYPE",
    "modal.priority_label": "PRIORITY",
    "modal.priority_low": "Low",
    "modal.priority_normal": "Normal",
    "modal.priority_high": "High",
    "modal.priority_urgent": "🔴 Urgent",
    "modal.company_label": "COMPANY / DEBTOR",
    "modal.company_placeholder": "Enter the company name or ID...",
    "modal.company_registered": "✓",
    "modal.title_label": "TITLE *",
    "modal.description_label": "DESCRIPTION",
    "modal.deadline_label": "DEADLINE",
    "modal.screenshot_label": "ERROR SCREENSHOT (optional)",
    "modal.click_to_attach": "📎 Click to attach image (max 5MB, images only)",
    "modal.attached": "📎",
    "modal.where_error_occurred": "WHERE ERROR OCCURRED / TITLE *",
    "modal.example_error": "Ex: 'Approve' button does not save",
    "modal.describe_problem": "DESCRIBE THE PROBLEM",
    "modal.steps_to_reproduce": "Steps to reproduce...",
    "modal.how_improvement": "HOW DO YOU IMAGINE THIS IMPROVEMENT?",
    "modal.improvement_details": "Feature details...",
    "modal.what_needed": "DESCRIPTION",
    "modal.detail_what": "Detail what needs to be sent...",
    "modal.cancel_button": "Cancel",

    // ── Modal: Request Update ──
    "modal.request_update_title": "Request update",
    "modal.request_recipients": "Recipients",
    "modal.request_loading_contacts": "Loading registered contacts…",
    "modal.request_no_contacts": "No contacts registered for this company ID. Enter the email below.",
    "modal.request_additional_email": "Add another email (optional)",
    "modal.request_error_invalid": "Invalid additional email.",
    "modal.request_error_none_selected": "Select at least one recipient.",
    "modal.request_info_text": "Each recipient will receive a unique and secure link (valid 24h) to fill in the data for",
    "modal.request_sending": "Sending…",
    "modal.request_send": "Send request →",
    "modal.request_success_title": "Request sent!",
    "modal.request_success_text": "Secure link sent to:",
    "modal.request_success_for": "for completion of",
    "modal.request_registered": "registered",

    // ── File Upload ──
    "upload.only_images": "❌ Images only are accepted",
    "upload.file_too_large": "❌ File too large (max 5MB)",
    "upload.drag_drop": "Drag and drop",
    "upload.select_file": "Select file",
    "upload.attach": "Attach",
    "upload.attached_file": "File attached",
    "upload.max_size": "max 5MB",
    "upload.image_only": "images only",

    // ── Checkout Modal ──
    "modal.checkout_title": "Subscribe to plan",
    "modal.checkout_redirect": "You will be redirected to Stripe for secure payment.",
    "modal.full_name": "Full name *",
    "modal.full_name_placeholder": "John Smith",
    "modal.company_cnpj": "Company ID *",
    "modal.company_cnpj_placeholder": "00.000.000/0001-00",
    "modal.cnpj_checking": "Checking Federal Revenue...",
    "modal.company_legal_name": "Name / Legal Name *",
    "modal.company_legal_placeholder": "Filled when entering the company ID",
    "modal.cpf_label": "Responsible's ID",
    "modal.cpf_placeholder": "000.000.000-00",
    "modal.job_title": "Job Title / Function",
    "modal.job_title_placeholder": "Ex: Financial Director",
    "modal.corporate_email": "Corporate email *",
    "modal.corporate_email_placeholder": "john@company.com",
    "modal.checkout_error": "⚠️ Error",
    "modal.already_exists_pending": "📧 Activation link resent",
    "modal.already_exists_active": "✅ Account already exists",
    "modal.domain_already_registered": "🏢 Company already registered",
    "modal.check_spam": "Also check the spam folder.",
    "modal.ask_admin": "To access RiskMind, ask your company administrator to go to Settings → Users and send you an invitation.",
    "modal.contract_accepted": "SaaS Contract + LGPD electronically accepted",
    "modal.undo_accept": "undo",
    "modal.read_sign_contract": "📄 Read and sign Contract + Privacy",
    "modal.required": "(required)",
    "modal.sending_text": "Sending…",
    "modal.close_login": "Close and login →",
    "unit.group": "Group",
    "unit.title": "Business Units",
    "unit.back": "← Back",
    "unit.view_portfolio": "📊 View in Portfolio",
    "unit.new": "+ New Unit",
    "unit.edit_title": "Edit Unit",
    "unit.new_title": "New Unit",
    "unit.name_label": "Name *",
    "unit.name_ph": "E.g.: company name or Tax ID...",
    "unit.cnpj_label": "Tax ID (optional)",
    "unit.desc_label": "Description (optional)",
    "unit.desc_ph": "E.g.: Logistics Division, North Unit...",
    "unit.credit_policy": "Credit Policy for this Unit",
    "unit.update_freq": "Update Frequency",
    "unit.quarterly": "Quarterly (3 months)",
    "unit.semiannual": "Semi-annual (6 months)",
    "unit.annual": "Annual (12 months)",
    "unit.min_interval": "Minimum Interval (months)",
    "unit.inherits_policy": "If not defined, inherits the group's default policy (Settings → Credit Policy).",
    "unit.name_required": "Name is required.",
    "unit.saving": "Saving...",
    "unit.save_changes": "Save Changes",
    "unit.register": "Register Unit",
    "unit.cancel": "Cancel",
    "unit.loading": "Loading units...",
    "unit.none": "No units registered",
    "unit.none_desc": "Set up the group's subsidiaries and divisions to view the credit portfolio by unit.",
    "unit.register_first": "+ Register First Unit",
    "unit.th_unit": "Unit",
    "unit.th_cnpj": "Tax ID",
    "unit.th_desc": "Description",
    "unit.th_policy": "Credit Policy",
    "unit.edit": "Edit",
    "unit.remove": "Remove",
    "unit.confirm_remove": "Remove \"{name}\"? This action cannot be undone.",
    "unit.inherits_default": "Inherits default",
    "unit.count": "{n} unit(s) registered",
    "unit.view_consolidated": "View consolidated portfolio",
    "unit.policy_info": "The Credit Update Policy is defined in Settings → Credit Policy.",
    "usr.back": "Back",
    "usr.title": "User Management",
    "usr.invite": "+ Invite User",
    "usr.invite_title": "Invite New User",
    "usr.invite_sub": "The user will receive an email with a link to create their password (valid for 72h)",
    "usr.name": "Full Name *",
    "usr.email": "Corporate Email *",
    "usr.position": "Position *",
    "usr.position_ph": "E.g.: Credit Analyst",
    "usr.access_profile": "Access Profile *",
    "usr.security_title": "🔒 Security — Password Creation by User",
    "usr.security_desc": "The invitation is sent via email with a secure one-time link.",
    "usr.security_pass": "The user will create their own password with at least 12 characters.",
    "usr.security_expire": "The link expires in 72 hours. If it expires, you can resend the invitation.",
    "usr.sod_title": "⚠ SOD PRINCIPLE — Segregation of Duties",
    "usr.role_analista": "Analyst: fills data, runs engine, generates report — CANNOT approve.",
    "usr.role_aprovador": "Approver: views result and decides — CANNOT alter analysis.",
    "usr.role_tesouraria": "Treasury: performs full analysis and approves — for lean teams.",
    "usr.role_cs": "CS + Treasury: commercial + analysis + approval — for companies without segregated structure.",
    "usr.role_cfo": "CFO/Director: read-only + review request — DO NOT interfere with analysis.",
    "usr.cancel": "Cancel",
    "usr.sending": "Sending invitation...",
    "usr.send_invite": "Send Invitation via Email",
    "usr.fill_required": "Please fill in name, email and position.",
    "usr.none": "No users found.",
    "usr.awaiting_setup": "Awaiting Setup",
    "usr.verified": "Verified",
    "usr.awaiting_password": "📧 Awaiting password creation via email",
    "usr.edit": "Edit",
    "usr.resend": "Resend Invitation",
    "usr.reactivate": "Reactivate",
    "usr.deactivate": "Deactivate",
    "usr.delete": "Delete",
    "usr.delete_title": "Delete User",
    "usr.delete_confirm": "Are you sure you want to delete",
    "usr.delete_irreversible": "This action is irreversible.",
    "usr.confirm_delete": "Confirm Deletion",
    "usr.edit_title": "Edit User",
    "usr.name_label": "NAME",
    "usr.position_label": "POSITION",
    "usr.access_label": "ACCESS PROFILE",
    "usr.admin_warning": "⚠ Full access — use only for testing and validation.",
    "usr.save": "Save changes",
    "usr.loading": "Loading...",
    "port2.risk_by_borrower": "Risk Analysis by Borrower",
    "port2.risk_by_borrower_sub": "Risk indicators per company receiving credit",
    "port2.risk_by_assignor": "Risk Analysis by Assignor",
    "port2.risk_by_assignor_sub": "Risk indicators grouped by business unit",
    "port2.no_unit_analysis": "No analysis by business unit",
    "port2.no_unit_desc": "Approved clients have no defined units/subsidiaries.",
    "port2.no_unit_desc2": "Credit risk is consolidated by company in the portfolio above.",
    "port2.risk_ranges": "Risk ranges: Green < 3% | Amber 3-12% | Red > 12%",
    "port2.score_avg": "Score 0–100 · Overall average:",
    "port2.pd_warning": "⚠️ Rising PD indicates worsening portfolio quality — monitor new clients with PD > 6%",
    "port2.exposure_concentration": "Exposure Concentration by Unit",
    "port2.exposure": "Exposure:",
    "port2.clients": "Clients:",
    "port2.avg_pd": "Average PD:",
    "port2.dominant_rating": "Dominant Rating:",
    "port2.client": "Client",
    "port2.validity": "Validity: Annual limit with automatic quarterly review.",
    "port2.immediate_review": "Immediate review:",
    "port2.review_text": "reserves the right to review, suspend or cancel credit limits at any time, without prior notice, at its sole discretion.",
    "port2.generated_at": "Analysis generated on",
    "port2.confidential": "Confidential",
    "port2.th_empresa": "Company",
    "port2.th_cnpj": "Tax ID",
    "port2.th_rating": "Rating",
    "port2.th_pd": "PD",
    "port2.th_score": "Score",
    "port2.th_limite": "Limit",
    "port2.th_unidade": "Unit",
    "port2.th_status": "Status",
    "port2.approved": "Approved",
    "port2.conditional": "Cond.",
    "port2.rejected": "Rejected",
    "common.all_rights": "All rights reserved",
    "common.confidential": "CONFIDENTIAL — INTERNAL USE",
    "common.ticket_pending": "🎫 Ticket Pending",
    "stat.approved": "Approved",
    "stat.conditional": "Conditional",
    "stat.rejected": "Rejected",
    "stat.pending": "Pending",
    "stat.awaiting": "Awaiting",
    "stat.in_analysis": "Under Analysis",
    "bill.active_users": "Active users",
    "bill.back_panel": "← Back to panel",
    "bill.billing_q": "Billing questions?",
    "bill.cnpjs_analyzed": "Tax IDs analyzed",
    "bill.cnpjs_available": "Tax IDs available in the trial period.",
    "bill.contact": "Contact us:",
    "bill.current_plan": "CURRENT PLAN",
    "bill.free_trial": "🎉 Free trial in progress",
    "bill.mia_queries": "MIA Queries",
    "bill.no_subscription": "No subscription",
    "bill.portal_info": "The subscription portal allows you to change cards, download invoices and cancel or upgrade the plan.",
    "bill.title": "Subscription & Billing",
    "bill.unlimited": "(unlimited)",
    "bill.usage_title": "PLAN USAGE — CURRENT CYCLE",
    "fiscal.address": "FISCAL ADDRESS",
    "fiscal.address_desc": "Automatically filled when looking up the Tax ID",
    "fiscal.city": "City",
    "fiscal.city_reg": "City Registration",
    "fiscal.cnpj": "Tax ID *",
    "fiscal.company_desc": "Required data for NF-e issuance on paid plans",
    "fiscal.company_id": "COMPANY IDENTIFICATION",
    "fiscal.complement": "Complement",
    "fiscal.district": "District",
    "fiscal.legal_name": "Legal Name *",
    "fiscal.nfe_info": "This data is used as the recipient in the automatic NF-e issuance for your subscriptions. Keep it updated to ensure fiscal validity.",
    "fiscal.number": "Number",
    "fiscal.save": "Save Fiscal Data",
    "fiscal.state": "State",
    "fiscal.state_reg": "State Registration",
    "fiscal.street": "Street",
    "fiscal.title": "Fiscal Data",
    "fiscal.trade_name": "Trade Name",
    "fiscal.zip": "Zip Code",
    "inv.new": "+ New Invitation",
    "inv.none": "No invitations sent",
    "inv.none_desc": "Click \"+ New Invitation\" to invite a company to register.",
    "inv.title": "Registration Invitations",
    "pol.alert_info": "Clients will receive automatic alerts when the update is near expiration.",
    "pol.annual_option": "Annual (every 12 months — minimum required)",
    "pol.min_interval": "Minimum Interval (months)",
    "pol.min_max": "Minimum: 3 months · Maximum: 12 months (required per year)",
    "pol.rule_desc": "Defines how often debtors must update financial data for credit renewal",
    "pol.rule_title": "FINANCIAL DATA UPDATE RULE",
    "pol.save": "Save Policy",
    "pol.title": "Credit Policy",
    "pol.unit_edit_info": "To set specific deadlines per unit, go to 🏢 Units in the main menu and edit each unit individually.",
    "pol.unit_inherit": "Business units inherit this default policy.",
    "pol.unit_policy": "POLICY BY BUSINESS UNIT",
    "pol.unit_policy_sub": "To define individual policies per subsidiary",
    "pol.update_freq": "Update Frequency",
    "port2.customers": "Clients:",
    "port2.footer": "RiskMind v2.0 · Analysis generated on",
    "port2.footer_confidential": "· Confidential",
    "port2.no_unit_desc1": "Approved clients have no defined units/subsidiaries.",
    "port2.predominant_rating": "Dominant rating:",
    "port2.th_company": "Company",
    "port2.th_customer": "Client",
    "port2.th_limit": "Limit",
    "port2.th_unit": "Unit",
    "port2.validity_annual": "Annual limit with automatic quarterly review.",
    "port2.validity_header": "Validity:",
    "port2.validity_rights": "reserves the right to review, suspend or cancel credit limits at any time, without prior notice, at its sole discretion.",
    "usr.invite_access_profile": "Access Profile *",
    "usr.invite_email": "Corporate Email *",
    "usr.invite_name": "Full Name *",
    "usr.invite_role": "Position *",
    "usr.label_access_profile": "ACCESS PROFILE",
    "usr.label_name": "NAME",
    "usr.label_role": "POSITION",
    "usr.resend_invite": "Resend Invitation",
    "usr.security_header": "Security — Password Creation by User",
    "usr.sending_invite": "Sending invitation...",
    "usr.sod_desc": "Analyst: fills data, runs engine, generates report — CANNOT approve. Approver: views result and decides — CANNOT alter analysis. Treasury: performs full analysis and approves — for lean teams. CS + Treasury: commercial + analysis + approval — for companies without segregated structure. CFO/Director: read-only + review request — DO NOT interfere with analysis.",
    "usr.sod_header": "SOD PRINCIPLE — Segregation of Duties",
    "bill.cnpjs": "Tax IDs analyzed",
    "bill.mia": "MIA Queries",
    "bill.users": "Active users",
    "bill.usage_label": "PLAN USAGE — CURRENT CYCLE",
    "bill.support_question": "Billing questions?",
    "fiscal.address_sub": "Automatically filled when looking up the Tax ID",
    "fiscal.id_company": "COMPANY IDENTIFICATION",
    "fiscal.id_sub": "Required data for NF-e issuance on paid plans",
    "fiscal.tax_usage": "This data is used as the recipient in the automatic NF-e issuance for your subscriptions. Keep it updated to ensure fiscal validity.",
    "fiscal.neighborhood": "Neighborhood",
    "inv.header": "Registration Invitations",
    "inv.new_invite": "+ New Invitation",
    "inv.no_invites": "No invitations sent",
    "pol.annual": "Annual (every 12 months — minimum required)",
    "pol.auto_alerts": "Clients will receive automatic alerts when the update is near expiration.",
    "pol.inheritance_note": "Business units inherit this default policy. To set specific deadlines per unit, go to Units in the main menu and edit each unit individually.",
    "pol.interval_info": "Minimum: 3 months · Maximum: 12 months (required per year)",
    "pol.per_unit": "POLICY BY BUSINESS UNIT",
    "usr.two_factor": "Two-factor authentication",
    "cfg.settings_label": "Settings",
    "inv.empty_hint": "Click \"+ New Invite\" to invite a company to register.",
    "inv.form_title": "Invite Debtor Company",
    "inv.lbl_cnpj": "Tax ID *",
    "inv.lbl_company": "Company Name *",
    "inv.lbl_contact_cpf": "Contact ID",
    "inv.lbl_contact_name": "Contact Name",
    "inv.lbl_email": "Corporate Email *",
    "inv.lbl_role": "Role / Position",
    "inv.ph_company": "Company name",
    "inv.ph_email": "contact@company.com",
    "inv.ph_name": "Full name",
    "inv.ph_role": "E.g.: CFO, Finance Director",
    "inv.resend": "Resend",
    "inv.searching": "Searching data...",
    "inv.submit_btn": "📨 Send Invite",
    "inv.submitting": "Submitting...",
    "inv.th_actions": "Actions",
    "inv.th_cnpj": "Tax ID",
    "inv.th_company": "Company",
    "inv.th_contact": "Contact",
    "inv.th_email": "Email",
    "inv.th_expires": "Expires",
    "inv.th_status": "Status",
    "pol.per_unit_sub": "To define individual policies per subsidiary",
    "pol.quarterly": "Quarterly (every 3 months)",
    "pol.rule_sub": "Defines how often debtors must update financial data for credit renewal",
    "pol.semiannual": "Semiannual (every 6 months)",
    "pol.saving": "Saving...",

    // ── Client Portal (cp.*) ──
    "cp.portal_title": "CLIENT PORTAL",
    "cp.credit_history": "My Credit History",
    "cp.logout": "Sign Out",
    "cp.new_application": "+ New Application",
    "cp.portfolio_stats": "Portfolio Statistics",
    "cp.credit_requests": "Credit Requests",
    "cp.support": "Support",
    "cp.loading": "Loading...",
    "cp.no_applications": "No applications yet",
    "cp.no_applications_hint": "Click \"+ New Application\" to get started",
    "cp.applications_count": "application(s)",
    "cp.limit_evolution": "LIMIT EVOLUTION",
    "cp.most_recent": "Most recent",
    "cp.waiting_cs": "Awaiting commercial completion (CS)",
    "cp.in_analysis_treasury": "Under review by Treasury",
    "cp.credit_letter": "Credit Letter",
    "cp.current_limit": "Current limit",
    "cp.limit_label": "Limit",
    "cp.status_approved": "Approved",
    "cp.status_conditional": "Conditional",
    "cp.status_rejected": "Rejected",
    "cp.status_in_analysis": "Under Review",
    "cp.status_waiting": "Pending",
    "cp.status_pending_board": "Pend. Board",
    "cp.status_pending_docs": "Pend. Docs",

    // ── Documents (doc.*) ──
    "doc.section_title": "DOCUMENTS",
    "doc.validation_intro": "Documents are validated automatically by AI before proceeding. Items marked with * are required.",
    "doc.validation_hint": "After uploading all documents, click Validate Documents so AI can confirm they are correct and related to your company.",
    "doc.required_note": "* Required. Illegible documents will be validated manually by Treasury.",
    "doc.upload": "Upload",
    "doc.multiple_files": "Multiple files accepted",
    "doc.validate_ai": "Validate Documents with AI",
    "doc.back": "Back",
    "doc.contract_amendments": "Articles of Incorporation + Amendments",
    "doc.contract_amendments_desc": "Upload the original contract + all amendments. Multiple files accepted.",
    "doc.meeting_minutes": "Meeting Minutes / Board Resolution",
    "doc.meeting_minutes_desc": "Board or partner meeting minutes with relevant resolutions.",
    "doc.balance_sheet_dre": "Balance Sheet + Income Statement",
    "doc.balance_sheet_dre_desc": "One file per year or all together. PDF and image accepted.",
    "doc.trial_balance": "Trial Balance (supplementary)",
    "doc.trial_balance_desc": "Useful for periods without finalized balance sheets or semi-annual renewals.",
    "doc.sped_accounting": "SPED Accounting / ECD / ECF",
    "doc.sped_accounting_desc": "SPED file generated by the accounting system.",
    "doc.cnd_federal": "Federal Tax Clearance (IRS)",
    "doc.cnd_federal_desc": "Certificate valid for 30 days. Expired certificate penalizes the score.",
    "doc.cnd_inss": "Social Security Clearance",
    "doc.cnd_inss_desc": "Social Security Compliance Certificate.",
    "doc.crf_fgts": "FGTS Clearance",
    "doc.crf_fgts_desc": "FGTS Compliance Certificate.",
    "doc.cndt_labor": "Labor Clearance Certificate",
    "doc.cndt_labor_desc": "Negative Certificate of Labor Debts.",
    "doc.audit_report": "Independent Audit Report",
    "doc.audit_report_desc": "Report signed by registered CVM/CFC auditor.",
    "doc.esg_report": "Sustainability / ESG Report",
    "doc.esg_report_desc": "GRI, SASB, Integrated Report or similar.",
    "doc.id_owners": "Owner/Partner ID Documents",
    "doc.id_owners_desc": "ID document of each managing partner.",
    "doc.bylaws": "Bylaws / Articles of Association",
    "doc.bylaws_desc": "Consolidated company bylaws.",
    "doc.board_election": "Board Election Minutes / AGM",
    "doc.board_election_desc": "General assembly minutes electing the current board.",
    "doc.balance_audited": "Audited Balance Sheet + Income Statement",
    "doc.balance_audited_desc": "Financial statements audited by an independent audit firm.",
    "doc.trial_balance_sa": "Trial Balances (supplementary)",
    "doc.trial_balance_sa_desc": "Interim trial balances for supplementary analysis.",
    "doc.sped_sa": "SPED Accounting / ECD",
    "doc.sped_sa_desc": "SPED file generated by the accounting system.",
    "doc.id_directors": "Director ID Documents",
    "doc.id_directors_desc": "ID document of each director.",
    "doc.mei_certificate": "MEI Certificate",
    "doc.mei_certificate_desc": "Individual Micro-Entrepreneur Status Certificate.",
    "doc.dasn_simei": "DASN-SIMEI",
    "doc.dasn_simei_desc": "Annual Simples Nacional Declaration.",
    "doc.id_holder": "Holder ID Document",
    "doc.id_holder_desc": "ID document of the MEI holder.",

    // ── AI Document Validation ──
    "doc.ai_analyzing": "Analyzing documents with Mia...",
    "doc.ai_checking": "Verifying authenticity and company match",
    "doc.ai_all_valid": "All documents validated successfully",
    "doc.ai_next_financial": "Next: Financial Data →",
    "doc.ai_warnings": "Documents accepted with caveats",
    "doc.ai_replace": "Replace Documents",
    "doc.ai_proceed": "Proceed anyway →",
    "doc.ai_problems": "Problems found in documents",
    "doc.ai_company_mismatch": "Company mismatch",
    "doc.ai_ignore_proceed": "Ignore and proceed →",
    "doc.no_previous": "no prior record, will be requested",
    "doc.ai_timeout": "Timeout — manual validation by Treasury.",
    "doc.ai_fallback": "Could not validate — proceeding.",
    "doc.ai_manual_required": "Manual validation required",
    "doc.ai_manual_required_desc": "AI could not validate any documents. Documents will be forwarded for manual validation by the Treasury team.",
    "doc.ai_proceed_manual": "Proceed — manual validation by Treasury →",
    "doc.ai_manual_partial": "Partial validation — some documents require manual review",
    "doc.ai_manual_partial_desc": "Some documents were validated by AI, but others could not be analyzed and will be forwarded for manual validation.",
    "doc.ai_proceed_partial": "Proceed — pending items will be validated manually →",
    "form.quarter_partial_data": "Year {year}: fill in data for the {quarters} already closed only.",
    "doc.upload_first": "Upload at least one document before validating."
  },

  // ════════════════════════════════════════════════════════════════════
  //  ESPAÑOL (MÉXICO)
  // ════════════════════════════════════════════════════════════════════
  "es-MX": {
    "nav.home": "Inicio",
    "nav.products": "Productos",
    "nav.pricing": "Precios",
    "nav.about": "Nosotros",
    "nav.contact": "Contacto",
    "nav.login": "Iniciar Sesión",
    "nav.signup": "Registrarse",
    "nav.start_free": "Comenzar Gratis",
    "nav.logout": "Cerrar Sesión",
    "nav.dashboard": "Panel",
    "nav.settings": "Configuración",
    "nav.language": "Idioma",

    "auth.login": "Iniciar Sesión",
    "auth.register": "Crear Cuenta",
    "auth.email": "Correo electrónico",
    "auth.password": "Contraseña",
    "auth.confirm_password": "Confirmar Contraseña",
    "auth.forgot_password": "¿Olvidó su contraseña?",
    "auth.name": "Nombre Completo",
    "auth.company": "Empresa",
    "auth.title": "Cargo",
    "auth.company_id": "RFC",
    "auth.personal_id": "CURP",
    "auth.legal_name": "Razón Social",
    "auth.trade_name": "Nombre Comercial",
    "auth.fill_all_fields": "Complete todos los campos.",
    "auth.invalid_company_id": "RFC inválido.",
    "auth.invalid_personal_id": "CURP inválida.",
    "auth.registration_success": "¡Cuenta creada! Revise su correo electrónico.",
    "auth.login_error": "Correo o contraseña incorrectos.",
    "auth.access_portal": "Portal de Acceso",
    "auth.identify": "Identifíquese",
    "auth.select_profile": "Seleccione su perfil para acceder a la plataforma",
    "auth.left_tag": "Plataforma B2B de Crédito",
    "auth.left_h1": "Análisis de crédito",
    "auth.left_h2": "estructurado y auditable",
    "auth.left_h3": "para su negocio.",
    "auth.left_desc": "Motor cuantitativo propio, IA generativa Anthropic Claude y cumplimiento de privacidad de datos en una plataforma unificada.",
    "auth.feat1_title": "Algoritmo Propietario",
    "auth.feat1_desc": "Motor de scoring desarrollado internamente — metodología exclusiva, no replicable por competidores.",
    "auth.feat2_title": "IA Generativa Anthropic",
    "auth.feat2_desc": "Claude analiza narrativas, informes de auditores y factores cualitativos con razonamiento financiero.",
    "auth.feat3_title": "Rigor Cuantitativo",
    "auth.feat3_desc": "Fundamentado en Altman, Merton-KMV, Basel II/III y calibración al mercado.",
    "auth.card_analyst_title": "Analista / Equipo Interno",
    "auth.card_analyst_desc": "Tesorería, CFO, Directiva, Comercial y Aprobadores. Acceso al panel completo de análisis de crédito.",
    "auth.tag_new_analysis": "Nuevo Análisis",
    "auth.tag_portfolio": "Portafolio",
    "auth.tag_reports": "Reportes",
    "auth.card_client_title": "Empresa Solicitante de Crédito",
    "auth.card_client_desc": "Acceso vía invitación de la empresa socia. Envíe sus datos y documentos para análisis de crédito comercial.",
    "auth.invite_only": "Acceso exclusivo por invitación",

    "risk.title": "RiskMind — Análisis de Riesgo Crediticio",
    "risk.subtitle": "Plataforma B2B de riesgo crediticio con IA",
    "risk.new_application": "Nueva Solicitud",
    "risk.applications": "Solicitudes",
    "risk.credit_analysis": "Análisis de Crédito",
    "risk.risk_score": "Score de Riesgo",
    "risk.credit_limit": "Límite de Crédito",
    "risk.approval_status": "Estado de Aprobación",
    "risk.approved": "Aprobado",
    "risk.denied": "Denegado",
    "risk.pending": "Pendiente",
    "risk.in_review": "En Revisión",
    "risk.financial_docs": "Documentos Financieros",
    "risk.upload_docs": "Subir Documentos",
    "risk.balance_sheet": "Balance General",
    "risk.income_statement": "Estado de Resultados",
    "risk.cash_flow": "Estado de Flujo de Efectivo",
    "risk.equity_statement": "Estado de Variaciones en el Capital Contable",

    "mia.title": "MIA — Asistente de Inteligencia Financiera",
    "mia.greeting": "¡Hola! Soy MIA, su asistente de análisis financiero.",
    "mia.placeholder": "Pregunte sobre análisis de crédito, riesgo, mercados...",
    "mia.analyzing": "Analizando...",

    "plan.free": "Gratuito",
    "plan.essential": "Esencial",
    "plan.professional": "Profesional",
    "plan.enterprise": "Enterprise",
    "plan.companies": "empresas",
    "plan.users": "usuarios",
    "plan.per_month": "/mes",
    "plan.start_free": "Comenzar Gratis",
    "plan.subscribe": "Suscribirse",
    "plan.contact_sales": "Contactar Ventas",

    "legal.terms": "Términos de Servicio",
    "legal.privacy": "Política de Privacidad",
    "legal.data_protection": "LFPDPPP",
    "legal.contract": "Contrato",
    "legal.accept_terms": "He leído y acepto los Términos + Política de Privacidad",
    "legal.cookie_consent": "Este sitio utiliza cookies para mejorar su experiencia.",

    "dash.overview": "Resumen",
    "dash.total_applications": "Total de Solicitudes",
    "dash.approved_volume": "Volumen Aprobado",
    "dash.avg_score": "Score Promedio",
    "dash.pending_review": "Pendientes de Revisión",
    "dash.recent_activity": "Actividad Reciente",

    "role.client": "Cliente",
    "role.analyst": "Analista de Crédito",
    "role.approver": "Aprobador de Crédito",
    "role.commercial": "Comercial (CS)",
    "role.treasury": "Tesorería",
    "role.manager": "Gerente Comercial",
    "role.director": "Director de Negocios",
    "role.cfo": "CFO",
    "role.admin": "Admin Sistema",

    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.edit": "Editar",
    "common.delete": "Eliminar",
    "common.search": "Buscar",
    "common.filter": "Filtrar",
    "common.export": "Exportar",
    "common.loading": "Cargando...",
    "common.error": "Error",
    "common.success": "Éxito",
    "common.confirm": "Confirmar",
    "common.back": "Volver",
    "common.next": "Siguiente",
    "common.yes": "Sí",
    "common.no": "No",
    "common.or": "o",
    "common.required": "Obligatorio",
    "common.optional": "Opcional",

    "footer.powered_by": "Powered by Anthropic Claude · AWS",
    "footer.compliance": "LFPDPPP Compliant",
    "footer.copyright": "© {year} Keymind Technology Inc.",

    // ── Landing Page ──
    "land.tag": "Plataforma de Riesgo de Crédito B2B",
    "land.headline1": "Análisis de crédito",
    "land.headline_gold": "tan preciso",
    "land.headline2": "como sus mejores",
    "land.headline3": "analistas.",
    "land.description": "Motor cuantitativo con Basel II, Z-Score de Altman, KMV-Merton y Kanitz — con algoritmo propietario RiskMind y modelos exclusivos, interpretados por la IA Generativa Claude. Aprendizaje continuo con la inteligencia Mia.",
    "land.cta_free": "Comenzar gratis — sin tarjeta",
    "land.cta_login": "Ya tengo cuenta →",
    "land.trial_info": "Prueba gratuita · 15 días · 2 empresas · sin tarjeta",
    "land.pill_basel": "Motor Basel II activo",
    "land.pill_ifrs": "IFRS 16 · KMV-Merton",
    "land.pill_zscore": "Z-Score · Kanitz · Altman",
    "land.how_title": "Cómo Funciona",
    "land.how_subtitle": "De la entrada de datos al informe en 4 pasos.",
    "land.pricing_title": "Planes",
    "land.pricing_subtitle": "Elija el plan ideal para su operación.",
    "land.faq_title": "Preguntas Frecuentes",
    "land.footer_cta": "Comience hoy el análisis de crédito más inteligente.",
    "land.nav_how": "Cómo funciona",
    "land.nav_plans": "Planes",

    // ── How It Works (steps) ──
    "land.how_tag": "Cómo Funciona",
    "land.how_head1": "Del RFC al dictamen en ",
    "land.how_head_gold": "3 pasos",
    "land.how_sub2": "Sin hojas de cálculo. Sin cálculos manuales. Sin horas de trabajo.",
    "land.how_s1_title": "Registre la empresa",
    "land.how_s1_desc": "Ingrese el RFC y los datos financieros de la contraparte. Puede importar estados financieros en PDF — la IA extrae los campos automáticamente.",
    "land.how_s2_title": "El motor cuantitativo analiza",
    "land.how_s2_desc": "Basel II, Z-Score de Altman, KMV-Merton, Kanitz y análisis de Damodaran se ejecutan simultáneamente. PD, LGD, rating y límite de crédito calculados en segundos.",
    "land.how_s3_title": "Dictamen inteligente listo",
    "land.how_s3_desc": "MIA (nuestra analista de IA) interpreta los resultados, identifica riesgos, explica los modelos y sugiere límite de crédito con fundamento técnico completo.",

    // ── Pricing Section ──
    "land.price_tag": "Planes y Precios",
    "land.price_head1": "Elija el plan adecuado para ",
    "land.price_head_gold": "su operación",
    "land.price_sub": "Comience gratis. Actualice cuando necesite. Cancele cuando quiera.",
    "land.price_monthly": "Mensual",
    "land.price_annual": "Anual",
    "land.price_per_month": "/mes",
    "land.price_billed_annual": "Cobro anual",
    "land.price_free_period": "por 15 días · sin tarjeta",
    "land.price_custom": "Bajo consulta",
    "land.price_note": "Todos los precios en MXN · RFC obligatorio para facturación · Sujeto a ajuste anual",
    "land.price_currency": "MX$",

    // Plan names/desc/CTA
    "land.plan_free_name": "Prueba Gratuita",
    "land.plan_free_tag": "15 días",
    "land.plan_free_desc": "Prueba gratuita por 15 días. Motor completo sin tarjeta de crédito.",
    "land.plan_free_cta": "Comenzar Prueba Gratuita",
    "land.plan_ess_name": "Esencial",
    "land.plan_ess_desc": "Para toda empresa, análisis de crédito avanzado",
    "land.plan_ess_cta": "Suscribirse",
    "land.plan_pro_name": "Profesional",
    "land.plan_pro_tag": "Más popular",
    "land.plan_pro_desc": "Para análisis que requieran interpretación avanzada",
    "land.plan_pro_cta": "Suscribirse",
    "land.plan_ent_name": "Enterprise",
    "land.plan_ent_desc": "Para bancos, fondos y plataformas de crédito.",
    "land.plan_ent_cta": "Contactar Ventas",

    // Plan features
    "land.feat_cnpj_2": "2 empresas para análisis",
    "land.feat_user_1": "1 usuario",
    "land.feat_engine": "Motor de riesgo completo",
    "land.feat_score": "Score + Rating automatizado",
    "land.feat_mia_10": "MIA — 10 preguntas/mes",
    "land.feat_no_history": "Solo último análisis (sin historial)",
    "land.feat_no_pdf": "Sin exportación PDF",
    "land.feat_corp_email": "Correo corporativo obligatorio",
    "land.feat_cnpj_15": "15 empresas monitoreadas",
    "land.feat_user_3": "3 usuarios",
    "land.feat_history": "Historial completo de análisis",
    "land.feat_pdf_unlim": "Exportación PDF ilimitada",
    "land.feat_mia_limited": "MIA asistente IA (limitado)",
    "land.feat_ticket": "Soporte por ticket en plataforma",
    "land.feat_sod": "SOD — segregación de funciones",
    "land.feat_cnpj_75": "75 empresas monitoreadas",
    "land.feat_user_10": "10 usuarios",
    "land.feat_tenant": "Tenant dedicado para su empresa",
    "land.feat_models": "Basel II · KMV-Merton · Z-Score · Kanitz",
    "land.feat_algo": "Algoritmo propietario RiskMind",
    "land.feat_prs": "PRS — Passive Risk Score (tiempo real, diario)",
    "land.feat_mia_adv": "MIA con contexto de cartera y análisis avanzado",
    "land.feat_ticket2": "Soporte por ticket en plataforma",
    "land.feat_reports": "Reportes personalizados",
    "land.feat_sod2": "SOD - segregación de funciones",
    "land.feat_cnpj_unlim": "Empresas ilimitadas",
    "land.feat_user_unlim": "Usuarios ilimitados",
    "land.feat_sla": "SLA contractual",
    "land.feat_api": "Integración vía API",
    "land.feat_vpc": "Ambiente dedicado (VPC)",
    "land.feat_onboard": "Onboarding y capacitación",
    "land.feat_custom_models": "Personalización de modelos",
    "land.feat_support_247": "Soporte 24/7",

    // ── FAQ ──
    "land.faq_tag": "Dudas Frecuentes",
    "land.faq_head": "Preguntas frecuentes",
    "land.faq_q1": "¿El plan gratuito requiere tarjeta de crédito?",
    "land.faq_a1": "No. Cree su cuenta con correo corporativo y comience a usar inmediatamente. Sin tarjeta, sin compromiso.",
    "land.faq_q2": "¿Qué es una 'empresa monitoreada'?",
    "land.faq_a2": "Es cada empresa (contraparte) que registra y analiza en la plataforma. Cada análisis de crédito consume un slot de empresa activa al mes.",
    "land.faq_q3": "¿Puedo cancelar en cualquier momento?",
    "land.faq_a3": "Sí. Planes mensuales pueden cancelarse en cualquier momento sin penalización. Planes anuales ofrecen descuento de 2 meses y se cancelan al término del período.",
    "land.faq_q4": "¿RiskMind usa inteligencia artificial real?",
    "land.faq_a4": "Sí. El motor analítico está alimentado por Claude de Anthropic — el mismo modelo de IA generativa adoptado por instituciones financieras líderes globales. Todo análisis combina modelos cuantitativos (Basel II, Z-Score, KMV-Merton) con interpretación generativa.",
    "land.faq_q5": "¿Mis datos financieros están seguros?",
    "land.faq_a5": "Su infraestructura corre 100% en AWS. Datos en reposo cifrados (AES-256) y en tránsito (TLS 1.3). Nunca vendemos ni compartimos datos de clientes.",
    "land.faq_q6": "¿El plan Enterprise incluye integración con sistemas internos?",
    "land.faq_a6": "Sí. Ofrecemos API REST documentada y soporte para integración con ERPs, sistemas de originación y CRMs. Contáctenos para discutir su arquitectura.",

    // ── Backtest Section ──
    "land.bt_tag": "Validación Científica",
    "land.bt_head1": "Backtest con ",
    "land.bt_head_gold": "192 empresas de la B3",
    "land.bt_desc": "Análisis bilateral con datos públicos de 2015 a 2024. El algoritmo RiskMind™ demostró capacidad superior de discriminación y anticipación de eventos crediticios.",
    "land.bt_m1_desc": "Capacidad de distinguir empresas sanas de distressed",
    "land.bt_m2_desc": "Poder de ordenación del modelo propietario",
    "land.bt_m3_desc": "Separación máxima entre distribuciones de riesgo",
    "land.bt_m4_label": "Razón PD",
    "land.bt_m4_desc": "Riesgo relativo entre empresas distressed y sanas",
    "land.bt_m5_value": "3 años",
    "land.bt_m5_label": "Anticipación",
    "land.bt_m5_desc": "Señalización anticipada de eventos crediticios",
    "land.bt_m6_value": "8 de 8",
    "land.bt_m6_label": "Acierto",
    "land.bt_m6_desc": "Clasificación correcta en todas las empresas probadas",
    "land.bt_check1": "100% datos públicos",
    "land.bt_check2": "Metodología replicable",
    "land.bt_check3": "+19pp vs. baseline logístico",
    "land.bt_check4": "Período 2015–2024",
    "land.bt_cta": "Ver estudio completo →",
    "land.bt_cta_sub": "Estudio detallado con curvas ROC, distribuciones y metodología",

    // ── Footer CTA ──
    "land.fcta_head1": "¿Listo para tomar decisiones ",
    "land.fcta_head_gold": "más seguras",
    "land.fcta_desc": "Únase a los equipos de crédito que ya usan RiskMind.\nComience gratis en menos de 2 minutos.",
    "land.fcta_btn": "Crear cuenta gratuita →",
    "land.fcta_badge1": "Sin tarjeta de crédito",
    "land.fcta_badge2": "Prueba gratis 15 días",
    "land.fcta_badge3": "Motor completo disponible",

    // ── Landing Footer Badges ──
    "land.foot_b1": "Powered by Anthropic Claude",
    "land.foot_b2": "AWS São Paulo",
    "land.foot_b3": "Cumplimiento LGPD",

    // ── Trust Badges / Destacados ──
    "land.trust_tag": "Infraestructura y Socios",
    "land.trust_h2": "Confianza de nivel institucional",
    "land.trust_more": "leer más",
    "land.trust1_title": "Powered by Anthropic Claude",
    "land.trust1_sub": "IA generativa con seguridad empresarial",
    "land.trust1_detail": "RiskMind está impulsado por Claude de Anthropic — el mismo modelo de IA generativa adoptado por instituciones financieras líderes a nivel mundial, reconocido por trazabilidad, cumplimiento regulatorio y alineamiento ético.",
    "land.trust2_title": "AWS Infrastructure",
    "land.trust2_sub": "São Paulo · 99.9% uptime SLA",
    "land.trust2_detail": "Infraestructura 100% AWS en la región sa-east-1 (São Paulo). Datos en reposo con AES-256, tránsito TLS 1.3. Elastic Beanstalk + RDS PostgreSQL con respaldos automáticos diarios.",
    "land.trust3_title": "Seguridad Financiera",
    "land.trust3_sub": "LGPD · Cifrado AES-256",
    "land.trust3_detail": "Cumplimiento con LGPD y mejores prácticas de seguridad del sector financiero. Autenticación JWT, rate limiting, auditoría completa de accesos y logs inmutables de todas las operaciones.",

    // ── Configuración ──
    "cfg.title": "Configuración",
    "cfg.users": "Usuarios",
    "cfg.users_desc": "Administre los miembros y sus perfiles de acceso.",
    "cfg.invites": "Invitaciones",
    "cfg.invites_desc": "Envíe invitaciones a nuevos usuarios.",
    "cfg.policy": "Política de Crédito",
    "cfg.policy_desc": "Reglas, límites y niveles de aprobación.",
    "cfg.fiscal": "Datos Fiscales",
    "cfg.fiscal_desc": "RFC, razón social y régimen fiscal.",
    "cfg.billing": "Facturación",
    "cfg.billing_desc": "Plan, facturas y forma de pago.",

    // ── Panel Ejecutivo ──
    "dash.exec_panel": "Panel Ejecutivo de Crédito",
    "dash.portfolio": "Portafolio",
    "dash.tickets": "Tickets",
    "dash.units": "Unidades",
    "dash.settings": "Configuración",
    "dash.logout": "Salir",
    "dash.total_portfolio": "Portafolio Total",
    "dash.analyses": "análisis",
    "dash.approved": "Aprobados",
    "dash.active_credits": "créditos activos",
    "dash.conditional": "Condicionados",
    "dash.with_caveats": "con observaciones",
    "dash.pend_board": "Pend. Comité",
    "dash.awaiting_decision": "en espera de decisión",
    "dash.total_exposure": "Exposición Total",
    "dash.approved_limits": "límites aprobados",
    "dash.avg_pd": "PD Promedio",
    "dash.avg_risk": "riesgo promedio del portafolio",

    // ── Controles SOD ──
    "dash.sod_title": "Controles SOD",
    "dash.sod_sub": "Segregación de funciones activa en tiempo real",
    "dash.sod_analyst": "Analista ≠ Aprobador",
    "dash.sod_analyst_d": "Quien analiza no puede aprobar la misma operación",
    "dash.sod_audit": "Pista de Auditoría",
    "dash.sod_audit_d": "Registro inmutable de todas las acciones y decisiones",
    "dash.sod_review": "Revisión por Pares",
    "dash.sod_review_d": "Análisis por encima del límite requieren doble verificación",
    "dash.sod_models": "Modelos Independientes",
    "dash.sod_models_d": "Calibración separada de la operación de crédito",
    "dash.sod_limit": "Niveles Definidos",
    "dash.sod_limit_d": "Límites de aprobación por nivel jerárquico",
    "dash.sod_compliance": "Cumplimiento Continuo",
    "dash.sod_compliance_d": "Monitoreo 24/7 con alertas automáticas",

    // Portfolio/Dashboard
    "port.back": "← Atrás",
    "port.title": "Cartera de Crédito",
    "port.consolidated": "Consolidado",
    "port.analyses": "análisis",
    "port.unique_clients": "clientes únicos",
    "port.updated": "Actualizado",
    "port.loading": "Cargando datos detallados del análisis...",
    "port.total_analyses": "Total de Análisis",
    "port.approved": "Aprobado",
    "port.full": "integral",
    "port.conditional": "condicional",
    "port.rejected": "Rechazado",
    "port.avg_pd": "PD Promedio Cartera",
    "port.total_exposure": "Exposición Total",
    "port.approval_rate": "Tasa de Aprobación",
    "port.distribution": "Distribución de Cartera",
    "port.by_status": "Por estado de análisis",
    "port.status_approved": "Aprobado",
    "port.status_conditional": "Condicional",
    "port.status_rejected": "Rechazado",
    "port.status_analyzing": "En Análisis",
    "port.status_pending": "Pendiente",
    "port.approval_rate_label": "Tasa aprobación",
    "port.risk_radar": "Radar de Riesgo de Cartera",
    "port.based_on": "Basado en",
    "port.analyses_with_complete_data": "análisis(s) con datos completos",
    "port.perform_credit_analyses_to_populate_radar": "Realice análisis de crédito para completar el radar",
    "port.radar_solvency": "Solvencia",
    "port.radar_liquidity": "Liquidez",
    "port.radar_approval": "Aprobación",
    "port.radar_score": "Puntuación",
    "port.radar_renewal": "Renovación",
    "port.radar_capital": "Capital",
    "port.no_data": "Sin datos",
    "port.ratings_dist": "Distribución de Calificaciones",
    "port.ratings_sub": "Basado en modelo interno PD → Calificación",
    "port.avg_pd_label": "PD Promedio",
    "port.avg_limit": "Límite promedio",
    "port.max_limit": "Límite máximo",
    "port.clients_with_renewal": "Clientes con renovación",
    "port.pd_dist": "Distribución PD",
    "port.pd_by_range": "Probabilidad de incumplimiento por rango",
    "port.avg_score_by_status": "Puntuación Promedio por Estado",
    "port.behavioral_financial_scorecard": "Scorecard conductual + financiero",
    "port.monthly_evolution": "Evolución Mensual — Volumen Aprobado",
    "port.trend_last_6_months": "Tendencia de últimos 6 meses",
    "port.pd_trend": "Evolución PD Promedio — Tendencia de Riesgo",
    "port.pd_trend_sub": "Cuanto menor, mejor calidad de cartera",
    "port.concentration": "Concentración por Subsidiaria",
    "port.concentration_sub": "Exposición por unidad de negocio del grupo (basada en asignación comercial)",
    "port.unit_dash": "Panel de Control por Unidad de Negocio",
    "port.units": "unidades",
    "port.unit": "unidad",
    "port.with_recorded_analyses": "con análisis registrados",
    "port.table_unit": "Unidad",
    "port.table_analyses": "Análisis",
    "port.table_approved": "Aprobado",
    "port.table_rejected": "Rechazado",
    "port.table_exposure": "Exposición",
    "port.table_avg_pd": "PD Promedio",
    "port.table_avg_score": "Puntuación Promedio",
    "port.table_approval_rate": "Tasa Aprob.",
    "port.top_clients": "Top Clientes por Límite",
    "port.top_clients_sub": "clientes únicos aprobados · ordenados por límite",
    "port.table_company": "Empresa",
    "port.table_cnpj": "RFC",
    "port.table_limit": "Límite",
    "port.table_pd": "PD",
    "port.table_rating": "Calificación",
    "port.table_status": "Estado",
    "port.table_date": "Fecha",
    "port.no_approval_data": "Sin datos de aprobación",
    "port.consolidation_info": "La vista consolidada incluye todos los análisis. Filtre por unidad arriba para análisis detallado.",

    // ── Formulario de Registro de Cliente (ClientForm) ──
    "form.step_company": "Empresa",
    "form.step_documents": "Documentos",
    "form.step_financial": "Financiero",
    "form.step_confirmation": "Confirmación",
    "form.checking_registration": "Verificando registro...",
    "form.registration_found": "Registro Encontrado",
    "form.your_data_registered": "Sus datos ya están registrados en el sistema",
    "form.new_request_reuse_data": "Para una nueva solicitud, se reutilizarán sus datos y documentos válidos. Solo confirme si hay cambios.",
    "form.previous_docs_changes": "Documentos del registro anterior — ¿hay cambios?",
    "form.no_changes": "Sin cambios ✓",
    "form.update": "Actualizar",
    "form.responsibility_statement": "Declaración de Responsabilidad",
    "form.responsibility_text": "Al mantener documentos anteriores sin actualización, declaro que la información y los documentos están vigentes, completos y sin cambios relevantes. Soy consciente de que proporcionar información falsa constituye un delito según la ley.",
    "form.confirm_and_continue": "Confirmar y Continuar",
    "form.new_registration": "Nuevo Registro",
    "form.no_previous_registration": "No se encontró registro anterior. Vamos a crear su perfil completo.",
    "form.get_started": "Comenzar",
    "form.company_data": "Datos de la Empresa",
    "form.cnpj_matrix": "RFC Empresarial",
    "form.cnpj_linked_to_invite": "RFC vinculado a su invitación — no se puede cambiar",
    "form.lookup": "Consultar",
    "form.federal_revenue_data": "Datos de Hacienda",
    "form.legal_name": "Razón Social",
    "form.legal_entity_type": "Tipo de Entidad Legal",
    "form.type_ltda": "Ltda / Eireli / ME",
    "form.type_sa": "S/A",
    "form.type_mei": "MEI",
    "form.industry_sector": "Sector Industrial",
    "form.sector_logistics": "Logística",
    "form.sector_transport": "Transporte",
    "form.sector_industry": "Industria",
    "form.sector_commerce": "Comercio",
    "form.sector_services": "Servicios",
    "form.sector_agribusiness": "Agronegocios",
    "form.sector_technology": "Tecnología",
    "form.sector_others": "Otros",
    "form.documents": "Documentos - {type}",
    "form.docs_validated_automatically": "Los documentos se validan automáticamente con IA antes de continuar. Los elementos marcados con * son obligatorios.",
    "form.after_upload_validate_docs": "Después de cargar todos los documentos, haga clic en Validar Documentos para que la IA confirme que son correctos y relacionados con su empresa.",
    "form.multiple_files_accepted": "Se aceptan múltiples archivos",
    "form.analyzing": "Analizando...",
    "form.add_file": "+Archivo",
    "form.upload": "Cargar",
    "form.reused": "REUTILIZADO",
    "form.optional_comment_analysis": "Comentario opcional para el análisis...",
    "form.required_docs_manual_validation": "* Obligatorios. Los documentos ilegibles serán validados manualmente por Tesorería.",
    "form.financial_data": "Datos Financieros - 3 Años",
    "form.years": "Años",
    "form.fill_financial_data": "Rellene con valores del Balance General y Estado de Resultados. Si documentos financieros se cargaron en etapa anterior (PDF), use el botón abajo para intentar extracción automática.",
    "form.first_time_financial_notice": "¿Primer registro? Es obligatorio completar los datos financieros de los 3 últimos ejercicios cerrados ({years}). Balance General, Estado de Resultados y demás estados financieros deben ser proporcionados para cada año. Datos incompletos pueden retrasar el análisis de crédito.",
    "form.first_time_docs_notice": "Para el primer registro, cargue los documentos financieros (Balance, Estado de Resultados, Balanza de Comprobación, SPED) de los 3 últimos ejercicios cerrados ({years}). Esto es esencial para el análisis de crédito.",
    "form.quarter_req_notice": "Además de los 3 ejercicios anteriores, es necesario enviar también los datos parciales de {year} ({quarters}). Balanza de comprobación y estados intermedios del período cerrado son obligatorios.",
    "form.quarter_req_docs_notice": "Incluya también los documentos parciales de {year} ({quarters}) — balanza de comprobación y estados financieros intermedios del ejercicio en curso.",
    "form.pdf_extraction": "Extracción PDF",
    "form.pdf_extraction_desc": "Lee el texto nativo del PDF (Balance + Estado de Resultados). Verifique y corrija los valores extraídos.",
    "form.extracting": "Extrayendo...",
    "form.extract_from_pdf": "Extraer del PDF",
    "form.extract_all_years": "Extraer Todos los Años del PDF",
    "form.upload_financial_first": "Suba los documentos financieros primero (Balance + Estado de Resultados) en la etapa de documentos, luego vuelva aquí.",
    "form.ai_partial_years": "Datos extraídos para: {found}.\n\nNo encontrados en documentos: {missing}.\nComplete esos años manualmente o suba los documentos correspondientes.",
    "form.ai_no_data_found": "No se pudieron extraer datos financieros de los documentos. Verifique que los PDFs contengan Balance General o Estado de Resultados legibles e intente de nuevo.",
    "form.extracted_fields": "Extraídos {count} campo(s) del PDF.",
    "form.verify_and_correct": "Verifique y corrija si es necesario.",
    "form.confirm_and_send": "Confirmar y Enviar",
    "form.request_sent_to_treasury": "Su solicitud entrará en la cola del equipo de Tesorería. El equipo comercial (CS) completará datos de relación y volúmenes antes del análisis de crédito.",
    "form.company": "Empresa",
    "form.type": "Tipo",
    "form.files_uploaded": "Archivos cargados",
    "form.sending": "Enviando...",
    "form.send_request": "Enviar Solicitud",

    // ── Formulario Financiero (FinancialFormPeriod) ──
    "form.fin_field": "Campo",
    "form.fin_previous": "Anterior",
    "form.fin_new": "Nuevo ({period})",
    "form.fin_group_income_statement": "Estado de Resultados",
    "form.fin_group_balance_sheet": "Balance General",
    "form.fin_required_legend": "* Obligatorios · Valores en MXN (pesos mexicanos enteros) · Campos de flujo = valor del período | Stock = saldo al final del período",
    "form.fin_flow_vs_stock_warning": "📊 Campos de <strong>flujo</strong> (ingresos, costos, resultado): valores del período. Campos de <strong>stock</strong> (activos, pasivos, patrimonio): saldo al final del período.",

    // ── Campos Financieros (FINS_FIELDS) ──
    "form.fin_rev": "Ingresos Netos (después de deducciones)",
    "form.fin_cpv": "Costo de Productos / Servicios (CPV/CSP)",
    "form.fin_desp_op": "Gastos Operacionales",
    "form.fin_desp_fin": "Gastos Financieros (Intereses pagados)",
    "form.fin_lucro": "Resultado Neto (Ganancia o Pérdida)",
    "form.fin_da": "Depreciación y Amortización (D&A)",
    "form.fin_ebitda_real": "EBITDA (si se divulga en Estado de Resultados)",
    "form.fin_caixa": "Efectivo y Equivalentes",
    "form.fin_ac": "Total Activo Circulante",
    "form.fin_pc": "Total Pasivo Circulante",
    "form.fin_at": "Total Activos",
    "form.fin_pt": "Total Pasivos",
    "form.fin_pl": "Patrimonio Total",
    "form.fin_lucro_acum": "Ganancias/Pérdidas Acumuladas (Reservas)",
    "form.fin_div_cp": "Préstamos y Financiamientos - Corto Plazo (hasta 12 meses)",
    "form.fin_div_lp": "Préstamos y Financiamientos - Largo Plazo (más de 12 meses)",
    "form.fin_arrend_cp": "Arrendamientos IFRS16 - Corto Plazo (pasivo)",
    "form.fin_arrend_lp": "Arrendamientos IFRS16 - Largo Plazo (pasivo)",
    "form.fin_dou_uso": "Derecho de Uso (activo IFRS16)",
    "form.fin_pgto_lease": "Pago de Arrendamiento en Período (opcional)",

    // ── Tickets & Support ──
    "tkt.report_error": "Reportar Error",
    "tkt.suggest_improvement": "Sugerir Mejora",
    "tkt.technical_support": "SOPORTE TÉCNICO",
    "tkt.credit_tickets": "TICKETS DE CRÉDITO",
    "tkt.support_technical": "Soporte Técnico",
    "tkt.tickets_credit": "Tickets de Crédito",
    "tkt.new_ticket": "+ Nuevo Ticket",
    "tkt.credit_label": "🎫 Crédito",
    "tkt.credit_desc": "Pendencias y documentos",
    "tkt.support_label": "🐛 Soporte",
    "tkt.support_desc": "Errores y mejoras",
    "tkt.status_all": "Todos",
    "tkt.status_open": "Abiertos",
    "tkt.status_waiting": "Esperando",
    "tkt.status_replied": "Respondidos",
    "tkt.status_closed": "Cerrados",
    "tkt.loading": "Cargando...",
    "tkt.no_error_reported": "Aún no ha reportado ningún error o mejora",
    "tkt.no_ticket_found": "Ningún ticket encontrado",
    "tkt.new_reply": "● Nueva respuesta",
    "tkt.awaiting_you": "⏳ Esperando su respuesta",
    "tkt.pending_badge": "🎫 Ticket Pendiente",
    "tkt.avg_closure_time": "Tiempo medio de cierre:",
    "tkt.total_tickets": "tickets totales",
    "tkt.days": "días",
    "tkt.send_error_report": "🐛 Enviar Reporte",
    "tkt.send_suggestion": "💡 Enviar Sugerencia",
    "tkt.create_ticket": "🎫 Crear Ticket",
    "tkt.sending": "Enviando...",
    "tkt.sent_success": "✅ ¡Enviado! El Fundador será notificado.",
    "tkt.ticket_created": "✅ ¡Ticket creado y cliente notificado!",
    "tkt.back": "← Atrás",
    "tkt.requests": "Solicitudes",

    // ── Ticket Detail ──
    "tkt.detail_header": "Solicitudes",
    "tkt.open_tickets": "Abiertos",
    "tkt.waiting_debtor": "Esperando",
    "tkt.replied_tickets": "Respondidos",
    "tkt.closed_tickets": "Cerrados",

    // ── Modal: Ticket Creation ──
    "modal.ticket_error_title": "Reportar Error",
    "modal.ticket_improvement_title": "Sugerir Mejora",
    "modal.ticket_credit_title": "Nuevo Ticket de Crédito",
    "modal.sent_to_founder": "Enviado al Fundador · Código FNM-Tech generado automáticamente",
    "modal.auto_code_generated": "Código FNM generado automáticamente",
    "modal.type_label": "TIPO",
    "modal.priority_label": "PRIORIDAD",
    "modal.priority_low": "Baja",
    "modal.priority_normal": "Normal",
    "modal.priority_high": "Alta",
    "modal.priority_urgent": "🔴 Urgente",
    "modal.company_label": "EMPRESA / DEUDOR",
    "modal.company_placeholder": "Escriba el nombre o RFC de la empresa...",
    "modal.company_registered": "✓",
    "modal.title_label": "TÍTULO *",
    "modal.description_label": "DESCRIPCIÓN",
    "modal.deadline_label": "PLAZO",
    "modal.screenshot_label": "CAPTURA DE PANTALLA DEL ERROR (opcional)",
    "modal.click_to_attach": "📎 Haga clic para adjuntar imagen (máx 5MB, solo imágenes)",
    "modal.attached": "📎",
    "modal.where_error_occurred": "DÓNDE OCURRIÓ / TÍTULO *",
    "modal.example_error": "Ej: Botón 'Aprobar' no guarda",
    "modal.describe_problem": "DESCRIBA EL PROBLEMA",
    "modal.steps_to_reproduce": "Pasos para reproducir...",
    "modal.how_improvement": "¿CÓMO SE IMAGINA ESTA MEJORA?",
    "modal.improvement_details": "Detalles de la funcionalidad...",
    "modal.what_needed": "DESCRIPCIÓN",
    "modal.detail_what": "Detalle lo que necesita ser enviado...",
    "modal.cancel_button": "Cancelar",

    // ── Modal: Request Update ──
    "modal.request_update_title": "Solicitar actualización",
    "modal.request_recipients": "Destinatarios",
    "modal.request_loading_contacts": "Buscando contactos registrados…",
    "modal.request_no_contacts": "Sin contactos registrados para este RFC. Ingrese el correo abajo.",
    "modal.request_additional_email": "Añadir otro correo (opcional)",
    "modal.request_error_invalid": "Correo adicional inválido.",
    "modal.request_error_none_selected": "Seleccione al menos un destinatario.",
    "modal.request_info_text": "Cada destinatario recibirá un enlace único y seguro (válido 24h) para completar los datos de",
    "modal.request_sending": "Enviando…",
    "modal.request_send": "Enviar solicitud →",
    "modal.request_success_title": "¡Solicitud enviada!",
    "modal.request_success_text": "Enlace seguro enviado a:",
    "modal.request_success_for": "para completar",
    "modal.request_registered": "registrado",

    // ── File Upload ──
    "upload.only_images": "❌ Solo se aceptan imágenes",
    "upload.file_too_large": "❌ Archivo demasiado grande (máx 5MB)",
    "upload.drag_drop": "Arrastrar y soltar",
    "upload.select_file": "Seleccionar archivo",
    "upload.attach": "Adjuntar",
    "upload.attached_file": "Archivo adjunto",
    "upload.max_size": "máx 5MB",
    "upload.image_only": "solo imágenes",

    // ── Checkout Modal ──
    "modal.checkout_title": "Suscribirse al plan",
    "modal.checkout_redirect": "Será redirigido a Stripe para un pago seguro.",
    "modal.full_name": "Nombre completo *",
    "modal.full_name_placeholder": "Juan García",
    "modal.company_cnpj": "RFC de la Empresa *",
    "modal.company_cnpj_placeholder": "00.000.000/0001-00",
    "modal.cnpj_checking": "Consultando Hacienda...",
    "modal.company_legal_name": "Nombre / Razón Social *",
    "modal.company_legal_placeholder": "Se rellenará al ingresar el RFC",
    "modal.cpf_label": "RFC del Responsable",
    "modal.cpf_placeholder": "000.000.000-00",
    "modal.job_title": "Cargo / Puesto",
    "modal.job_title_placeholder": "Ej: Director Financiero",
    "modal.corporate_email": "Correo corporativo *",
    "modal.corporate_email_placeholder": "juan@empresa.com",
    "modal.checkout_error": "⚠️ Error",
    "modal.already_exists_pending": "📧 Enlace de activación reenviado",
    "modal.already_exists_active": "✅ Cuenta ya existe",
    "modal.domain_already_registered": "🏢 Empresa ya registrada",
    "modal.check_spam": "También revise la carpeta de spam.",
    "modal.ask_admin": "Para acceder a RiskMind, pida al administrador de su empresa que vaya a Configuración → Usuarios y le envíe una invitación.",
    "modal.contract_accepted": "Contrato SaaS + LGPD aceptados electrónicamente",
    "modal.undo_accept": "deshacer",
    "modal.read_sign_contract": "📄 Leer y firmar Contrato + Privacidad",
    "modal.required": "(obligatorio)",
    "modal.sending_text": "Enviando…",
    "modal.close_login": "Cerrar e iniciar sesión →",
    "unit.group": "Grupo",
    "unit.title": "Unidades de Negocio",
    "unit.back": "← Volver",
    "unit.view_portfolio": "📊 Ver en Portafolio",
    "unit.new": "+ Nueva Unidad",
    "unit.edit_title": "Editar Unidad",
    "unit.new_title": "Nueva Unidad",
    "unit.name_label": "Nombre *",
    "unit.name_ph": "Ej: nombre de la empresa o RFC...",
    "unit.cnpj_label": "RFC (opcional)",
    "unit.desc_label": "Descripción (opcional)",
    "unit.desc_ph": "Ej: División Logística, Unidad Norte...",
    "unit.credit_policy": "Política de Crédito de esta Unidad",
    "unit.update_freq": "Frecuencia de Actualización",
    "unit.quarterly": "Trimestral (3 meses)",
    "unit.semiannual": "Semestral (6 meses)",
    "unit.annual": "Anual (12 meses)",
    "unit.min_interval": "Intervalo Mínimo (meses)",
    "unit.inherits_policy": "Si no está definida, hereda la política predeterminada del grupo (Configuraciones → Política de Crédito).",
    "unit.name_required": "El nombre es obligatorio.",
    "unit.saving": "Guardando...",
    "unit.save_changes": "Guardar Cambios",
    "unit.register": "Registrar Unidad",
    "unit.cancel": "Cancelar",
    "unit.loading": "Cargando unidades...",
    "unit.none": "Ninguna unidad registrada",
    "unit.none_desc": "Configure las subsidiarias y divisiones del grupo para ver el portafolio de crédito por unidad.",
    "unit.register_first": "+ Registrar Primera Unidad",
    "unit.th_unit": "Unidad",
    "unit.th_cnpj": "RFC",
    "unit.th_desc": "Descripción",
    "unit.th_policy": "Política de Crédito",
    "unit.edit": "Editar",
    "unit.remove": "Eliminar",
    "unit.confirm_remove": "¿Eliminar \"{name}\"? Esta acción no se puede deshacer.",
    "unit.inherits_default": "Hereda predeterminado",
    "unit.count": "{n} unidad(es) registrada(s)",
    "unit.view_consolidated": "Ver portafolio consolidado",
    "unit.policy_info": "La Política de Actualización de Crédito se define en Configuraciones → Política de Crédito.",
    "usr.back": "Volver",
    "usr.title": "Gestión de Usuarios",
    "usr.invite": "+ Invitar Usuario",
    "usr.invite_title": "Invitar Nuevo Usuario",
    "usr.invite_sub": "El usuario recibirá un correo con un enlace para crear su contraseña (válido por 72h)",
    "usr.name": "Nombre Completo *",
    "usr.email": "Correo Corporativo *",
    "usr.position": "Cargo *",
    "usr.position_ph": "Ej: Analista de Crédito",
    "usr.access_profile": "Perfil de Acceso *",
    "usr.security_title": "🔒 Seguridad — Creación de Contraseña por el Usuario",
    "usr.security_desc": "La invitación se envía por correo con un enlace seguro de uso único.",
    "usr.security_pass": "El usuario creará su propia contraseña con al menos 12 caracteres.",
    "usr.security_expire": "El enlace expira en 72 horas. Si expira, puede reenviar la invitación.",
    "usr.sod_title": "⚠ PRINCIPIO SOD — Segregación de Funciones",
    "usr.role_analista": "Analista: llena datos, ejecuta motor, genera informe — NO puede aprobar.",
    "usr.role_aprovador": "Aprobador: visualiza resultado y decide — NO puede alterar análisis.",
    "usr.role_tesouraria": "Tesorería: realiza análisis completo y aprueba — para equipos pequeños.",
    "usr.role_cs": "CS + Tesorería: comercial + análisis + aprobación — para empresas sin estructura segregada.",
    "usr.role_cfo": "CFO/Director: solo lectura + solicitud de revisión — NO interfieren en el análisis.",
    "usr.cancel": "Cancelar",
    "usr.sending": "Enviando invitación...",
    "usr.send_invite": "Enviar Invitación por Correo",
    "usr.fill_required": "Complete nombre, correo y cargo.",
    "usr.none": "Ningún usuario encontrado.",
    "usr.awaiting_setup": "Esperando Configuración",
    "usr.verified": "Verificado",
    "usr.awaiting_password": "📧 Esperando creación de contraseña por correo",
    "usr.edit": "Editar",
    "usr.resend": "Reenviar Invitación",
    "usr.reactivate": "Reactivar",
    "usr.deactivate": "Desactivar",
    "usr.delete": "Eliminar",
    "usr.delete_title": "Eliminar Usuario",
    "usr.delete_confirm": "¿Está seguro que desea eliminar",
    "usr.delete_irreversible": "Esta acción es irreversible.",
    "usr.confirm_delete": "Confirmar Eliminación",
    "usr.edit_title": "Editar Usuario",
    "usr.name_label": "NOMBRE",
    "usr.position_label": "CARGO",
    "usr.access_label": "PERFIL DE ACCESO",
    "usr.admin_warning": "⚠ Acceso total — use solo para pruebas y validaciones.",
    "usr.save": "Guardar cambios",
    "usr.loading": "Cargando...",
    "port2.risk_by_borrower": "Análisis de Riesgo por Tomador",
    "port2.risk_by_borrower_sub": "Indicadores de riesgo por empresa que recibe crédito",
    "port2.risk_by_assignor": "Análisis de Riesgo por Cedente",
    "port2.risk_by_assignor_sub": "Indicadores de riesgo agrupados por unidad de negocio",
    "port2.no_unit_analysis": "Sin análisis por unidad de negocio",
    "port2.no_unit_desc": "Los clientes aprobados no tienen unidades/subsidiarias definidas.",
    "port2.no_unit_desc2": "El riesgo crediticio está consolidado por empresa en el portafolio anterior.",
    "port2.risk_ranges": "Rangos de riesgo: Verde < 3% | Ámbar 3-12% | Rojo > 12%",
    "port2.score_avg": "Score 0–100 · Media general:",
    "port2.pd_warning": "⚠️ PD creciente indica deterioro de la calidad del portafolio — monitoree nuevos clientes con PD > 6%",
    "port2.exposure_concentration": "Concentración de Exposición por Unidad",
    "port2.exposure": "Exposición:",
    "port2.clients": "Clientes:",
    "port2.avg_pd": "PD media:",
    "port2.dominant_rating": "Rating predominante:",
    "port2.client": "Cliente",
    "port2.validity": "Vigencia: Límite anual con revisión trimestral automática.",
    "port2.immediate_review": "Revisión inmediata:",
    "port2.review_text": "se reserva el derecho de revisar, suspender o cancelar límites de crédito en cualquier momento, sin previo aviso, a su exclusivo criterio.",
    "port2.generated_at": "Análisis generado el",
    "port2.confidential": "Confidencial",
    "port2.th_empresa": "Empresa",
    "port2.th_cnpj": "RFC",
    "port2.th_rating": "Rating",
    "port2.th_pd": "PD",
    "port2.th_score": "Score",
    "port2.th_limite": "Límite",
    "port2.th_unidade": "Unidad",
    "port2.th_status": "Estado",
    "port2.approved": "Aprobado",
    "port2.conditional": "Cond.",
    "port2.rejected": "Rechaz.",
    "common.all_rights": "Todos los derechos reservados",
    "common.confidential": "CONFIDENCIAL — USO INTERNO",
    "common.ticket_pending": "🎫 Ticket Pendiente",
    "stat.approved": "Aprobado",
    "stat.conditional": "Condicional",
    "stat.rejected": "Rechazado",
    "stat.pending": "Pendiente",
    "stat.awaiting": "Esperando",
    "stat.in_analysis": "En Análisis",
    "bill.active_users": "Usuarios activos",
    "bill.back_panel": "← Volver al panel",
    "bill.billing_q": "¿Dudas sobre la facturación?",
    "bill.cnpjs_analyzed": "RFCs analizados",
    "bill.cnpjs_available": "RFCs disponibles en el periodo de prueba.",
    "bill.contact": "Contáctenos:",
    "bill.current_plan": "PLAN ACTUAL",
    "bill.free_trial": "🎉 Prueba gratuita en curso",
    "bill.mia_queries": "Consultas MIA",
    "bill.no_subscription": "Sin suscripción",
    "bill.portal_info": "El portal de suscripción permite cambiar tarjeta, descargar facturas y cancelar o hacer upgrade del plan.",
    "bill.title": "Suscripción y Facturación",
    "bill.unlimited": "(ilimitado)",
    "bill.usage_title": "USO DEL PLAN — CICLO ACTUAL",
    "fiscal.address": "DIRECCIÓN FISCAL",
    "fiscal.address_desc": "Completado automáticamente al consultar el RFC",
    "fiscal.city": "Municipio",
    "fiscal.city_reg": "Inscripción Municipal",
    "fiscal.cnpj": "RFC *",
    "fiscal.company_desc": "Datos obligatorios para emisión de NF-e en planes pagos",
    "fiscal.company_id": "IDENTIFICACIÓN DE LA EMPRESA",
    "fiscal.complement": "Complemento",
    "fiscal.district": "Barrio",
    "fiscal.legal_name": "Razón Social *",
    "fiscal.nfe_info": "Estos datos se utilizan como tomador en la emisión automática de NF-e para sus mensualidades. Manténgalos actualizados para garantizar la validez fiscal.",
    "fiscal.number": "Número",
    "fiscal.save": "Guardar Datos Fiscales",
    "fiscal.state": "Estado",
    "fiscal.state_reg": "Inscripción Estatal",
    "fiscal.street": "Calle",
    "fiscal.title": "Datos Fiscales",
    "fiscal.trade_name": "Nombre Comercial",
    "fiscal.zip": "Código Postal",
    "inv.new": "+ Nueva Invitación",
    "inv.none": "Ninguna invitación enviada",
    "inv.none_desc": "Haga clic en \"+ Nueva Invitación\" para invitar a una empresa a registrarse.",
    "inv.title": "Invitaciones de Registro",
    "pol.alert_info": "Los clientes recibirán alertas automáticos cuando la actualización esté próxima al vencimiento.",
    "pol.annual_option": "Anual (cada 12 meses — mínimo obligatorio)",
    "pol.min_interval": "Intervalo Mínimo (meses)",
    "pol.min_max": "Mínimo: 3 meses · Máximo: 12 meses (obligatorio por año)",
    "pol.rule_desc": "Define con qué frecuencia los deudores deben actualizar los datos financieros para renovación de crédito",
    "pol.rule_title": "REGLA DE ACTUALIZACIÓN DE DATOS FINANCIEROS",
    "pol.save": "Guardar Política",
    "pol.title": "Política de Crédito",
    "pol.unit_edit_info": "Para definir plazos específicos por unidad, acceda a 🏢 Unidades en el menú principal y edite cada unidad individualmente.",
    "pol.unit_inherit": "Las unidades de negocio heredan esta política predeterminada.",
    "pol.unit_policy": "POLÍTICA POR UNIDAD DE NEGOCIO",
    "pol.unit_policy_sub": "Para definir políticas individuales por subsidiaria",
    "pol.update_freq": "Frecuencia de Actualización",
    "port2.customers": "Clientes:",
    "port2.footer": "RiskMind v2.0 · Análisis generado el",
    "port2.footer_confidential": "· Confidencial",
    "port2.no_unit_desc1": "Los clientes aprobados no tienen unidades/subsidiarias definidas.",
    "port2.predominant_rating": "Rating predominante:",
    "port2.th_company": "Empresa",
    "port2.th_customer": "Cliente",
    "port2.th_limit": "Límite",
    "port2.th_unit": "Unidad",
    "port2.validity_annual": "Límite anual con revisión trimestral automática.",
    "port2.validity_header": "Vigencia:",
    "port2.validity_rights": "se reserva el derecho de revisar, suspender o cancelar límites de crédito en cualquier momento, sin previo aviso.",
    "usr.invite_access_profile": "Perfil de Acceso *",
    "usr.invite_email": "Correo Corporativo *",
    "usr.invite_name": "Nombre Completo *",
    "usr.invite_role": "Cargo *",
    "usr.label_access_profile": "PERFIL DE ACCESO",
    "usr.label_name": "NOMBRE",
    "usr.label_role": "CARGO",
    "usr.resend_invite": "Reenviar Invitación",
    "usr.security_header": "Seguridad — Creación de Contraseña por el Usuario",
    "usr.sending_invite": "Enviando invitación...",
    "usr.sod_desc": "Analista: llena datos, ejecuta motor, genera informe — NO puede aprobar. Aprobador: visualiza resultado y decide — NO puede alterar análisis. Tesorería: realiza análisis completo y aprueba — para equipos pequeños. CS + Tesorería: comercial + análisis + aprobación — para empresas sin estructura segregada. CFO/Director: solo lectura + solicitud de revisión — NO interfieren en el análisis.",
    "usr.sod_header": "PRINCIPIO SOD — Segregación de Funciones",
    "bill.cnpjs": "RFCs analizados",
    "bill.mia": "Consultas MIA",
    "bill.users": "Usuarios activos",
    "bill.usage_label": "USO DEL PLAN — CICLO ACTUAL",
    "bill.support_question": "¿Dudas sobre la facturación?",
    "fiscal.address_sub": "Completado automáticamente al consultar el RFC",
    "fiscal.id_company": "IDENTIFICACIÓN DE LA EMPRESA",
    "fiscal.id_sub": "Datos obligatorios para emisión de NF-e en planes pagos",
    "fiscal.tax_usage": "Estos datos se utilizan como tomador en la emisión automática de NF-e. Manténgalos actualizados para garantizar la validez fiscal.",
    "fiscal.neighborhood": "Barrio",
    "inv.header": "Invitaciones de Registro",
    "inv.new_invite": "+ Nueva Invitación",
    "inv.no_invites": "Ninguna invitación enviada",
    "pol.annual": "Anual (cada 12 meses — mínimo obligatorio)",
    "pol.auto_alerts": "Los clientes recibirán alertas automáticos cuando la actualización esté próxima al vencimiento.",
    "pol.inheritance_note": "Las unidades de negocio heredan esta política predeterminada. Para definir plazos específicos por unidad, acceda a Unidades en el menú principal.",
    "pol.interval_info": "Mínimo: 3 meses · Máximo: 12 meses (obligatorio por año)",
    "pol.per_unit": "POLÍTICA POR UNIDAD DE NEGOCIO",
    "usr.two_factor": "Autenticación de dos factores",
    "cfg.settings_label": "Configuración",
    "inv.empty_hint": "Haga clic en \"+ Nueva Invitación\" para invitar a una empresa a registrarse.",
    "inv.form_title": "Invitar Empresa Deudora",
    "inv.lbl_cnpj": "RFC *",
    "inv.lbl_company": "Razón Social *",
    "inv.lbl_contact_cpf": "CURP del Responsable",
    "inv.lbl_contact_name": "Nombre del Responsable",
    "inv.lbl_email": "Correo Corporativo *",
    "inv.lbl_role": "Cargo / Función",
    "inv.ph_company": "Nombre de la empresa",
    "inv.ph_email": "responsable@empresa.com",
    "inv.ph_name": "Nombre completo",
    "inv.ph_role": "Ej: Director Financiero",
    "inv.resend": "Reenviar",
    "inv.searching": "Buscando datos...",
    "inv.submit_btn": "📨 Enviar Invitación",
    "inv.submitting": "Enviando...",
    "inv.th_actions": "Acciones",
    "inv.th_cnpj": "RFC",
    "inv.th_company": "Empresa",
    "inv.th_contact": "Responsable",
    "inv.th_email": "Email",
    "inv.th_expires": "Expira",
    "inv.th_status": "Estado",
    "pol.per_unit_sub": "Para definir políticas individuales por subsidiaria",
    "pol.quarterly": "Trimestral (cada 3 meses)",
    "pol.rule_sub": "Define con qué frecuencia los deudores deben actualizar los datos financieros para renovación de crédito",
    "pol.semiannual": "Semestral (cada 6 meses)",
    "pol.saving": "Guardando...",

    // ── Portal del Cliente (cp.*) ──
    "cp.portal_title": "PORTAL DEL CLIENTE",
    "cp.credit_history": "Mi Historial de Crédito",
    "cp.logout": "Cerrar Sesión",
    "cp.new_application": "+ Nueva Solicitud",
    "cp.portfolio_stats": "Estadísticas del Portafolio",
    "cp.credit_requests": "Solicitudes de Crédito",
    "cp.support": "Soporte",
    "cp.loading": "Cargando...",
    "cp.no_applications": "Ninguna solicitud aún",
    "cp.no_applications_hint": "Haga clic en \"+ Nueva Solicitud\" para comenzar",
    "cp.applications_count": "solicitud(es)",
    "cp.limit_evolution": "EVOLUCIÓN DEL LÍMITE",
    "cp.most_recent": "Más reciente",
    "cp.waiting_cs": "Esperando cumplimiento comercial (CS)",
    "cp.in_analysis_treasury": "En análisis por Tesorería",
    "cp.credit_letter": "Carta de Crédito",
    "cp.current_limit": "Límite actual",
    "cp.limit_label": "Límite",
    "cp.status_approved": "Aprobado",
    "cp.status_conditional": "Condicional",
    "cp.status_rejected": "Rechazado",
    "cp.status_in_analysis": "En Análisis",
    "cp.status_waiting": "Pendiente",
    "cp.status_pending_board": "Pend. Directorio",
    "cp.status_pending_docs": "Pend. Docs",

    // ── Documentos (doc.*) ──
    "doc.section_title": "DOCUMENTOS",
    "doc.validation_intro": "Los documentos son validados automáticamente por IA antes de continuar. Los marcados con * son obligatorios.",
    "doc.validation_hint": "Después de subir todos los documentos, haga clic en Validar Documentos para que la IA confirme que son correctos y relacionados con su empresa.",
    "doc.required_note": "* Obligatorio. Los documentos ilegibles serán validados manualmente por Tesorería.",
    "doc.upload": "Subir",
    "doc.multiple_files": "Múltiples archivos aceptados",
    "doc.validate_ai": "Validar Documentos con IA",
    "doc.back": "Volver",
    "doc.contract_amendments": "Acta Constitutiva + Modificaciones",
    "doc.contract_amendments_desc": "Suba el contrato original + todas las modificaciones. Múltiples archivos aceptados.",
    "doc.meeting_minutes": "Acta de Asamblea / Consejo",
    "doc.meeting_minutes_desc": "Actas de asamblea de socios o consejo con deliberaciones relevantes.",
    "doc.balance_sheet_dre": "Balance General + Estado de Resultados",
    "doc.balance_sheet_dre_desc": "Un archivo por año o todos juntos. PDF e imagen aceptados.",
    "doc.trial_balance": "Balanza de Comprobación (complementaria)",
    "doc.trial_balance_desc": "Útil para períodos sin balance cerrado o renovaciones semestrales.",
    "doc.sped_accounting": "Contabilidad Electrónica",
    "doc.sped_accounting_desc": "Archivo de contabilidad generado por el sistema contable.",
    "doc.cnd_federal": "Constancia de Situación Fiscal (SAT)",
    "doc.cnd_federal_desc": "Constancia con vigencia de 30 días. La vencida penaliza el score.",
    "doc.cnd_inss": "Constancia de Seguridad Social (IMSS)",
    "doc.cnd_inss_desc": "Certificado de cumplimiento de seguridad social.",
    "doc.crf_fgts": "Constancia INFONAVIT",
    "doc.crf_fgts_desc": "Certificado de cumplimiento INFONAVIT.",
    "doc.cndt_labor": "Constancia Laboral",
    "doc.cndt_labor_desc": "Certificado negativo de adeudos laborales.",
    "doc.audit_report": "Informe de Auditoría Independiente",
    "doc.audit_report_desc": "Informe firmado por auditor registrado.",
    "doc.esg_report": "Informe de Sustentabilidad / ESG",
    "doc.esg_report_desc": "GRI, SASB, Integrated Report o similar.",
    "doc.id_owners": "INE o Pasaporte de Socios Adm.",
    "doc.id_owners_desc": "Documento de identidad de cada socio administrador.",
    "doc.bylaws": "Estatutos Sociales",
    "doc.bylaws_desc": "Estatutos sociales consolidados de la empresa.",
    "doc.board_election": "Acta de Elección de Directorio / AGO",
    "doc.board_election_desc": "Acta de asamblea general que eligió al directorio actual.",
    "doc.balance_audited": "Balance + Estado de Resultados Auditado",
    "doc.balance_audited_desc": "Estados financieros auditados por firma independiente.",
    "doc.trial_balance_sa": "Balanzas (complementarias)",
    "doc.trial_balance_sa_desc": "Balanzas intermedias para análisis complementario.",
    "doc.sped_sa": "Contabilidad Electrónica / ECD",
    "doc.sped_sa_desc": "Archivo de contabilidad generado por el sistema contable.",
    "doc.id_directors": "INE o Pasaporte de Directores",
    "doc.id_directors_desc": "Documento de identidad de cada director.",
    "doc.mei_certificate": "Certificado de Régimen Simplificado",
    "doc.mei_certificate_desc": "Certificado de régimen simplificado de contribuyente.",
    "doc.dasn_simei": "Declaración Anual Simplificada",
    "doc.dasn_simei_desc": "Declaración anual del régimen simplificado.",
    "doc.id_holder": "INE o Pasaporte del Titular",
    "doc.id_holder_desc": "Documento de identidad del titular.",

    // ── Validación IA de Documentos ──
    "doc.ai_analyzing": "Analizando documentos con Mia...",
    "doc.ai_checking": "Verificando autenticidad y correspondencia con la empresa",
    "doc.ai_all_valid": "Todos los documentos validados exitosamente",
    "doc.ai_next_financial": "Siguiente: Datos Financieros →",
    "doc.ai_warnings": "Documentos aceptados con observaciones",
    "doc.ai_replace": "Reemplazar Documentos",
    "doc.ai_proceed": "Continuar de todas formas →",
    "doc.ai_problems": "Problemas encontrados en los documentos",
    "doc.ai_company_mismatch": "Empresa no coincide",
    "doc.ai_ignore_proceed": "Ignorar y continuar →",
    "doc.no_previous": "sin registro previo, será solicitado",
    "doc.ai_timeout": "Timeout — validación manual por Tesorería.",
    "doc.ai_fallback": "No se pudo validar — continuando.",
    "doc.ai_manual_required": "Validación manual necesaria",
    "doc.ai_manual_required_desc": "La IA no pudo validar ningún documento. Los documentos serán enviados para validación manual por la Tesorería.",
    "doc.ai_proceed_manual": "Continuar — validación manual por Tesorería →",
    "doc.ai_manual_partial": "Validación parcial — algunos documentos requieren revisión manual",
    "doc.ai_manual_partial_desc": "Algunos documentos fueron validados por la IA, pero otros no pudieron ser analizados y serán enviados para validación manual.",
    "doc.ai_proceed_partial": "Continuar — pendientes serán validados manualmente →",
    "form.quarter_partial_data": "Año {year}: complete solo los datos del/los {quarters} ya cerrado(s).",
    "doc.upload_first": "Suba al menos un documento antes de validar."
  },

  // ════════════════════════════════════════════════════════════════════
  //  中文 (中国)
  // ════════════════════════════════════════════════════════════════════
  "zh-CN": {
    "nav.home": "首页",
    "nav.products": "产品",
    "nav.pricing": "定价",
    "nav.about": "关于",
    "nav.contact": "联系我们",
    "nav.login": "登录",
    "nav.signup": "注册",
    "nav.start_free": "免费开始",
    "nav.logout": "退出",
    "nav.dashboard": "仪表板",
    "nav.settings": "设置",
    "nav.language": "语言",

    "auth.login": "登录",
    "auth.register": "创建账户",
    "auth.email": "电子邮件",
    "auth.password": "密码",
    "auth.confirm_password": "确认密码",
    "auth.forgot_password": "忘记密码？",
    "auth.name": "全名",
    "auth.company": "公司",
    "auth.title": "职位",
    "auth.company_id": "统一社会信用代码",
    "auth.personal_id": "身份证号码",
    "auth.legal_name": "企业名称",
    "auth.trade_name": "商号",
    "auth.fill_all_fields": "请填写所有字段。",
    "auth.invalid_company_id": "无效的统一社会信用代码。",
    "auth.invalid_personal_id": "无效的身份证号码。",
    "auth.registration_success": "账户创建成功！请查看您的电子邮件。",
    "auth.login_error": "邮箱或密码错误。",
    "auth.access_portal": "访问门户",
    "auth.identify": "请登录",
    "auth.select_profile": "选择您的角色以访问平台",
    "auth.left_tag": "B2B信用平台",
    "auth.left_h1": "信用分析",
    "auth.left_h2": "结构化且可审计",
    "auth.left_h3": "为您的业务服务。",
    "auth.left_desc": "自主量化引擎、Anthropic Claude生成式AI和数据隐私合规——统一平台。",
    "auth.feat1_title": "专有算法",
    "auth.feat1_desc": "内部开发的评分引擎——独家方法论，竞争对手无法复制。",
    "auth.feat2_title": "Anthropic生成式AI",
    "auth.feat2_desc": "Claude分析叙述、审计报告和定性因素，具有金融推理能力。",
    "auth.feat3_title": "量化严谨性",
    "auth.feat3_desc": "基于Altman、Merton-KMV、Basel II/III和市场校准。",
    "auth.card_analyst_title": "分析师/内部团队",
    "auth.card_analyst_desc": "财务、CFO、董事会、商务和审批人。完整访问信用分析仪表板。",
    "auth.tag_new_analysis": "新分析",
    "auth.tag_portfolio": "投资组合",
    "auth.tag_reports": "报告",
    "auth.card_client_title": "信用申请企业",
    "auth.card_client_desc": "通过合作企业邀请访问。提交您的数据和文件进行商业信用分析。",
    "auth.invite_only": "仅限邀请访问",

    "risk.title": "RiskMind — 信用风险分析",
    "risk.subtitle": "人工智能驱动的B2B信用风险平台",
    "risk.new_application": "新申请",
    "risk.applications": "申请列表",
    "risk.credit_analysis": "信用分析",
    "risk.risk_score": "风险评分",
    "risk.credit_limit": "信用额度",
    "risk.approval_status": "审批状态",
    "risk.approved": "已批准",
    "risk.denied": "已拒绝",
    "risk.pending": "待处理",
    "risk.in_review": "审核中",
    "risk.financial_docs": "财务文件",
    "risk.upload_docs": "上传文件",
    "risk.balance_sheet": "资产负债表",
    "risk.income_statement": "利润表",
    "risk.cash_flow": "现金流量表",
    "risk.equity_statement": "所有者权益变动表",

    "mia.title": "MIA — 金融智能助手",
    "mia.greeting": "您好！我是MIA，您的金融分析助手。",
    "mia.placeholder": "询问信用分析、风险、市场...",
    "mia.analyzing": "分析中...",

    "plan.free": "免费版",
    "plan.essential": "基础版",
    "plan.professional": "专业版",
    "plan.enterprise": "企业版",
    "plan.companies": "家企业",
    "plan.users": "位用户",
    "plan.per_month": "/月",
    "plan.start_free": "免费开始",
    "plan.subscribe": "订阅",
    "plan.contact_sales": "联系销售",

    "legal.terms": "服务条款",
    "legal.privacy": "隐私政策",
    "legal.data_protection": "个人信息保护法",
    "legal.contract": "服务协议",
    "legal.accept_terms": "我已阅读并接受服务条款和隐私政策",
    "legal.cookie_consent": "本网站使用Cookie以改善您的体验。",

    "dash.overview": "概览",
    "dash.total_applications": "申请总数",
    "dash.approved_volume": "批准额度",
    "dash.avg_score": "平均评分",
    "dash.pending_review": "待审核",
    "dash.recent_activity": "近期活动",

    "role.client": "客户",
    "role.analyst": "信用分析师",
    "role.approver": "信用审批员",
    "role.commercial": "商务 (CS)",
    "role.treasury": "财务部",
    "role.manager": "销售经理",
    "role.director": "业务总监",
    "role.cfo": "首席财务官",
    "role.admin": "系统管理员",

    "common.save": "保存",
    "common.cancel": "取消",
    "common.edit": "编辑",
    "common.delete": "删除",
    "common.search": "搜索",
    "common.filter": "筛选",
    "common.export": "导出",
    "common.loading": "加载中...",
    "common.error": "错误",
    "common.success": "成功",
    "common.confirm": "确认",
    "common.back": "返回",
    "common.next": "下一步",
    "common.yes": "是",
    "common.no": "否",
    "common.or": "或",
    "common.required": "必填",
    "common.optional": "选填",

    "footer.powered_by": "由 Anthropic Claude · AWS 提供支持",
    "footer.compliance": "PIPL 合规",
    "footer.copyright": "© {year} Keymind Technology Inc.",

    // ── Landing Page ──
    "land.tag": "B2B信用风险平台",
    "land.headline1": "信用分析",
    "land.headline_gold": "精准如",
    "land.headline2": "您最优秀的",
    "land.headline3": "分析师。",
    "land.description": "基于Basel II、Altman Z-Score、KMV-Merton和Kanitz的量化引擎——由RiskMind专有算法和独家模型驱动，经Claude生成式AI解读。Mia智能持续学习。",
    "land.cta_free": "免费开始 — 无需信用卡",
    "land.cta_login": "已有账户 →",
    "land.trial_info": "免费试用 · 15天 · 2家公司 · 无需信用卡",
    "land.pill_basel": "Basel II引擎已启动",
    "land.pill_ifrs": "IFRS 16 · KMV-Merton",
    "land.pill_zscore": "Z-Score · Kanitz · Altman",
    "land.how_title": "使用流程",
    "land.how_subtitle": "从数据输入到报告只需4步。",
    "land.pricing_title": "定价方案",
    "land.pricing_subtitle": "选择适合您业务的方案。",
    "land.faq_title": "常见问题",
    "land.footer_cta": "立即开始最智能的信用分析。",
    "land.nav_how": "使用流程",
    "land.nav_plans": "定价方案",

    // ── How It Works (steps) ──
    "land.how_tag": "使用流程",
    "land.how_head1": "从公司ID到报告只需",
    "land.how_head_gold": "3个步骤",
    "land.how_sub2": "无需电子表格。无需手动计算。无需大量时间。",
    "land.how_s1_title": "注册公司",
    "land.how_s1_desc": "输入公司ID和财务数据。您可以导入PDF格式的财务报表——AI自动提取字段。",
    "land.how_s2_title": "量化引擎运行",
    "land.how_s2_desc": "Basel II、Altman Z-Score、KMV-Merton、Kanitz和Damodaran分析同时运行。PD、LGD、评级和信用额度在数秒内计算完成。",
    "land.how_s3_title": "智能报告就绪",
    "land.how_s3_desc": "MIA（我们的AI分析师）解读结果，识别风险，解释模型，并提供完整技术依据的信用额度建议。",

    // ── Pricing Section ──
    "land.price_tag": "方案与定价",
    "land.price_head1": "选择适合",
    "land.price_head_gold": "您业务的方案",
    "land.price_sub": "免费开始。按需升级。随时取消。",
    "land.price_monthly": "月付",
    "land.price_annual": "年付",
    "land.price_per_month": "/月",
    "land.price_billed_annual": "按年计费",
    "land.price_free_period": "15天 · 无需信用卡",
    "land.price_custom": "定制报价",
    "land.price_note": "所有价格以人民币计 · 需要公司ID用于开票 · 价格可能年度调整",
    "land.price_currency": "¥",

    // Plan names/desc/CTA
    "land.plan_free_name": "免费试用",
    "land.plan_free_tag": "15天",
    "land.plan_free_desc": "免费试用15天。完整引擎，无需信用卡。",
    "land.plan_free_cta": "开始免费试用",
    "land.plan_ess_name": "基础版",
    "land.plan_ess_desc": "适用于所有企业的高级信用分析",
    "land.plan_ess_cta": "订阅",
    "land.plan_pro_name": "专业版",
    "land.plan_pro_tag": "最受欢迎",
    "land.plan_pro_desc": "适用于需要高级解读的分析",
    "land.plan_pro_cta": "订阅",
    "land.plan_ent_name": "企业版",
    "land.plan_ent_desc": "适用于银行、基金和信贷平台。",
    "land.plan_ent_cta": "联系销售",

    // Plan features
    "land.feat_cnpj_2": "2家公司分析",
    "land.feat_user_1": "1个用户",
    "land.feat_engine": "完整风险引擎",
    "land.feat_score": "自动评分+评级",
    "land.feat_mia_10": "MIA — 每月10个问题",
    "land.feat_no_history": "仅最新分析（无历史记录）",
    "land.feat_no_pdf": "无PDF导出",
    "land.feat_corp_email": "需企业邮箱",
    "land.feat_cnpj_15": "15家监控公司",
    "land.feat_user_3": "3个用户",
    "land.feat_history": "完整分析历史",
    "land.feat_pdf_unlim": "无限PDF导出",
    "land.feat_mia_limited": "MIA AI助手（有限）",
    "land.feat_ticket": "平台工单支持",
    "land.feat_sod": "SOD — 职责分离",
    "land.feat_cnpj_75": "75家监控公司",
    "land.feat_user_10": "10个用户",
    "land.feat_tenant": "专属企业租户",
    "land.feat_models": "Basel II · KMV-Merton · Z-Score · Kanitz",
    "land.feat_algo": "RiskMind专有算法",
    "land.feat_prs": "PRS — 被动风险评分（实时，每日）",
    "land.feat_mia_adv": "MIA带投资组合上下文和高级分析",
    "land.feat_ticket2": "平台工单支持",
    "land.feat_reports": "自定义报告",
    "land.feat_sod2": "SOD — 职责分离",
    "land.feat_cnpj_unlim": "无限公司",
    "land.feat_user_unlim": "无限用户",
    "land.feat_sla": "合同SLA",
    "land.feat_api": "API集成",
    "land.feat_vpc": "专用环境（VPC）",
    "land.feat_onboard": "入职培训",
    "land.feat_custom_models": "模型定制开发",
    "land.feat_support_247": "24/7支持",

    // ── FAQ ──
    "land.faq_tag": "常见问题",
    "land.faq_head": "常见问题解答",
    "land.faq_q1": "免费计划需要信用卡吗？",
    "land.faq_a1": "不需要。使用企业邮箱创建账户即可立即使用。无需信用卡，无需承诺。",
    "land.faq_q2": "什么是'监控公司'？",
    "land.faq_a2": "您在平台上注册和分析的每家公司（交易对手）。每次信用分析消耗一个月度活跃公司名额。",
    "land.faq_q3": "可以随时取消吗？",
    "land.faq_a3": "可以。月付计划可随时取消，无罚金。年付计划享受2个月折扣，在期限结束时取消。",
    "land.faq_q4": "RiskMind使用真正的人工智能吗？",
    "land.faq_a4": "是的。分析引擎由Anthropic的Claude驱动——全球领先金融机构采用的同一生成式AI模型。每次分析结合量化模型（Basel II、Z-Score、KMV-Merton）与生成式解读。",
    "land.faq_q5": "我的财务数据安全吗？",
    "land.faq_a5": "您的基础设施100%运行在AWS上。静态数据加密（AES-256），传输加密（TLS 1.3）。我们绝不出售或分享客户数据。",
    "land.faq_q6": "企业版包含与内部系统的集成吗？",
    "land.faq_a6": "是的。我们提供文档化的REST API，支持与ERP、发起系统和CRM的集成。联系我们讨论您的架构。",

    // ── Backtest Section ──
    "land.bt_tag": "科学验证",
    "land.bt_head1": "回测涵盖",
    "land.bt_head_gold": "B3交易所192家公司",
    "land.bt_desc": "2015至2024年公开数据的双边分析。RiskMind™算法展示了卓越的区分能力和信用事件预警能力。",
    "land.bt_m1_desc": "区分健康与困境公司的能力",
    "land.bt_m2_desc": "专有模型的排序能力",
    "land.bt_m3_desc": "风险分布间的最大分离度",
    "land.bt_m4_label": "PD比率",
    "land.bt_m4_desc": "困境与健康公司间的相对风险",
    "land.bt_m5_value": "3年",
    "land.bt_m5_label": "预警",
    "land.bt_m5_desc": "信用事件的提前预警",
    "land.bt_m6_value": "8/8",
    "land.bt_m6_label": "准确率",
    "land.bt_m6_desc": "所有测试公司的正确分类",
    "land.bt_check1": "100%公开数据",
    "land.bt_check2": "可复现方法论",
    "land.bt_check3": "+19pp vs.逻辑回归基线",
    "land.bt_check4": "2015–2024年期间",
    "land.bt_cta": "查看完整研究 →",
    "land.bt_cta_sub": "详细案例研究含ROC曲线、分布和方法论",

    // ── Footer CTA ──
    "land.fcta_head1": "准备好做出",
    "land.fcta_head_gold": "更安全的决策",
    "land.fcta_desc": "加入已在使用RiskMind的信贷团队。\n不到2分钟即可免费开始。",
    "land.fcta_btn": "创建免费账户 →",
    "land.fcta_badge1": "无需信用卡",
    "land.fcta_badge2": "免费试用15天",
    "land.fcta_badge3": "完整引擎可用",

    // ── 着陆页页脚徽章 ──
    "land.foot_b1": "由Anthropic Claude驱动",
    "land.foot_b2": "AWS 圣保罗",
    "land.foot_b3": "LGPD合规",

    // ── 信任徽章/亮点 ──
    "land.trust_tag": "基础设施与合作伙伴",
    "land.trust_h2": "机构级信任",
    "land.trust_more": "阅读更多",
    "land.trust1_title": "由Anthropic Claude驱动",
    "land.trust1_sub": "企业级生成式AI",
    "land.trust1_detail": "RiskMind由Anthropic的Claude驱动——全球领先金融机构采用的同款生成式AI模型，以可追溯性、监管合规和伦理对齐著称。",
    "land.trust2_title": "AWS基础设施",
    "land.trust2_sub": "圣保罗 · 99.9%可用性SLA",
    "land.trust2_detail": "100% AWS基础设施部署在sa-east-1区域（圣保罗）。静态数据AES-256加密，传输TLS 1.3。Elastic Beanstalk + RDS PostgreSQL，自动每日备份。",
    "land.trust3_title": "金融安全",
    "land.trust3_sub": "LGPD · AES-256加密",
    "land.trust3_detail": "符合LGPD及金融行业安全最佳实践。JWT认证、速率限制、完整的访问审计和所有操作的不可变日志。",

    // ── 设置 ──
    "cfg.title": "设置",
    "cfg.users": "用户",
    "cfg.users_desc": "管理团队成员及其访问权限。",
    "cfg.invites": "邀请",
    "cfg.invites_desc": "向新用户发送邀请。",
    "cfg.policy": "信贷政策",
    "cfg.policy_desc": "规则、限额和审批权限。",
    "cfg.fiscal": "财税数据",
    "cfg.fiscal_desc": "税号、法人名称和税务制度。",
    "cfg.billing": "账单",
    "cfg.billing_desc": "套餐、发票和付款方式。",

    // ── 执行仪表板 ──
    "dash.exec_panel": "信贷执行仪表板",
    "dash.portfolio": "投资组合",
    "dash.tickets": "工单",
    "dash.units": "单位",
    "dash.settings": "设置",
    "dash.logout": "退出",
    "dash.total_portfolio": "总投资组合",
    "dash.analyses": "分析",
    "dash.approved": "已批准",
    "dash.active_credits": "活跃信贷",
    "dash.conditional": "有条件的",
    "dash.with_caveats": "附带条件",
    "dash.pend_board": "待委员会",
    "dash.awaiting_decision": "等待决策",
    "dash.total_exposure": "总敞口",
    "dash.approved_limits": "已批准额度",
    "dash.avg_pd": "平均PD",
    "dash.avg_risk": "组合平均风险",

    // ── SOD控制 ──
    "dash.sod_title": "SOD控制",
    "dash.sod_sub": "职责分离实时生效",
    "dash.sod_analyst": "分析师 ≠ 审批人",
    "dash.sod_analyst_d": "分析人员不能批准同一操作",
    "dash.sod_audit": "审计跟踪",
    "dash.sod_audit_d": "所有操作和决策的不可变日志",
    "dash.sod_review": "同行评审",
    "dash.sod_review_d": "超过限额的分析需要双重验证",
    "dash.sod_models": "独立模型",
    "dash.sod_models_d": "校准与信贷运营分离",
    "dash.sod_limit": "已定义权限",
    "dash.sod_limit_d": "按层级设定审批限额",
    "dash.sod_compliance": "持续合规",
    "dash.sod_compliance_d": "24/7监控与自动警报",

    // Portfolio/Dashboard
    "port.back": "← 返回",
    "port.title": "信贷投资组合",
    "port.consolidated": "合并",
    "port.analyses": "项分析",
    "port.unique_clients": "家独特客户",
    "port.updated": "更新于",
    "port.loading": "正在加载详细分析数据...",
    "port.total_analyses": "总分析数",
    "port.approved": "已批准",
    "port.full": "完整",
    "port.conditional": "条件性",
    "port.rejected": "已拒绝",
    "port.avg_pd": "投资组合平均PD",
    "port.total_exposure": "总敞口",
    "port.approval_rate": "批准率",
    "port.distribution": "投资组合分布",
    "port.by_status": "按分析状态",
    "port.status_approved": "已批准",
    "port.status_conditional": "条件性",
    "port.status_rejected": "已拒绝",
    "port.status_analyzing": "分析中",
    "port.status_pending": "待处理",
    "port.approval_rate_label": "批准率",
    "port.risk_radar": "投资组合风险雷达",
    "port.based_on": "基于",
    "port.analyses_with_complete_data": "项含完整数据的分析",
    "port.perform_credit_analyses_to_populate_radar": "执行信贷分析以填充雷达",
    "port.radar_solvency": "偿债能力",
    "port.radar_liquidity": "流动性",
    "port.radar_approval": "批准",
    "port.radar_score": "评分",
    "port.radar_renewal": "续期",
    "port.radar_capital": "资本",
    "port.no_data": "无数据",
    "port.ratings_dist": "评级分布",
    "port.ratings_sub": "基于内部PD→评级模型",
    "port.avg_pd_label": "平均PD",
    "port.avg_limit": "平均限额",
    "port.max_limit": "最大限额",
    "port.clients_with_renewal": "续期客户",
    "port.pd_dist": "PD分布",
    "port.pd_by_range": "按范围的违约概率",
    "port.avg_score_by_status": "按状态的平均评分",
    "port.behavioral_financial_scorecard": "行为+财务记分卡",
    "port.monthly_evolution": "月度演变——批准量",
    "port.trend_last_6_months": "过去6个月的趋势",
    "port.pd_trend": "平均PD演变——风险趋势",
    "port.pd_trend_sub": "越低投资组合质量越好",
    "port.concentration": "按子公司集中度",
    "port.concentration_sub": "按业务部门的敞口（基于商业分配）",
    "port.unit_dash": "业务部门仪表板",
    "port.units": "个单位",
    "port.unit": "单位",
    "port.with_recorded_analyses": "含已记录分析",
    "port.table_unit": "单位",
    "port.table_analyses": "分析",
    "port.table_approved": "已批准",
    "port.table_rejected": "已拒绝",
    "port.table_exposure": "敞口",
    "port.table_avg_pd": "平均PD",
    "port.table_avg_score": "平均评分",
    "port.table_approval_rate": "批准率",
    "port.top_clients": "按限额排名靠前的客户",
    "port.top_clients_sub": "家独特的已批准客户·按限额排序",
    "port.table_company": "公司",
    "port.table_cnpj": "CNPJ",
    "port.table_limit": "限额",
    "port.table_pd": "PD",
    "port.table_rating": "评级",
    "port.table_status": "状态",
    "port.table_date": "日期",
    "port.no_approval_data": "无批准数据",
    "port.consolidation_info": "合并视图包括所有分析。上面按单位筛选以进行详细分析。",

    // ── 客户注册表单 (ClientForm) ──
    "form.step_company": "公司",
    "form.step_documents": "文件",
    "form.step_financial": "财务",
    "form.step_confirmation": "确认",
    "form.checking_registration": "检查注册...",
    "form.registration_found": "找到注册",
    "form.your_data_registered": "您的数据已在系统中注册",
    "form.new_request_reuse_data": "对于新请求，将重新使用您的数据和有效文件。只需确认是否有任何更改。",
    "form.previous_docs_changes": "以前注册的文件——有更改吗？",
    "form.no_changes": "无更改 ✓",
    "form.update": "更新",
    "form.responsibility_statement": "责任声明",
    "form.responsibility_text": "通过保留以前的文件而不进行更新，我声明信息和文件是最新的、完整的且没有相关更改。我意识到提供虚假信息构成违法犯罪。",
    "form.confirm_and_continue": "确认并继续",
    "form.new_registration": "新注册",
    "form.no_previous_registration": "未找到之前的注册。让我们创建您的完整档案。",
    "form.get_started": "开始",
    "form.company_data": "公司数据",
    "form.cnpj_matrix": "公司税号",
    "form.cnpj_linked_to_invite": "税号与您的邀请关联——无法更改",
    "form.lookup": "查询",
    "form.federal_revenue_data": "联邦税务数据",
    "form.legal_name": "法律名称",
    "form.legal_entity_type": "法律实体类型",
    "form.type_ltda": "有限公司 / 一人公司 / 微型企业",
    "form.type_sa": "股份公司",
    "form.type_mei": "微型企业个体户",
    "form.industry_sector": "行业部门",
    "form.sector_logistics": "物流",
    "form.sector_transport": "运输",
    "form.sector_industry": "工业",
    "form.sector_commerce": "商业",
    "form.sector_services": "服务",
    "form.sector_agribusiness": "农业商业",
    "form.sector_technology": "技术",
    "form.sector_others": "其他",
    "form.documents": "文件 - {type}",
    "form.docs_validated_automatically": "文件将由AI自动验证后再继续。标有*的项目为必需。",
    "form.after_upload_validate_docs": "上传所有文件后，点击验证文件，以便AI确认它们正确且与您的公司有关。",
    "form.multiple_files_accepted": "接受多个文件",
    "form.analyzing": "分析中...",
    "form.add_file": "+文件",
    "form.upload": "上传",
    "form.reused": "已重用",
    "form.optional_comment_analysis": "分析的可选注释...",
    "form.required_docs_manual_validation": "* 必需。不清晰的文件将由财务部手动验证。",
    "form.financial_data": "财务数据 - 3个财务年度",
    "form.years": "年份",
    "form.fill_financial_data": "填入资产负债表和损益表的值。如果财务文件在之前的步骤(PDF)中上传，使用下面的按钮尝试自动提取。",
    "form.first_time_financial_notice": "首次注册？必须提供最近3个已结算会计年度（{years}）的财务数据。资产负债表、损益表和其他财务报表必须逐年填写。数据不完整可能延迟信用分析。",
    "form.first_time_docs_notice": "首次注册请上传最近3个已结算会计年度（{years}）的财务文件（资产负债表、损益表、试算表、SPED）。这是信用分析的必要条件。",
    "form.quarter_req_notice": "除了前3个会计年度外，还需提供{year}年的部分数据（{quarters}）。已结算期间的试算表和中期报表为必填项。",
    "form.quarter_req_docs_notice": "请同时附上{year}年（{quarters}）的部分文件——当前会计年度的试算表和中期财务报表。",
    "form.pdf_extraction": "PDF提取",
    "form.pdf_extraction_desc": "读取PDF的本地文本(资产负债表+损益表)。检查并纠正提取的值。",
    "form.extracting": "提取中...",
    "form.extract_from_pdf": "从PDF提取",
    "form.extract_all_years": "从PDF提取所有年份",
    "form.upload_financial_first": "请先在文件步骤中上传财务文件（资产负债表+损益表），然后返回此处。",
    "form.ai_partial_years": "已提取数据：{found}。\n\n文件中未找到：{missing}。\n请手动填写这些年份或上传相应文件。",
    "form.ai_no_data_found": "无法从文件中提取财务数据。请确认PDF包含可读的资产负债表或损益表后重试。",
    "form.extracted_fields": "从PDF提取{count}个字段。",
    "form.verify_and_correct": "验证并在必要时更正。",
    "form.confirm_and_send": "确认并发送",
    "form.request_sent_to_treasury": "您的请求将进入财务部队列。商业团队(CS)将在信贷分析前完成关系数据和交易量。",
    "form.company": "公司",
    "form.type": "类型",
    "form.files_uploaded": "上传的文件",
    "form.sending": "发送中...",
    "form.send_request": "发送请求",

    // ── 财务表单 (FinancialFormPeriod) ──
    "form.fin_field": "字段",
    "form.fin_previous": "之前",
    "form.fin_new": "新建 ({period})",
    "form.fin_group_income_statement": "损益表",
    "form.fin_group_balance_sheet": "资产负债表",
    "form.fin_required_legend": "* 必需 · 值为CNY(整数) · 流量字段 = 期间值 | 存量 = 期末余额",
    "form.fin_flow_vs_stock_warning": "📊 <strong>流量</strong>字段(收入、成本、结果)：期间值。<strong>存量</strong>字段(资产、负债、权益)：期末余额。",

    // ── 财务字段 (FINS_FIELDS) ──
    "form.fin_rev": "净收入(扣除后)",
    "form.fin_cpv": "产品/服务成本(CPV/CSP)",
    "form.fin_desp_op": "营业费用",
    "form.fin_desp_fin": "财务费用(应付利息)",
    "form.fin_lucro": "净结果(利润或亏损)",
    "form.fin_da": "折旧和摊销(D&A)",
    "form.fin_ebitda_real": "EBITDA(若在损益表中披露)",
    "form.fin_caixa": "现金和等价物",
    "form.fin_ac": "流动资产合计",
    "form.fin_pc": "流动负债合计",
    "form.fin_at": "资产总额",
    "form.fin_pt": "负债总额",
    "form.fin_pl": "股东权益合计",
    "form.fin_lucro_acum": "累积利润/亏损(储备)",
    "form.fin_div_cp": "贷款和融资 - 短期(最长12个月)",
    "form.fin_div_lp": "贷款和融资 - 长期(超过12个月)",
    "form.fin_arrend_cp": "IFRS16租赁 - 短期(负债)",
    "form.fin_arrend_lp": "IFRS16租赁 - 长期(负债)",
    "form.fin_dou_uso": "使用权(IFRS16资产)",
    "form.fin_pgto_lease": "期间租赁支付(可选)",

    // ── 工单和支持 ──
    "tkt.report_error": "报告错误",
    "tkt.suggest_improvement": "建议改进",
    "tkt.technical_support": "技术支持",
    "tkt.credit_tickets": "信用工单",
    "tkt.support_technical": "技术支持",
    "tkt.tickets_credit": "信用工单",
    "tkt.new_ticket": "+ 新建工单",
    "tkt.credit_label": "🎫 信用",
    "tkt.credit_desc": "待办事项和文件",
    "tkt.support_label": "🐛 支持",
    "tkt.support_desc": "错误和改进",
    "tkt.status_all": "全部",
    "tkt.status_open": "打开",
    "tkt.status_waiting": "等待",
    "tkt.status_replied": "已回复",
    "tkt.status_closed": "已关闭",
    "tkt.loading": "加载中...",
    "tkt.no_error_reported": "您还没有报告任何错误或改进",
    "tkt.no_ticket_found": "未找到工单",
    "tkt.new_reply": "● 新回复",
    "tkt.awaiting_you": "⏳ 等待您的回复",
    "tkt.pending_badge": "🎫 待办工单",
    "tkt.avg_closure_time": "平均结束时间:",
    "tkt.total_tickets": "个工单总数",
    "tkt.days": "天",
    "tkt.send_error_report": "🐛 发送报告",
    "tkt.send_suggestion": "💡 发送建议",
    "tkt.create_ticket": "🎫 创建工单",
    "tkt.sending": "发送中...",
    "tkt.sent_success": "✅ 已发送！创始人将收到通知。",
    "tkt.ticket_created": "✅ 工单已创建且客户已被通知！",
    "tkt.back": "← 返回",
    "tkt.requests": "请求",

    // ── 工单详情 ──
    "tkt.detail_header": "请求",
    "tkt.open_tickets": "打开",
    "tkt.waiting_debtor": "等待",
    "tkt.replied_tickets": "已回复",
    "tkt.closed_tickets": "已关闭",

    // ── 模态窗口：工单创建 ──
    "modal.ticket_error_title": "报告错误",
    "modal.ticket_improvement_title": "建议改进",
    "modal.ticket_credit_title": "新建信用工单",
    "modal.sent_to_founder": "已发送给创始人 · FNM-Tech代码自动生成",
    "modal.auto_code_generated": "FNM代码自动生成",
    "modal.type_label": "类型",
    "modal.priority_label": "优先级",
    "modal.priority_low": "低",
    "modal.priority_normal": "普通",
    "modal.priority_high": "高",
    "modal.priority_urgent": "🔴 紧急",
    "modal.company_label": "公司 / 债务人",
    "modal.company_placeholder": "输入公司名称或ID...",
    "modal.company_registered": "✓",
    "modal.title_label": "标题 *",
    "modal.description_label": "描述",
    "modal.deadline_label": "截止日期",
    "modal.screenshot_label": "错误屏幕截图 (可选)",
    "modal.click_to_attach": "📎 点击附加图像 (最大5MB，仅限图像)",
    "modal.attached": "📎",
    "modal.where_error_occurred": "错误发生位置 / 标题 *",
    "modal.example_error": "例：'批准'按钮不保存",
    "modal.describe_problem": "描述问题",
    "modal.steps_to_reproduce": "重现步骤...",
    "modal.how_improvement": "您如何想象这一改进？",
    "modal.improvement_details": "功能详情...",
    "modal.what_needed": "描述",
    "modal.detail_what": "详细说明需要发送的内容...",
    "modal.cancel_button": "取消",

    // ── 模态窗口：请求更新 ──
    "modal.request_update_title": "请求更新",
    "modal.request_recipients": "收件人",
    "modal.request_loading_contacts": "正在加载已注册的联系人…",
    "modal.request_no_contacts": "此税号没有已注册的联系人。请在下方输入电子邮件。",
    "modal.request_additional_email": "添加另一个电子邮件 (可选)",
    "modal.request_error_invalid": "额外电子邮件无效。",
    "modal.request_error_none_selected": "至少选择一个收件人。",
    "modal.request_info_text": "每个收件人将收到一个唯一且安全的链接 (有效期24小时) 以填写以下数据",
    "modal.request_sending": "发送中…",
    "modal.request_send": "发送请求 →",
    "modal.request_success_title": "请求已发送！",
    "modal.request_success_text": "安全链接已发送至:",
    "modal.request_success_for": "用于完成",
    "modal.request_registered": "已注册",

    // ── 文件上传 ──
    "upload.only_images": "❌ 仅接受图像",
    "upload.file_too_large": "❌ 文件太大 (最大5MB)",
    "upload.drag_drop": "拖放",
    "upload.select_file": "选择文件",
    "upload.attach": "附加",
    "upload.attached_file": "已附加文件",
    "upload.max_size": "最大5MB",
    "upload.image_only": "仅限图像",

    // ── 结账模态窗口 ──
    "modal.checkout_title": "订阅计划",
    "modal.checkout_redirect": "您将被重定向到Stripe进行安全支付。",
    "modal.full_name": "全名 *",
    "modal.full_name_placeholder": "张三",
    "modal.company_cnpj": "公司统一社会信用代码 *",
    "modal.company_cnpj_placeholder": "00.000.000/0001-00",
    "modal.cnpj_checking": "正在查询税务部门...",
    "modal.company_legal_name": "名称 / 法定名称 *",
    "modal.company_legal_placeholder": "输入税号后自动填充",
    "modal.cpf_label": "责任人身份证号",
    "modal.cpf_placeholder": "000.000.000-00",
    "modal.job_title": "职位 / 职务",
    "modal.job_title_placeholder": "例：财务总监",
    "modal.corporate_email": "公司电子邮件 *",
    "modal.corporate_email_placeholder": "zhang@company.com",
    "modal.checkout_error": "⚠️ 错误",
    "modal.already_exists_pending": "📧 激活链接已重新发送",
    "modal.already_exists_active": "✅ 账户已存在",
    "modal.domain_already_registered": "🏢 公司已注册",
    "modal.check_spam": "也请检查垃圾邮件文件夹。",
    "modal.ask_admin": "要访问RiskMind，请要求您公司的管理员前往设置 → 用户，然后向您发送邀请。",
    "modal.contract_accepted": "SaaS合同 + LGPD已电子签署",
    "modal.undo_accept": "撤销",
    "modal.read_sign_contract": "📄 阅读并签署合同 + 隐私政策",
    "modal.required": "(必需)",
    "modal.sending_text": "发送中…",
    "modal.close_login": "关闭并登录 →",
    "unit.group": "集团",
    "unit.title": "业务单元",
    "unit.back": "← 返回",
    "unit.view_portfolio": "📊 查看投资组合",
    "unit.new": "+ 新单元",
    "unit.edit_title": "编辑单元",
    "unit.new_title": "新单元",
    "unit.name_label": "名称 *",
    "unit.name_ph": "例如：公司名称或税号...",
    "unit.cnpj_label": "税号（可选）",
    "unit.desc_label": "描述（可选）",
    "unit.desc_ph": "例如：物流部门，北方单元...",
    "unit.credit_policy": "此单元的信贷策略",
    "unit.update_freq": "更新频率",
    "unit.quarterly": "季度（3个月）",
    "unit.semiannual": "半年（6个月）",
    "unit.annual": "年度（12个月）",
    "unit.min_interval": "最小间隔（月）",
    "unit.inherits_policy": "如果未定义，则继承集团默认策略（设置 → 信贷策略）。",
    "unit.name_required": "名称为必填项。",
    "unit.saving": "保存中...",
    "unit.save_changes": "保存更改",
    "unit.register": "注册单元",
    "unit.cancel": "取消",
    "unit.loading": "加载单元中...",
    "unit.none": "未注册单元",
    "unit.none_desc": "设置集团的子公司和分支机构，以按单元查看信贷组合。",
    "unit.register_first": "+ 注册第一个单元",
    "unit.th_unit": "单元",
    "unit.th_cnpj": "税号",
    "unit.th_desc": "描述",
    "unit.th_policy": "信贷策略",
    "unit.edit": "编辑",
    "unit.remove": "删除",
    "unit.confirm_remove": "删除\"{name}\"？此操作无法撤消。",
    "unit.inherits_default": "继承默认",
    "unit.count": "{n} 个单元已注册",
    "unit.view_consolidated": "查看合并投资组合",
    "unit.policy_info": "信贷更新策略在设置 → 信贷策略中定义。",
    "usr.back": "返回",
    "usr.title": "用户管理",
    "usr.invite": "+ 邀请用户",
    "usr.invite_title": "邀请新用户",
    "usr.invite_sub": "用户将收到一封包含创建密码链接的邮件（72小时有效）",
    "usr.name": "全名 *",
    "usr.email": "企业邮箱 *",
    "usr.position": "职位 *",
    "usr.position_ph": "例如：信贷分析师",
    "usr.access_profile": "访问权限 *",
    "usr.security_title": "🔒 安全 — 用户自行创建密码",
    "usr.security_desc": "邀请通过电子邮件发送，附带一次性安全链接。",
    "usr.security_pass": "用户将创建至少12个字符的密码。",
    "usr.security_expire": "链接72小时后过期。如果过期，您可以重新发送邀请。",
    "usr.sod_title": "⚠ SOD原则 — 职责分离",
    "usr.role_analista": "分析师：填写数据，运行引擎，生成报告——不能批准。",
    "usr.role_aprovador": "审批者：查看结果并决定——不能更改分析。",
    "usr.role_tesouraria": "财务：执行完整分析并批准——适用于精简团队。",
    "usr.role_cs": "CS + 财务：商务 + 分析 + 审批——适用于无隔离结构的企业。",
    "usr.role_cfo": "CFO/总监：仅查看 + 申请审核——不干预分析。",
    "usr.cancel": "取消",
    "usr.sending": "发送邀请中...",
    "usr.send_invite": "通过邮件发送邀请",
    "usr.fill_required": "请填写姓名、邮箱和职位。",
    "usr.none": "未找到用户。",
    "usr.awaiting_setup": "等待设置",
    "usr.verified": "已验证",
    "usr.awaiting_password": "📧 等待通过邮件创建密码",
    "usr.edit": "编辑",
    "usr.resend": "重发邀请",
    "usr.reactivate": "重新激活",
    "usr.deactivate": "停用",
    "usr.delete": "删除",
    "usr.delete_title": "删除用户",
    "usr.delete_confirm": "您确定要删除",
    "usr.delete_irreversible": "此操作无法撤消。",
    "usr.confirm_delete": "确认删除",
    "usr.edit_title": "编辑用户",
    "usr.name_label": "姓名",
    "usr.position_label": "职位",
    "usr.access_label": "访问权限",
    "usr.admin_warning": "⚠ 完全访问权限——仅用于测试和验证。",
    "usr.save": "保存更改",
    "usr.loading": "加载中...",
    "port2.risk_by_borrower": "按借款方的风险分析",
    "port2.risk_by_borrower_sub": "获得信贷的企业风险指标",
    "port2.risk_by_assignor": "按转让方的风险分析",
    "port2.risk_by_assignor_sub": "按业务单元分组的风险指标",
    "port2.no_unit_analysis": "无业务单元分析",
    "port2.no_unit_desc": "已批准的客户没有定义的单元/子公司。",
    "port2.no_unit_desc2": "信用风险在上述投资组合中按企业合并。",
    "port2.risk_ranges": "风险范围：绿色 < 3% | 琥珀色 3-12% | 红色 > 12%",
    "port2.score_avg": "评分 0–100 · 总体平均：",
    "port2.pd_warning": "⚠️ PD上升表示投资组合质量恶化——监控PD > 6%的新客户",
    "port2.exposure_concentration": "按单元的风险敞口集中度",
    "port2.exposure": "风险敞口：",
    "port2.clients": "客户：",
    "port2.avg_pd": "平均PD：",
    "port2.dominant_rating": "主要评级：",
    "port2.client": "客户",
    "port2.validity": "有效期：年度限额，自动季度审查。",
    "port2.immediate_review": "立即审查：",
    "port2.review_text": "保留随时审查、暂停或取消信贷限额的权利，恕不另行通知。",
    "port2.generated_at": "分析生成于",
    "port2.confidential": "机密",
    "port2.th_empresa": "企业",
    "port2.th_cnpj": "税号",
    "port2.th_rating": "评级",
    "port2.th_pd": "PD",
    "port2.th_score": "评分",
    "port2.th_limite": "限额",
    "port2.th_unidade": "单元",
    "port2.th_status": "状态",
    "port2.approved": "已批准",
    "port2.conditional": "有条件",
    "port2.rejected": "已拒绝",
    "common.all_rights": "版权所有",
    "common.confidential": "机密——内部使用",
    "common.ticket_pending": "🎫 工单待处理",
    "stat.approved": "已批准",
    "stat.conditional": "有条件",
    "stat.rejected": "已拒绝",
    "stat.pending": "待处理",
    "stat.awaiting": "等待中",
    "stat.in_analysis": "分析中",
    "bill.active_users": "活跃用户",
    "bill.back_panel": "← 返回面板",
    "bill.billing_q": "计费问题？",
    "bill.cnpjs_analyzed": "已分析的税号",
    "bill.cnpjs_available": "试用期间可用的税号。",
    "bill.contact": "联系我们：",
    "bill.current_plan": "当前计划",
    "bill.free_trial": "🎉 免费试用进行中",
    "bill.mia_queries": "MIA查询",
    "bill.no_subscription": "无订阅",
    "bill.portal_info": "订阅门户允许您更换卡片、下载发票以及取消或升级计划。",
    "bill.title": "订阅与计费",
    "bill.unlimited": "（无限制）",
    "bill.usage_title": "计划使用 — 当前周期",
    "fiscal.address": "财务地址",
    "fiscal.address_desc": "查询税号时自动填写",
    "fiscal.city": "城市",
    "fiscal.city_reg": "市注册号",
    "fiscal.cnpj": "税号 *",
    "fiscal.company_desc": "付费计划中开具NF-e所需的数据",
    "fiscal.company_id": "企业识别",
    "fiscal.complement": "补充信息",
    "fiscal.district": "区/街道",
    "fiscal.legal_name": "法定名称 *",
    "fiscal.nfe_info": "此数据用于订阅费自动开具NF-e的接收方。请保持更新以确保发票的财务有效性。",
    "fiscal.number": "门牌号",
    "fiscal.save": "保存财务数据",
    "fiscal.state": "省/州",
    "fiscal.state_reg": "州注册号",
    "fiscal.street": "街道",
    "fiscal.title": "财务数据",
    "fiscal.trade_name": "商号",
    "fiscal.zip": "邮政编码",
    "inv.new": "+ 新邀请",
    "inv.none": "未发送邀请",
    "inv.none_desc": "点击\"+ 新邀请\"邀请公司注册。",
    "inv.title": "注册邀请",
    "pol.alert_info": "更新即将到期时，客户将收到自动提醒。",
    "pol.annual_option": "年度（每12个月——最低要求）",
    "pol.min_interval": "最小间隔（月）",
    "pol.min_max": "最少：3个月 · 最多：12个月（每年必须）",
    "pol.rule_desc": "定义债务人必须以何种频率更新财务数据以进行信贷续期",
    "pol.rule_title": "财务数据更新规则",
    "pol.save": "保存策略",
    "pol.title": "信贷策略",
    "pol.unit_edit_info": "要为每个单元设置具体期限，请转到主菜单中的🏢 单元并单独编辑每个单元。",
    "pol.unit_inherit": "业务单元继承此默认策略。",
    "pol.unit_policy": "按业务单元策略",
    "pol.unit_policy_sub": "为每个子公司定义单独的策略",
    "pol.update_freq": "更新频率",
    "port2.customers": "客户：",
    "port2.footer": "RiskMind v2.0 · 分析生成于",
    "port2.footer_confidential": "· 机密",
    "port2.no_unit_desc1": "已批准的客户没有定义的单元/子公司。",
    "port2.predominant_rating": "主要评级：",
    "port2.th_company": "企业",
    "port2.th_customer": "客户",
    "port2.th_limit": "限额",
    "port2.th_unit": "单元",
    "port2.validity_annual": "年度限额，自动季度审查。",
    "port2.validity_header": "有效期：",
    "port2.validity_rights": "保留随时审查、暂停或取消信贷限额的权利，恕不另行通知。",
    "usr.invite_access_profile": "访问权限 *",
    "usr.invite_email": "企业邮箱 *",
    "usr.invite_name": "全名 *",
    "usr.invite_role": "职位 *",
    "usr.label_access_profile": "访问权限",
    "usr.label_name": "姓名",
    "usr.label_role": "职位",
    "usr.resend_invite": "重发邀请",
    "usr.security_header": "安全 — 用户自行创建密码",
    "usr.sending_invite": "发送邀请中...",
    "usr.sod_desc": "分析师：填写数据，运行引擎，生成报告——不能批准。审批者：查看结果并决定——不能更改分析。财务：执行完整分析并批准——适用于精简团队。CS + 财务：商务 + 分析 + 审批——适用于无隔离结构的企业。CFO/总监：仅查看 + 申请审核——不干预分析。",
    "usr.sod_header": "SOD原则 — 职责分离",
    "bill.cnpjs": "已分析的税号",
    "bill.mia": "MIA查询",
    "bill.users": "活跃用户",
    "bill.usage_label": "计划使用 — 当前周期",
    "bill.support_question": "计费问题？",
    "fiscal.address_sub": "查询税号时自动填写",
    "fiscal.id_company": "企业识别",
    "fiscal.id_sub": "付费计划中开具NF-e所需的数据",
    "fiscal.tax_usage": "此数据用于订阅费自动开具NF-e的接收方。请保持更新以确保发票的财务有效性。",
    "fiscal.neighborhood": "街道/区",
    "inv.header": "注册邀请",
    "inv.new_invite": "+ 新邀请",
    "inv.no_invites": "未发送邀请",
    "pol.annual": "年度（每12个月——最低要求）",
    "pol.auto_alerts": "更新即将到期时，客户将收到自动提醒。",
    "pol.inheritance_note": "业务单元继承此默认策略。要为每个单元设置具体期限，请转到主菜单中的单元并单独编辑每个单元。",
    "pol.interval_info": "最少：3个月 · 最多：12个月（每年必须）",
    "pol.per_unit": "按业务单元策略",
    "usr.two_factor": "双因素认证",
    "cfg.settings_label": "设置",
    "inv.empty_hint": "点击\"+新建邀请\"邀请公司注册。",
    "inv.form_title": "邀请债务公司",
    "inv.lbl_cnpj": "税号 *",
    "inv.lbl_company": "公司名称 *",
    "inv.lbl_contact_cpf": "联系人身份证",
    "inv.lbl_contact_name": "联系人姓名",
    "inv.lbl_email": "企业邮箱 *",
    "inv.lbl_role": "职位 / 职能",
    "inv.ph_company": "公司名称",
    "inv.ph_email": "contact@company.com",
    "inv.ph_name": "全名",
    "inv.ph_role": "例如：首席财务官",
    "inv.resend": "重新发送",
    "inv.searching": "搜索数据...",
    "inv.submit_btn": "📨 发送邀请",
    "inv.submitting": "提交中...",
    "inv.th_actions": "操作",
    "inv.th_cnpj": "税号",
    "inv.th_company": "公司",
    "inv.th_contact": "联系人",
    "inv.th_email": "邮箱",
    "inv.th_expires": "到期",
    "inv.th_status": "状态",
    "pol.per_unit_sub": "为每个子公司定义个别政策",
    "pol.quarterly": "季度（每3个月）",
    "pol.rule_sub": "定义债务人更新财务数据以续期信贷的频率",
    "pol.semiannual": "半年（每6个月）",
    "pol.saving": "保存中...",

    // ── 客户门户 (cp.*) ──
    "cp.portal_title": "客户门户",
    "cp.credit_history": "我的信用历史",
    "cp.logout": "退出",
    "cp.new_application": "+ 新申请",
    "cp.portfolio_stats": "投资组合统计",
    "cp.credit_requests": "信贷申请",
    "cp.support": "技术支持",
    "cp.loading": "加载中...",
    "cp.no_applications": "暂无申请",
    "cp.no_applications_hint": "点击\"+ 新申请\"开始",
    "cp.applications_count": "项申请",
    "cp.limit_evolution": "限额变化",
    "cp.most_recent": "最新",
    "cp.waiting_cs": "等待商务部门填写 (CS)",
    "cp.in_analysis_treasury": "财务部审核中",
    "cp.credit_letter": "信用证",
    "cp.current_limit": "当前限额",
    "cp.limit_label": "限额",
    "cp.status_approved": "已批准",
    "cp.status_conditional": "有条件批准",
    "cp.status_rejected": "已拒绝",
    "cp.status_in_analysis": "审核中",
    "cp.status_waiting": "等待中",
    "cp.status_pending_board": "待董事会",
    "cp.status_pending_docs": "待文件",

    // ── 文件 (doc.*) ──
    "doc.section_title": "文件",
    "doc.validation_intro": "文件在继续之前由AI自动验证。标有*的项目为必填项。",
    "doc.validation_hint": "上传所有文件后，点击验证文件，AI将确认其正确性并与您的公司相关。",
    "doc.required_note": "* 必填。不清晰的文件将由财务部人工验证。",
    "doc.upload": "上传",
    "doc.multiple_files": "可上传多个文件",
    "doc.validate_ai": "用AI验证文件",
    "doc.back": "返回",
    "doc.contract_amendments": "公司章程 + 修正案",
    "doc.contract_amendments_desc": "上传原始合同及所有修正案。可上传多个文件。",
    "doc.meeting_minutes": "会议纪要 / 董事会决议",
    "doc.meeting_minutes_desc": "合伙人或董事会会议纪要及相关决议。",
    "doc.balance_sheet_dre": "资产负债表 + 利润表",
    "doc.balance_sheet_dre_desc": "每年一个文件或全部合并。接受PDF和图片。",
    "doc.trial_balance": "试算平衡表（补充）",
    "doc.trial_balance_desc": "适用于未完成结算或半年更新的期间。",
    "doc.sped_accounting": "电子会计账簿",
    "doc.sped_accounting_desc": "由会计系统生成的电子账簿文件。",
    "doc.cnd_federal": "联邦税务合规证明",
    "doc.cnd_federal_desc": "有效期30天的证明。过期将影响评分。",
    "doc.cnd_inss": "社会保险合规证明",
    "doc.cnd_inss_desc": "社会保险合规证书。",
    "doc.crf_fgts": "住房基金合规证明",
    "doc.crf_fgts_desc": "住房基金合规证书。",
    "doc.cndt_labor": "劳动合规证明",
    "doc.cndt_labor_desc": "劳动债务无欠款证明。",
    "doc.audit_report": "独立审计报告",
    "doc.audit_report_desc": "由注册审计师签署的报告。",
    "doc.esg_report": "可持续发展 / ESG报告",
    "doc.esg_report_desc": "GRI、SASB、综合报告或类似文件。",
    "doc.id_owners": "管理合伙人身份证件",
    "doc.id_owners_desc": "每位管理合伙人的身份证件。",
    "doc.bylaws": "公司章程",
    "doc.bylaws_desc": "合并后的公司章程。",
    "doc.board_election": "董事选举纪要 / 股东大会",
    "doc.board_election_desc": "选举现任董事会的股东大会纪要。",
    "doc.balance_audited": "经审计的资产负债表 + 利润表",
    "doc.balance_audited_desc": "由独立审计机构审计的财务报表。",
    "doc.trial_balance_sa": "试算平衡表（补充）",
    "doc.trial_balance_sa_desc": "中期试算平衡表供补充分析。",
    "doc.sped_sa": "电子会计账簿 / ECD",
    "doc.sped_sa_desc": "由会计系统生成的电子账簿文件。",
    "doc.id_directors": "董事身份证件",
    "doc.id_directors_desc": "每位董事的身份证件。",
    "doc.mei_certificate": "个体微型企业证书",
    "doc.mei_certificate_desc": "个体微型企业身份证明。",
    "doc.dasn_simei": "年度简易申报",
    "doc.dasn_simei_desc": "简易国民年度申报。",
    "doc.id_holder": "持有人身份证件",
    "doc.id_holder_desc": "个体微型企业持有人的身份证件。",

    // ── AI文件验证 ──
    "doc.ai_analyzing": "Mia正在分析文件...",
    "doc.ai_checking": "验证真实性和公司匹配",
    "doc.ai_all_valid": "所有文件验证成功",
    "doc.ai_next_financial": "下一步：财务数据 →",
    "doc.ai_warnings": "文件已接受但有注意事项",
    "doc.ai_replace": "替换文件",
    "doc.ai_proceed": "仍然继续 →",
    "doc.ai_problems": "文件中发现问题",
    "doc.ai_company_mismatch": "公司不匹配",
    "doc.ai_ignore_proceed": "忽略并继续 →",
    "doc.no_previous": "无先前记录，将被要求提供",
    "doc.ai_timeout": "超时 — 由财务部人工验证。",
    "doc.ai_fallback": "无法验证 — 继续进行。",
    "doc.ai_manual_required": "需要人工验证",
    "doc.ai_manual_required_desc": "AI无法验证任何文件。文件将转交给财务部进行人工验证。",
    "doc.ai_proceed_manual": "继续 — 由财务部人工验证 →",
    "doc.ai_manual_partial": "部分验证 — 部分文件需要人工审核",
    "doc.ai_manual_partial_desc": "部分文件已通过AI验证，但其他文件无法分析，将转交人工验证。",
    "doc.ai_proceed_partial": "继续 — 待处理项将由人工验证 →",
    "form.quarter_partial_data": "{year}年：仅填写已结束的{quarters}数据。",
    "doc.upload_first": "请在验证前至少上传一个文件。"
  },
};

// ─── Core i18n Functions ─────────────────────────────────────────────

/**
 * Traduz uma chave para o idioma atual
 * @param {string} key - Chave de tradução (ex: "auth.login")
 * @param {object} params - Parâmetros de interpolação (ex: { year: 2026 })
 * @returns {string}
 */
export function t(key, params = {}) {
  const dict = dictionaries[currentLocale] || dictionaries[DEFAULT_LOCALE];
  let text = dict[key] || dictionaries[DEFAULT_LOCALE][key] || key;

  // Interpolação: substitui {param} por valor
  Object.entries(params).forEach(([k, v]) => {
    text = text.replace(new RegExp(`\\{${k}\\}`, "g"), String(v));
  });

  return text;
}

/**
 * Define o idioma atual
 */
export function setLocale(locale) {
  if (SUPPORTED_LOCALES.includes(locale)) {
    currentLocale = locale;
    if (typeof window !== "undefined") {
      localStorage.setItem("fm_locale", locale);
      document.documentElement.lang = locale;
    }
  }
}

/**
 * Retorna o idioma atual
 */
export function getLocale() {
  return currentLocale;
}

/**
 * Detecta o idioma preferido do navegador ou localStorage
 */
export function detectLocale() {
  if (typeof window !== "undefined") {
    // 1. Prioridade: localStorage (escolha do usuário)
    const saved = localStorage.getItem("fm_locale");
    if (saved && SUPPORTED_LOCALES.includes(saved)) return saved;

    // 2. URL param: ?lang=en-US
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get("lang");
    if (urlLang && SUPPORTED_LOCALES.includes(urlLang)) return urlLang;

    // 3. Navigator language
    const navLang = navigator.language || navigator.userLanguage;
    // Match exact or by prefix
    const exact = SUPPORTED_LOCALES.find(l => l === navLang);
    if (exact) return exact;
    const prefix = SUPPORTED_LOCALES.find(l => l.startsWith(navLang.slice(0, 2)));
    if (prefix) return prefix;
  }
  return DEFAULT_LOCALE;
}

/**
 * Inicializa o i18n (chamar no boot do app)
 */
export function initI18n() {
  const locale = detectLocale();
  setLocale(locale);
  return locale;
}

/**
 * Retorna todos os locales suportados (para o seletor de idioma)
 */
export function getSupportedLocales() {
  return [
    { code: "pt-BR", label: "Português", flag: "🇧🇷", short: "PT" },
    { code: "en-US", label: "English",   flag: "🇺🇸", short: "EN" },
    { code: "es-MX", label: "Español",   flag: "🇲🇽", short: "ES" },
    { code: "zh-CN", label: "中文",       flag: "🇨🇳", short: "ZH" },
  ];
}

// ─── React Hook (para componentes React) ─────────────────────────────
// Uso: const { t, locale, setLocale } = useI18n()
export function createI18nHook(React) {
  const { useState, useCallback, useEffect } = React;

  return function useI18n() {
    const [locale, _setLocale] = useState(currentLocale);

    const changeLocale = useCallback((newLocale) => {
      setLocale(newLocale);
      _setLocale(newLocale);
    }, []);

    // Sync with external changes
    useEffect(() => {
      const handler = () => _setLocale(getLocale());
      window.addEventListener("fm-locale-change", handler);
      return () => window.removeEventListener("fm-locale-change", handler);
    }, []);

    return {
      t: (key, params) => t(key, params),
      locale,
      setLocale: changeLocale,
      locales: getSupportedLocales(),
    };
  };
}

export default { t, setLocale, getLocale, initI18n, detectLocale, getSupportedLocales, createI18nHook };
